var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "0 0 1200 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 88.507,
    x2: 1222.182,
    y1: -3.811,
    y2: 891.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#ff88c2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    style: {
      stopColor: "#ff983d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    style: {
      stopColor: "#f38d44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    style: {
      stopColor: "#d27158"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    style: {
      stopColor: "#9e4379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#610d9e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1200v800H0z",
    style: {
      fill: "url(#a)"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 0h1200v800H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#c)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 2428.706,
    x2: 2428.706,
    y1: 34.979,
    y2: -176.756,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e64900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd358"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1087.737,
    cy: -80.272,
    r: 105.867,
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 2427.128,
    x2: 2427.128,
    y1: 31.319,
    y2: -180.59,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e64900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e64a00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd358"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1084.071,
    cy: -82.071,
    r: 105.954,
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 2425.263,
    x2: 2425.263,
    y1: 27.843,
    y2: -184.239,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e64900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e64a00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd358"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1080.31,
    cy: -83.542,
    r: 106.041,
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 2423.131,
    x2: 2423.131,
    y1: 24.558,
    y2: -187.699,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e54901"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e54a01"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd358"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1076.472,
    cy: -84.693,
    r: 106.128,
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 2420.747,
    x2: 2420.747,
    y1: 21.466,
    y2: -190.964,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e54901"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e54a01"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd358"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1072.573,
    cy: -85.534,
    r: 106.215,
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 2418.132,
    x2: 2418.132,
    y1: 18.575,
    y2: -194.029,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e54901"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e54a01"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd259"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1068.631,
    cy: -86.071,
    r: 106.301,
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 2415.303,
    x2: 2415.303,
    y1: 15.887,
    y2: -196.89,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e54901"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e54a01"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd259"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1064.662,
    cy: -86.314,
    r: 106.388,
    style: {
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 2412.278,
    x2: 2412.278,
    y1: 13.41,
    y2: -199.541,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e54901"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e54a01"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd259"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1060.684,
    cy: -86.27,
    r: 106.475,
    style: {
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 2409.075,
    x2: 2409.075,
    y1: 11.147,
    y2: -201.977,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e44901"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e44a01"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd259"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1056.712,
    cy: -85.947,
    r: 106.562,
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 2405.712,
    x2: 2405.712,
    y1: 9.104,
    y2: -204.194,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e44802"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e44902"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd259"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1052.765,
    cy: -85.354,
    r: 106.649,
    style: {
      fill: "url(#m)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 2402.208,
    x2: 2402.208,
    y1: 7.285,
    y2: -206.187,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e44802"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e44902"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd259"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1048.859,
    cy: -84.499,
    r: 106.735,
    style: {
      fill: "url(#n)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 2398.58,
    x2: 2398.58,
    y1: 5.696,
    y2: -207.95,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e44802"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e44902"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd259"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1045.012,
    cy: -83.389,
    r: 106.822,
    style: {
      fill: "url(#o)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 2394.847,
    x2: 2394.847,
    y1: 4.341,
    y2: -209.478,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e44802"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e44902"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd259"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1041.239,
    cy: -82.034,
    r: 106.909,
    style: {
      fill: "url(#p)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 2391.027,
    x2: 2391.027,
    y1: 3.226,
    y2: -210.766,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e34802"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e34902"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd259"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1037.558,
    cy: -80.441,
    r: 106.996,
    style: {
      fill: "url(#q)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 2387.137,
    x2: 2387.137,
    y1: 2.356,
    y2: -211.81,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e34802"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e34902"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd15a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1033.986,
    cy: -78.618,
    r: 107.083,
    style: {
      fill: "url(#r)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 2383.197,
    x2: 2383.197,
    y1: 1.735,
    y2: -212.605,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e34803"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e34903"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd15a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1030.539,
    cy: -76.574,
    r: 107.169,
    style: {
      fill: "url(#s)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 2379.223,
    x2: 2379.223,
    y1: 1.369,
    y2: -213.144,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e34803"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e34903"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd15a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1027.236,
    cy: -74.316,
    r: 107.256,
    style: {
      fill: "url(#t)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 2375.235,
    x2: 2375.235,
    y1: 1.262,
    y2: -213.425,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e24803"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e24903"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd15a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1024.092,
    cy: -71.853,
    r: 107.343,
    style: {
      fill: "url(#u)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 2371.251,
    x2: 2371.251,
    y1: 1.421,
    y2: -213.44,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e24803"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e24903"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd15a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1021.124,
    cy: -69.193,
    r: 107.43,
    style: {
      fill: "url(#v)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 2367.287,
    x2: 2367.287,
    y1: 1.848,
    y2: -213.186,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e24803"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e24903"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd15a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1018.35,
    cy: -66.344,
    r: 107.517,
    style: {
      fill: "url(#w)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 2363.363,
    x2: 2363.363,
    y1: 2.55,
    y2: -212.657,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e24804"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e24904"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd15a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1015.787,
    cy: -63.314,
    r: 107.604,
    style: {
      fill: "url(#x)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 2359.497,
    x2: 2359.497,
    y1: 3.532,
    y2: -211.849,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e24804"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e24904"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd15a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1013.451,
    cy: -60.112,
    r: 107.69,
    style: {
      fill: "url(#y)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 2355.706,
    x2: 2355.706,
    y1: 4.799,
    y2: -210.756,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e14804"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e14904"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd15a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1011.359,
    cy: -56.745,
    r: 107.777,
    style: {
      fill: "url(#z)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 2352.01,
    x2: 2352.01,
    y1: 6.355,
    y2: -209.374,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e14804"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e14904"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd15b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1009.528,
    cy: -53.222,
    r: 107.864,
    style: {
      fill: "url(#A)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 2348.425,
    x2: 2348.425,
    y1: 8.206,
    y2: -207.697,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e14804"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e14904"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd05b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1007.975,
    cy: -49.551,
    r: 107.951,
    style: {
      fill: "url(#B)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 2344.97,
    x2: 2344.97,
    y1: 10.356,
    y2: -205.72,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e14804"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e14904"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd05b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1006.718,
    cy: -45.739,
    r: 108.038,
    style: {
      fill: "url(#C)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 2341.667,
    x2: 2341.667,
    y1: 12.809,
    y2: -203.441,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e14805"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e14905"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd05b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1005.773,
    cy: -41.799,
    r: 108.124,
    style: {
      fill: "url(#D)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 2338.595,
    x2: 2338.595,
    y1: 15.454,
    y2: -200.97,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e04705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e04805"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd05b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1005.128,
    cy: -37.867,
    r: 108.211,
    style: {
      fill: "url(#E)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 2335.698,
    x2: 2335.698,
    y1: 18.27,
    y2: -198.327,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e04705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e04805"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd05b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.729,
    cy: -33.921,
    r: 108.298,
    style: {
      fill: "url(#F)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 2332.971,
    x2: 2332.971,
    y1: 21.247,
    y2: -195.524,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e04705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e04805"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd05b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.563,
    cy: -29.967,
    r: 108.385,
    style: {
      fill: "url(#G)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 2330.41,
    x2: 2330.41,
    y1: 24.371,
    y2: -192.573,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e04705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e04805"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd05b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.619,
    cy: -26.009,
    r: 108.472,
    style: {
      fill: "url(#H)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 2328.008,
    x2: 2328.008,
    y1: 27.632,
    y2: -189.486,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e04705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e04805"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd05b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.886,
    cy: -22.055,
    r: 108.559,
    style: {
      fill: "url(#I)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 2325.762,
    x2: 2325.762,
    y1: 31.018,
    y2: -186.274,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#df4706"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#df4806"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd05c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1005.351,
    cy: -18.108,
    r: 108.645,
    style: {
      fill: "url(#J)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 2323.666,
    x2: 2323.666,
    y1: 34.516,
    y2: -182.949,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#df4706"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#df4806"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcf5c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1006.003,
    cy: -14.175,
    r: 108.732,
    style: {
      fill: "url(#K)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 2321.714,
    x2: 2321.714,
    y1: 38.115,
    y2: -179.523,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#df4706"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#df4806"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcf5c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1006.83,
    cy: -10.261,
    r: 108.819,
    style: {
      fill: "url(#L)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 2319.901,
    x2: 2319.901,
    y1: 41.804,
    y2: -176.009,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#df4706"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#df4806"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcf5c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1007.82,
    cy: -6.373,
    r: 108.906,
    style: {
      fill: "url(#M)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 2318.223,
    x2: 2318.223,
    y1: 45.569,
    y2: -172.417,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#df4706"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#df4806"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcf5c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1008.963,
    cy: -2.514,
    r: 108.993,
    style: {
      fill: "url(#N)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 2316.674,
    x2: 2316.674,
    y1: 49.399,
    y2: -168.761,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#de4707"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#de4807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcf5c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1010.245,
    cy: 1.309,
    r: 109.079,
    style: {
      fill: "url(#O)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 2315.249,
    x2: 2315.249,
    y1: 53.283,
    y2: -165.05,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#de4707"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#de4807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcf5c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1011.656,
    cy: 5.09,
    r: 109.166,
    style: {
      fill: "url(#P)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 2313.942,
    x2: 2313.942,
    y1: 57.208,
    y2: -161.299,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#de4707"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#de4807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcf5c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1013.184,
    cy: 8.825,
    r: 109.253,
    style: {
      fill: "url(#Q)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 2312.749,
    x2: 2312.749,
    y1: 61.163,
    y2: -157.517,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#de4707"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#de4807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcf5d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1014.816,
    cy: 12.507,
    r: 109.34,
    style: {
      fill: "url(#R)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 2311.665,
    x2: 2311.665,
    y1: 65.136,
    y2: -153.718,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dd4707"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#dd4807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcf5d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1016.543,
    cy: 16.131,
    r: 109.427,
    style: {
      fill: "url(#S)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 2310.68,
    x2: 2310.68,
    y1: 69.118,
    y2: -149.91,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dd4707"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#dd4807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffce5d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1018.349,
    cy: 19.696,
    r: 109.514,
    style: {
      fill: "url(#T)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 2309.781,
    x2: 2309.781,
    y1: 73.11,
    y2: -146.091,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dd4708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#dd4808"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffce5d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1020.228,
    cy: 23.213,
    r: 109.6,
    style: {
      fill: "url(#U)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 2308.964,
    x2: 2308.964,
    y1: 77.114,
    y2: -142.261,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dd4708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#dd4708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffce5d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1022.176,
    cy: 26.684,
    r: 109.687,
    style: {
      fill: "url(#V)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 2308.226,
    x2: 2308.226,
    y1: 81.129,
    y2: -138.42,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dd4608"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#dd4708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffce5d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1024.19,
    cy: 30.112,
    r: 109.774,
    style: {
      fill: "url(#W)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 2307.564,
    x2: 2307.564,
    y1: 85.154,
    y2: -134.569,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dc4608"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#dc4708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffce5d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1026.269,
    cy: 33.497,
    r: 109.861,
    style: {
      fill: "url(#X)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 2306.975,
    x2: 2306.975,
    y1: 89.189,
    y2: -130.707,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dc4608"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#dc4708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffce5d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.409,
    cy: 36.842,
    r: 109.948,
    style: {
      fill: "url(#Y)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 2306.456,
    x2: 2306.456,
    y1: 93.233,
    y2: -126.836,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dc4608"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#dc4708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffce5d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1030.608,
    cy: 40.149,
    r: 110.034,
    style: {
      fill: "url(#Z)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 2306.003,
    x2: 2306.003,
    y1: 97.287,
    y2: -122.956,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dc4609"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#dc4709"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffce5e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1032.862,
    cy: 43.418,
    r: 110.121,
    style: {
      fill: "url(#aa)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 2305.613,
    x2: 2305.613,
    y1: 101.349,
    y2: -119.068,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dc4609"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#dc4709"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffce5e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.17,
    cy: 46.653,
    r: 110.208,
    style: {
      fill: "url(#ab)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 2305.283,
    x2: 2305.283,
    y1: 105.42,
    y2: -115.171,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#db4609"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#db4709"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffce5e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1037.528,
    cy: 49.854,
    r: 110.295,
    style: {
      fill: "url(#ac)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 2305.01,
    x2: 2305.01,
    y1: 109.498,
    y2: -111.266,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#db4609"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#db4709"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcd5e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1039.935,
    cy: 53.023,
    r: 110.382,
    style: {
      fill: "url(#ad)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 2304.792,
    x2: 2304.792,
    y1: 113.584,
    y2: -107.354,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#db4609"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#db4709"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcd5e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1042.387,
    cy: 56.162,
    r: 110.468,
    style: {
      fill: "url(#ae)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 2304.624,
    x2: 2304.624,
    y1: 117.676,
    y2: -103.435,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#db460a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#db470a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcd5e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1044.882,
    cy: 59.273,
    r: 110.555,
    style: {
      fill: "url(#af)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 2304.503,
    x2: 2304.503,
    y1: 121.775,
    y2: -99.51,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#db460a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#db470a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcd5e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1047.416,
    cy: 62.358,
    r: 110.642,
    style: {
      fill: "url(#ag)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 2304.427,
    x2: 2304.427,
    y1: 125.88,
    y2: -95.579,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#da460a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#da470a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcd5e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1049.988,
    cy: 65.418,
    r: 110.729,
    style: {
      fill: "url(#ah)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 2304.392,
    x2: 2304.392,
    y1: 129.99,
    y2: -91.642,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#da460a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#da470a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcd5e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1052.595,
    cy: 68.455,
    r: 110.816,
    style: {
      fill: "url(#ai)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 2304.396,
    x2: 2304.396,
    y1: 134.106,
    y2: -87.7,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#da460a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#da470a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcd5f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1055.234,
    cy: 71.47,
    r: 110.903,
    style: {
      fill: "url(#aj)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 2304.434,
    x2: 2304.434,
    y1: 138.226,
    y2: -83.753,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#da460a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#da470a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcd5f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1057.902,
    cy: 74.467,
    r: 110.989,
    style: {
      fill: "url(#ak)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 2304.504,
    x2: 2304.504,
    y1: 142.351,
    y2: -79.802,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#da460b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#da470b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcd5f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1060.597,
    cy: 77.445,
    r: 111.076,
    style: {
      fill: "url(#al)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 2304.602,
    x2: 2304.602,
    y1: 146.479,
    y2: -75.848,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d9460b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d9460b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcc5f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1063.316,
    cy: 80.407,
    r: 111.163,
    style: {
      fill: "url(#am)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 2304.727,
    x2: 2304.727,
    y1: 150.611,
    y2: -71.89,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d9460b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d9460b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcc5f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1066.057,
    cy: 83.355,
    r: 111.25,
    style: {
      fill: "url(#an)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 2304.874,
    x2: 2304.874,
    y1: 154.746,
    y2: -67.929,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d9450b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d9460b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcc5f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1068.816,
    cy: 86.291,
    r: 111.337,
    style: {
      fill: "url(#ao)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 2305.04,
    x2: 2305.04,
    y1: 158.883,
    y2: -63.965,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d9450b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d9460b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcc5f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1071.591,
    cy: 89.216,
    r: 111.423,
    style: {
      fill: "url(#ap)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 2305.221,
    x2: 2305.221,
    y1: 163.022,
    y2: -60,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d8450b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d8460b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcc5f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1074.38,
    cy: 92.131,
    r: 111.51,
    style: {
      fill: "url(#aq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 2305.416,
    x2: 2305.416,
    y1: 167.163,
    y2: -56.032,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d8450c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d8460c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcc5f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1077.179,
    cy: 95.04,
    r: 111.597,
    style: {
      fill: "url(#ar)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 2305.621,
    x2: 2305.621,
    y1: 171.304,
    y2: -52.064,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d8450c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d8460c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcc60"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1079.987,
    cy: 97.942,
    r: 111.684,
    style: {
      fill: "url(#as)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 2305.833,
    x2: 2305.833,
    y1: 175.447,
    y2: -48.095,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d8450c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d8460c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcc60"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1082.8,
    cy: 100.841,
    r: 111.771,
    style: {
      fill: "url(#at)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 2306.048,
    x2: 2306.048,
    y1: 179.59,
    y2: -44.126,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d8450c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d8460c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcc60"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1085.616,
    cy: 103.738,
    r: 111.858,
    style: {
      fill: "url(#au)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 2306.263,
    x2: 2306.263,
    y1: 183.733,
    y2: -40.157,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7450c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d7460c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcb60"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1088.432,
    cy: 106.634,
    r: 111.944,
    style: {
      fill: "url(#av)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 2306.476,
    x2: 2306.476,
    y1: 187.875,
    y2: -36.188,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7450d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d7460d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcb60"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1091.246,
    cy: 109.532,
    r: 112.031,
    style: {
      fill: "url(#aw)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 2306.682,
    x2: 2306.682,
    y1: 192.016,
    y2: -32.221,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7450d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d7460d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcb60"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1094.054,
    cy: 112.433,
    r: 112.118,
    style: {
      fill: "url(#ax)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 2306.88,
    x2: 2306.88,
    y1: 196.156,
    y2: -28.255,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7450d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d7460d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcb60"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1096.855,
    cy: 115.338,
    r: 112.205,
    style: {
      fill: "url(#ay)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 2307.065,
    x2: 2307.065,
    y1: 200.293,
    y2: -24.291,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7450d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d7460d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcb60"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.645,
    cy: 118.25,
    r: 112.292,
    style: {
      fill: "url(#az)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 2307.235,
    x2: 2307.235,
    y1: 204.429,
    y2: -20.329,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d6450d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d6460d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcb60"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1102.422,
    cy: 121.171,
    r: 112.378,
    style: {
      fill: "url(#aA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 2307.386,
    x2: 2307.386,
    y1: 208.561,
    y2: -16.37,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d6450d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d6460d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcb61"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1105.183,
    cy: 124.102,
    r: 112.465,
    style: {
      fill: "url(#aB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 2307.516,
    x2: 2307.516,
    y1: 212.691,
    y2: -12.414,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d6450e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d6460e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcb61"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1107.926,
    cy: 127.044,
    r: 112.552,
    style: {
      fill: "url(#aC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 2307.621,
    x2: 2307.621,
    y1: 216.816,
    y2: -8.462,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d6450e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d6460e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcb61"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1110.647,
    cy: 130,
    r: 112.639,
    style: {
      fill: "url(#aD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 2307.698,
    x2: 2307.698,
    y1: 220.938,
    y2: -4.514,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d6450e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d6450e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffcb61"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1113.345,
    cy: 132.971,
    r: 112.726,
    style: {
      fill: "url(#aE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 2307.744,
    x2: 2307.744,
    y1: 225.055,
    y2: -0.571,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d5440e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d5450e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffca61"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1116.016,
    cy: 135.959,
    r: 112.813,
    style: {
      fill: "url(#aF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 2307.755,
    x2: 2307.755,
    y1: 229.167,
    y2: 3.367,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d5440e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d5450e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffca61"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1118.659,
    cy: 138.966,
    r: 112.899,
    style: {
      fill: "url(#aG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 2307.729,
    x2: 2307.729,
    y1: 233.273,
    y2: 7.3,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d5440e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d5450e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffca61"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1121.269,
    cy: 141.993,
    r: 112.986,
    style: {
      fill: "url(#aH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 2307.663,
    x2: 2307.663,
    y1: 237.374,
    y2: 11.227,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d5440f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d5450f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffca61"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1123.845,
    cy: 145.043,
    r: 113.073,
    style: {
      fill: "url(#aI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 2307.553,
    x2: 2307.553,
    y1: 241.468,
    y2: 15.148,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d5440f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d5450f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffca61"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1126.384,
    cy: 148.117,
    r: 113.16,
    style: {
      fill: "url(#aJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 2307.396,
    x2: 2307.396,
    y1: 245.556,
    y2: 19.062,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d4440f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d4450f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffca62"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1128.883,
    cy: 151.216,
    r: 113.247,
    style: {
      fill: "url(#aK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 2307.189,
    x2: 2307.189,
    y1: 249.636,
    y2: 22.968,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d4440f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d4450f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffca62"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1131.34,
    cy: 154.343,
    r: 113.333,
    style: {
      fill: "url(#aL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 2306.929,
    x2: 2306.929,
    y1: 253.709,
    y2: 26.868,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d4440f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d4450f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffca62"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1133.751,
    cy: 157.499,
    r: 113.42,
    style: {
      fill: "url(#aM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 2306.613,
    x2: 2306.613,
    y1: 257.774,
    y2: 30.759,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d44410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d44510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffca62"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1136.115,
    cy: 160.685,
    r: 113.507,
    style: {
      fill: "url(#aN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 2306.237,
    x2: 2306.237,
    y1: 261.83,
    y2: 34.641,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d34410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d34510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc962"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1138.429,
    cy: 163.905,
    r: 113.594,
    style: {
      fill: "url(#aO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 2305.799,
    x2: 2305.799,
    y1: 265.877,
    y2: 38.515,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d34410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d34510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc962"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1140.69,
    cy: 167.159,
    r: 113.681,
    style: {
      fill: "url(#aP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 2305.295,
    x2: 2305.295,
    y1: 269.915,
    y2: 42.379,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d34410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d34510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc962"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1142.894,
    cy: 170.449,
    r: 113.767,
    style: {
      fill: "url(#aQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 2304.722,
    x2: 2304.722,
    y1: 273.943,
    y2: 46.233,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d34410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d34510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc962"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1145.041,
    cy: 173.777,
    r: 113.854,
    style: {
      fill: "url(#aR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 2304.077,
    x2: 2304.077,
    y1: 277.96,
    y2: 50.077,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d34410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d34510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc962"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1147.126,
    cy: 177.144,
    r: 113.941,
    style: {
      fill: "url(#aS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 2303.357,
    x2: 2303.357,
    y1: 281.967,
    y2: 53.91,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d24411"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d24511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc963"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1149.148,
    cy: 180.553,
    r: 114.028,
    style: {
      fill: "url(#aT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 2302.558,
    x2: 2302.558,
    y1: 285.963,
    y2: 57.733,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d24411"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d24511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc963"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1151.104,
    cy: 184.005,
    r: 114.115,
    style: {
      fill: "url(#aU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 2301.678,
    x2: 2301.678,
    y1: 289.947,
    y2: 61.543,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d24411"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d24411"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc963"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1152.99,
    cy: 187.502,
    r: 114.202,
    style: {
      fill: "url(#aV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 2300.714,
    x2: 2300.714,
    y1: 293.919,
    y2: 65.342,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d24411"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d24411"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc963"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1154.805,
    cy: 191.045,
    r: 114.288,
    style: {
      fill: "url(#aW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 2299.662,
    x2: 2299.662,
    y1: 297.879,
    y2: 69.128,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d24311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d24411"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc863"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1156.545,
    cy: 194.637,
    r: 114.375,
    style: {
      fill: "url(#aX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 2298.469,
    x2: 2298.469,
    y1: 301.847,
    y2: 72.922,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d14311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d14411"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc863"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1158.186,
    cy: 198.328,
    r: 114.462,
    style: {
      fill: "url(#aY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 2297.073,
    x2: 2297.073,
    y1: 305.807,
    y2: 76.708,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d14312"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d14412"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc863"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1159.667,
    cy: 202.145,
    r: 114.549,
    style: {
      fill: "url(#aZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 2295.48,
    x2: 2295.48,
    y1: 309.731,
    y2: 80.458,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d14312"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d14412"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc863"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.976,
    cy: 206.066,
    r: 114.636,
    style: {
      fill: "url(#ba)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 2293.698,
    x2: 2293.698,
    y1: 313.594,
    y2: 84.148,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d14312"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d14412"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc863"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.104,
    cy: 210.064,
    r: 114.722,
    style: {
      fill: "url(#bb)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 2291.737,
    x2: 2291.737,
    y1: 317.372,
    y2: 87.752,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d14312"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d14412"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc864"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1163.04,
    cy: 214.118,
    r: 114.809,
    style: {
      fill: "url(#bc)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 2289.602,
    x2: 2289.602,
    y1: 321.04,
    y2: 91.247,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d04312"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d04412"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc864"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1163.773,
    cy: 218.202,
    r: 114.896,
    style: {
      fill: "url(#bd)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 2287.302,
    x2: 2287.302,
    y1: 324.574,
    y2: 94.607,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d04313"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d04413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc864"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1164.294,
    cy: 222.294,
    r: 114.983,
    style: {
      fill: "url(#be)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 2284.845,
    x2: 2284.845,
    y1: 327.949,
    y2: 97.808,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d04313"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d04413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc864"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1164.592,
    cy: 226.369,
    r: 115.07,
    style: {
      fill: "url(#bf)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 2282.239,
    x2: 2282.239,
    y1: 331.14,
    y2: 100.826,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d04313"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d04413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc864"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1164.656,
    cy: 230.403,
    r: 115.157,
    style: {
      fill: "url(#bg)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 2279.492,
    x2: 2279.492,
    y1: 334.122,
    y2: 103.635,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d04313"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#d04413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc764"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1164.477,
    cy: 234.374,
    r: 115.243,
    style: {
      fill: "url(#bh)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 2276.611,
    x2: 2276.611,
    y1: 336.872,
    y2: 106.21,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cf4313"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cf4413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc764"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1164.044,
    cy: 238.257,
    r: 115.33,
    style: {
      fill: "url(#bi)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 2273.605,
    x2: 2273.605,
    y1: 339.363,
    y2: 108.528,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cf4313"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cf4413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc764"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1163.347,
    cy: 242.028,
    r: 115.417,
    style: {
      fill: "url(#bj)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 2270.481,
    x2: 2270.481,
    y1: 341.572,
    y2: 110.563,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cf4314"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cf4414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc765"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.375,
    cy: 245.664,
    r: 115.504,
    style: {
      fill: "url(#bk)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 2267.248,
    x2: 2267.248,
    y1: 343.473,
    y2: 112.291,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cf4314"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cf4414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc765"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1161.119,
    cy: 249.14,
    r: 115.591,
    style: {
      fill: "url(#bl)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 2263.912,
    x2: 2263.912,
    y1: 345.043,
    y2: 113.687,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ce4314"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ce4414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc765"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1159.567,
    cy: 252.434,
    r: 115.677,
    style: {
      fill: "url(#bm)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 2260.483,
    x2: 2260.483,
    y1: 346.256,
    y2: 114.727,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ce4314"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ce4314"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc765"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1157.71,
    cy: 255.521,
    r: 115.764,
    style: {
      fill: "url(#bn)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 2256.967,
    x2: 2256.967,
    y1: 347.088,
    y2: 115.385,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ce4314"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ce4314"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc765"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1155.537,
    cy: 258.377,
    r: 115.851,
    style: {
      fill: "url(#bo)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 2253.373,
    x2: 2253.373,
    y1: 347.514,
    y2: 115.637,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ce4214"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ce4314"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc765"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1153.038,
    cy: 260.979,
    r: 115.938,
    style: {
      fill: "url(#bp)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 2249.709,
    x2: 2249.709,
    y1: 347.509,
    y2: 115.459,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ce4215"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ce4315"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc665"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1150.202,
    cy: 263.303,
    r: 116.025,
    style: {
      fill: "url(#bq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 2245.982,
    x2: 2245.982,
    y1: 347.049,
    y2: 114.825,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cd4215"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cd4315"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc665"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1147.02,
    cy: 265.326,
    r: 116.112,
    style: {
      fill: "url(#br)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 2242.2,
    x2: 2242.2,
    y1: 346.109,
    y2: 113.711,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cd4215"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cd4315"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc665"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1143.481,
    cy: 267.023,
    r: 116.198,
    style: {
      fill: "url(#bs)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 2238.372,
    x2: 2238.372,
    y1: 344.664,
    y2: 112.093,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cd4215"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cd4315"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc666"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1139.575,
    cy: 268.37,
    r: 116.285,
    style: {
      fill: "url(#bt)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: 2234.505,
    x2: 2234.505,
    y1: 342.69,
    y2: 109.945,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cd4215"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cd4315"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc666"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1135.291,
    cy: 269.344,
    r: 116.372,
    style: {
      fill: "url(#bu)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 2230.606,
    x2: 2230.606,
    y1: 340.162,
    y2: 107.243,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cd4216"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cd4316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc666"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.619,
    cy: 269.922,
    r: 116.459,
    style: {
      fill: "url(#bv)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: 2226.927,
    x2: 2226.927,
    y1: 337.269,
    y2: 104.177,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cc4216"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cc4316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc666"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1125.872,
    cy: 270.081,
    r: 116.546,
    style: {
      fill: "url(#bw)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: 2224.035,
    x2: 2224.035,
    y1: 334.637,
    y2: 101.371,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cc4216"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cc4316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc666"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1121.89,
    cy: 269.918,
    r: 116.632,
    style: {
      fill: "url(#bx)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: 2221.333,
    x2: 2221.333,
    y1: 331.84,
    y2: 98.401,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cc4216"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cc4316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc666"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1117.943,
    cy: 269.506,
    r: 116.719,
    style: {
      fill: "url(#by)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 2218.814,
    x2: 2218.814,
    y1: 328.891,
    y2: 95.278,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cc4216"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cc4316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc566"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1114.032,
    cy: 268.86,
    r: 116.806,
    style: {
      fill: "url(#bz)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bA",
    x1: 2216.467,
    x2: 2216.467,
    y1: 325.805,
    y2: 92.018,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cc4216"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cc4316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc566"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1110.162,
    cy: 267.995,
    r: 116.893,
    style: {
      fill: "url(#bA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bB",
    x1: 2214.285,
    x2: 2214.285,
    y1: 322.593,
    y2: 88.633,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cb4217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cb4317"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc566"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1106.333,
    cy: 266.929,
    r: 116.98,
    style: {
      fill: "url(#bB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bC",
    x1: 2212.258,
    x2: 2212.258,
    y1: 319.271,
    y2: 85.137,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cb4217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cb4317"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc567"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1102.548,
    cy: 265.678,
    r: 117.066,
    style: {
      fill: "url(#bC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bD",
    x1: 2210.377,
    x2: 2210.377,
    y1: 315.851,
    y2: 81.544,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cb4217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cb4317"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc567"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1098.809,
    cy: 264.256,
    r: 117.153,
    style: {
      fill: "url(#bD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bE",
    x1: 2208.634,
    x2: 2208.634,
    y1: 312.347,
    y2: 77.866,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cb4217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cb4217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc567"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1095.118,
    cy: 262.681,
    r: 117.24,
    style: {
      fill: "url(#bE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bF",
    x1: 2207.019,
    x2: 2207.019,
    y1: 308.773,
    y2: 74.118,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cb4217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#cb4217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc567"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1091.478,
    cy: 260.968,
    r: 117.327,
    style: {
      fill: "url(#bF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bG",
    x1: 2205.524,
    x2: 2205.524,
    y1: 305.142,
    y2: 70.314,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ca4217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ca4217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc567"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1087.89,
    cy: 259.134,
    r: 117.414,
    style: {
      fill: "url(#bG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bH",
    x1: 2204.14,
    x2: 2204.14,
    y1: 301.468,
    y2: 66.466,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ca4118"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ca4218"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc567"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1084.357,
    cy: 257.194,
    r: 117.501,
    style: {
      fill: "url(#bH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bI",
    x1: 2202.858,
    x2: 2202.858,
    y1: 297.765,
    y2: 62.589,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ca4118"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ca4218"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc567"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1080.882,
    cy: 255.165,
    r: 117.587,
    style: {
      fill: "url(#bI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bJ",
    x1: 2201.668,
    x2: 2201.668,
    y1: 294.045,
    y2: 58.695,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ca4118"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ca4218"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc467"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1077.466,
    cy: 253.063,
    r: 117.674,
    style: {
      fill: "url(#bJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bK",
    x1: 2200.773,
    x2: 2200.773,
    y1: 291.039,
    y2: 55.516,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c94118"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c94218"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc467"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1074.742,
    cy: 251.304,
    r: 117.761,
    style: {
      fill: "url(#bK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bL",
    x1: 2200.02,
    x2: 2200.02,
    y1: 288.238,
    y2: 52.541,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c94118"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c94218"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc468"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1072.258,
    cy: 249.606,
    r: 117.848,
    style: {
      fill: "url(#bL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bM",
    x1: 2199.311,
    x2: 2199.311,
    y1: 285.322,
    y2: 49.452,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c94119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c94219"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc468"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1069.733,
    cy: 247.793,
    r: 117.935,
    style: {
      fill: "url(#bM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bN",
    x1: 2198.643,
    x2: 2198.643,
    y1: 282.295,
    y2: 46.251,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c94119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c94219"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc468"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1067.166,
    cy: 245.869,
    r: 118.021,
    style: {
      fill: "url(#bN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bO",
    x1: 2198.015,
    x2: 2198.015,
    y1: 279.162,
    y2: 42.944,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c94119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c94219"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc468"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1064.558,
    cy: 243.839,
    r: 118.108,
    style: {
      fill: "url(#bO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bP",
    x1: 2197.423,
    x2: 2197.423,
    y1: 275.926,
    y2: 39.535,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c84119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c84219"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc468"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1061.911,
    cy: 241.708,
    r: 118.195,
    style: {
      fill: "url(#bP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bQ",
    x1: 2196.866,
    x2: 2196.866,
    y1: 272.593,
    y2: 36.028,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c84119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c84219"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc468"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1059.225,
    cy: 239.481,
    r: 118.282,
    style: {
      fill: "url(#bQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bR",
    x1: 2196.339,
    x2: 2196.339,
    y1: 269.165,
    y2: 32.427,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c84119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c84219"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc468"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1056.5,
    cy: 237.163,
    r: 118.369,
    style: {
      fill: "url(#bR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bS",
    x1: 2195.842,
    x2: 2195.842,
    y1: 265.648,
    y2: 28.736,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c8411a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c8421a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc368"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1053.739,
    cy: 234.757,
    r: 118.456,
    style: {
      fill: "url(#bS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bT",
    x1: 2195.371,
    x2: 2195.371,
    y1: 262.046,
    y2: 24.96,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c8411a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c8421a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc368"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1050.941,
    cy: 232.27,
    r: 118.542,
    style: {
      fill: "url(#bT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bU",
    x1: 2194.924,
    x2: 2194.924,
    y1: 258.362,
    y2: 21.103,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c7411a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c7421a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc369"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1048.107,
    cy: 229.706,
    r: 118.629,
    style: {
      fill: "url(#bU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bV",
    x1: 2194.498,
    x2: 2194.498,
    y1: 254.601,
    y2: 17.169,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c7411a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c7421a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc369"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1045.239,
    cy: 227.071,
    r: 118.716,
    style: {
      fill: "url(#bV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bW",
    x1: 2194.091,
    x2: 2194.091,
    y1: 250.768,
    y2: 13.161,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c7411a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c7411a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc369"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1042.337,
    cy: 224.367,
    r: 118.803,
    style: {
      fill: "url(#bW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bX",
    x1: 2193.7,
    x2: 2193.7,
    y1: 246.865,
    y2: 9.085,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c7411a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c7411a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc369"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1039.402,
    cy: 221.602,
    r: 118.89,
    style: {
      fill: "url(#bX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bY",
    x1: 2193.323,
    x2: 2193.323,
    y1: 242.899,
    y2: 4.945,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c7401b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c7411b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc369"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1036.435,
    cy: 218.779,
    r: 118.976,
    style: {
      fill: "url(#bY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bZ",
    x1: 2192.956,
    x2: 2192.956,
    y1: 238.871,
    y2: 0.744,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c6401b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c6411b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc369"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1033.436,
    cy: 215.903,
    r: 119.063,
    style: {
      fill: "url(#bZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: 2192.599,
    x2: 2192.599,
    y1: 234.788,
    y2: -3.513,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c6401b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c6411b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc369"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1030.407,
    cy: 212.979,
    r: 119.15,
    style: {
      fill: "url(#ca)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: 2192.247,
    x2: 2192.247,
    y1: 230.653,
    y2: -7.821,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c6401b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c6411b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc269"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1027.349,
    cy: 210.013,
    r: 119.237,
    style: {
      fill: "url(#cb)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 2191.899,
    x2: 2191.899,
    y1: 226.471,
    y2: -12.178,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c6401b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c6411b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc269"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1024.261,
    cy: 207.008,
    r: 119.324,
    style: {
      fill: "url(#cc)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    x1: 2191.552,
    x2: 2191.552,
    y1: 222.244,
    y2: -16.578,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c6401c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c6411c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc26a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1021.146,
    cy: 203.97,
    r: 119.411,
    style: {
      fill: "url(#cd)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: 2191.203,
    x2: 2191.203,
    y1: 217.979,
    y2: -21.017,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c5401c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c5411c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc26a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1018.003,
    cy: 200.903,
    r: 119.497,
    style: {
      fill: "url(#ce)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: 2190.849,
    x2: 2190.849,
    y1: 213.678,
    y2: -25.491,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c5401c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c5411c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc26a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1014.835,
    cy: 197.812,
    r: 119.584,
    style: {
      fill: "url(#cf)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg",
    x1: 2190.49,
    x2: 2190.49,
    y1: 209.347,
    y2: -29.996,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c5401c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c5411c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc26a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1011.64,
    cy: 194.703,
    r: 119.671,
    style: {
      fill: "url(#cg)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ch",
    x1: 2190.12,
    x2: 2190.12,
    y1: 204.989,
    y2: -34.528,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c5401c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c5411c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc26a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1008.422,
    cy: 191.58,
    r: 119.758,
    style: {
      fill: "url(#ch)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci",
    x1: 2189.739,
    x2: 2189.739,
    y1: 200.608,
    y2: -39.082,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c4401c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c4411c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc26a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1005.179,
    cy: 188.447,
    r: 119.845,
    style: {
      fill: "url(#ci)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cj",
    x1: 2189.343,
    x2: 2189.343,
    y1: 196.209,
    y2: -43.654,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c4401d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c4411d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc26a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1001.914,
    cy: 185.311,
    r: 119.931,
    style: {
      fill: "url(#cj)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ck",
    x1: 2188.931,
    x2: 2188.931,
    y1: 191.796,
    y2: -48.241,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c4401d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c4411d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc26a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 998.626,
    cy: 182.175,
    r: 120.018,
    style: {
      fill: "url(#ck)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cl",
    x1: 2188.499,
    x2: 2188.499,
    y1: 187.374,
    y2: -52.837,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c4401d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c4411d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc16a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 995.317,
    cy: 179.044,
    r: 120.105,
    style: {
      fill: "url(#cl)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cm",
    x1: 2188.045,
    x2: 2188.045,
    y1: 182.945,
    y2: -57.44,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c4401d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c4411d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc16b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 991.988,
    cy: 175.923,
    r: 120.192,
    style: {
      fill: "url(#cm)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cn",
    x1: 2187.566,
    x2: 2187.566,
    y1: 178.515,
    y2: -62.043,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c3401d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c3401d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc16b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 988.64,
    cy: 172.818,
    r: 120.279,
    style: {
      fill: "url(#cn)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "co",
    x1: 2187.06,
    x2: 2187.06,
    y1: 174.088,
    y2: -66.644,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c3401d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c3401d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc16b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 985.272,
    cy: 169.732,
    r: 120.365,
    style: {
      fill: "url(#co)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cp",
    x1: 2186.525,
    x2: 2186.525,
    y1: 169.667,
    y2: -71.238,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c3401e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c3401e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc16b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 981.887,
    cy: 166.671,
    r: 120.452,
    style: {
      fill: "url(#cp)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cq",
    x1: 2185.957,
    x2: 2185.957,
    y1: 165.258,
    y2: -75.821,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c33f1e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c3401e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc16b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 978.485,
    cy: 163.639,
    r: 120.539,
    style: {
      fill: "url(#cq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cr",
    x1: 2185.354,
    x2: 2185.354,
    y1: 160.864,
    y2: -80.389,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c33f1e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c3401e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc16b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 975.067,
    cy: 160.642,
    r: 120.626,
    style: {
      fill: "url(#cr)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cs",
    x1: 2184.714,
    x2: 2184.714,
    y1: 156.489,
    y2: -84.937,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c23f1e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c2401e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc16b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 971.633,
    cy: 157.685,
    r: 120.713,
    style: {
      fill: "url(#cs)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ct",
    x1: 2184.034,
    x2: 2184.034,
    y1: 152.138,
    y2: -89.462,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c23f1e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c2401e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc16b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 968.185,
    cy: 154.771,
    r: 120.8,
    style: {
      fill: "url(#ct)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cu",
    x1: 2183.312,
    x2: 2183.312,
    y1: 147.816,
    y2: -93.958,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c23f1f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c2401f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc06b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 964.723,
    cy: 151.906,
    r: 120.886,
    style: {
      fill: "url(#cu)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cv",
    x1: 2182.545,
    x2: 2182.545,
    y1: 143.525,
    y2: -98.423,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c23f1f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c2401f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc06c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 961.248,
    cy: 149.095,
    r: 120.973,
    style: {
      fill: "url(#cv)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cw",
    x1: 2181.73,
    x2: 2181.73,
    y1: 139.27,
    y2: -102.851,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c23f1f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c2401f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc06c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 957.762,
    cy: 146.343,
    r: 121.06,
    style: {
      fill: "url(#cw)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cx",
    x1: 2180.865,
    x2: 2180.865,
    y1: 135.056,
    y2: -107.238,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c13f1f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c1401f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc06c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 954.264,
    cy: 143.654,
    r: 121.147,
    style: {
      fill: "url(#cx)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cy",
    x1: 2179.947,
    x2: 2179.947,
    y1: 130.887,
    y2: -111.581,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c13f1f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c1401f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc06c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 950.756,
    cy: 141.033,
    r: 121.234,
    style: {
      fill: "url(#cy)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cz",
    x1: 2178.975,
    x2: 2178.975,
    y1: 126.766,
    y2: -115.876,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c13f1f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c1401f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc06c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 947.239,
    cy: 138.485,
    r: 121.32,
    style: {
      fill: "url(#cz)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cA",
    x1: 2177.944,
    x2: 2177.944,
    y1: 122.699,
    y2: -120.117,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c13f20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c14020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc06c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 943.713,
    cy: 136.015,
    r: 121.407,
    style: {
      fill: "url(#cA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cB",
    x1: 2176.853,
    x2: 2176.853,
    y1: 118.689,
    y2: -124.3,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c13f20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c14020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc06c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 940.18,
    cy: 133.628,
    r: 121.494,
    style: {
      fill: "url(#cB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cC",
    x1: 2175.7,
    x2: 2175.7,
    y1: 114.74,
    y2: -128.423,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c03f20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c04020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc06c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 936.639,
    cy: 131.329,
    r: 121.581,
    style: {
      fill: "url(#cC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cD",
    x1: 2174.481,
    x2: 2174.481,
    y1: 110.857,
    y2: -132.479,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c03f20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c04020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbf6d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 933.092,
    cy: 129.122,
    r: 121.668,
    style: {
      fill: "url(#cD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cE",
    x1: 2173.193,
    x2: 2173.193,
    y1: 107.044,
    y2: -136.466,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c03f20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c03f20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbf6d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 929.54,
    cy: 127.013,
    r: 121.755,
    style: {
      fill: "url(#cE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cF",
    x1: 2171.836,
    x2: 2171.836,
    y1: 103.305,
    y2: -140.378,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c03f20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#c03f20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbf6d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 925.984,
    cy: 125.005,
    r: 121.841,
    style: {
      fill: "url(#cF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cG",
    x1: 2170.405,
    x2: 2170.405,
    y1: 99.645,
    y2: -144.213,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bf3f21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bf3f21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbf6d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 922.425,
    cy: 123.105,
    r: 121.928,
    style: {
      fill: "url(#cG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cH",
    x1: 2168.899,
    x2: 2168.899,
    y1: 96.067,
    y2: -147.964,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bf3f21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bf3f21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbf6d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 918.862,
    cy: 121.316,
    r: 122.015,
    style: {
      fill: "url(#cH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cI",
    x1: 2167.315,
    x2: 2167.315,
    y1: 92.575,
    y2: -151.63,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bf3e21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bf3f21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbf6d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 915.298,
    cy: 119.644,
    r: 122.102,
    style: {
      fill: "url(#cI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cJ",
    x1: 2165.65,
    x2: 2165.65,
    y1: 89.174,
    y2: -155.204,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bf3e21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bf3f21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbf6d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 911.733,
    cy: 118.094,
    r: 122.189,
    style: {
      fill: "url(#cJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cK",
    x1: 2163.902,
    x2: 2163.902,
    y1: 85.869,
    y2: -158.683,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bf3e21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bf3f21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbf6d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 908.167,
    cy: 116.67,
    r: 122.275,
    style: {
      fill: "url(#cK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cL",
    x1: 2162.068,
    x2: 2162.068,
    y1: 82.662,
    y2: -162.063,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#be3e22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#be3f22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbf6d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 904.602,
    cy: 115.377,
    r: 122.362,
    style: {
      fill: "url(#cL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cM",
    x1: 2160.145,
    x2: 2160.145,
    y1: 79.56,
    y2: -165.339,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#be3e22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#be3f22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbe6e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 901.039,
    cy: 114.22,
    r: 122.449,
    style: {
      fill: "url(#cM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cN",
    x1: 2158.132,
    x2: 2158.132,
    y1: 76.564,
    y2: -168.508,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#be3e22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#be3f22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbe6e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 897.478,
    cy: 113.204,
    r: 122.536,
    style: {
      fill: "url(#cN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cO",
    x1: 2156.025,
    x2: 2156.025,
    y1: 73.681,
    y2: -171.565,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#be3e22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#be3f22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbe6e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 893.921,
    cy: 112.334,
    r: 122.623,
    style: {
      fill: "url(#cO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cP",
    x1: 2153.823,
    x2: 2153.823,
    y1: 70.914,
    y2: -174.506,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#be3e22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#be3f22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbe6e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 890.367,
    cy: 111.614,
    r: 122.71,
    style: {
      fill: "url(#cP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cQ",
    x1: 2151.521,
    x2: 2151.521,
    y1: 68.267,
    y2: -177.327,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bd3e22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bd3f22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbe6e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 886.818,
    cy: 111.049,
    r: 122.796,
    style: {
      fill: "url(#cQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cR",
    x1: 2149.119,
    x2: 2149.119,
    y1: 65.744,
    y2: -180.023,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bd3e23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bd3f23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbe6e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 883.275,
    cy: 110.645,
    r: 122.883,
    style: {
      fill: "url(#cR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cS",
    x1: 2146.613,
    x2: 2146.613,
    y1: 63.35,
    y2: -182.59,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bd3e23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bd3f23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbe6e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 879.739,
    cy: 110.406,
    r: 122.97,
    style: {
      fill: "url(#cS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cT",
    x1: 2144.001,
    x2: 2144.001,
    y1: 61.09,
    y2: -185.025,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bd3e23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bd3f23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbe6e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 876.21,
    cy: 110.337,
    r: 123.057,
    style: {
      fill: "url(#cT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cU",
    x1: 2141.28,
    x2: 2141.28,
    y1: 58.966,
    y2: -187.323,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bd3e23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bd3f23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbe6e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 872.689,
    cy: 110.442,
    r: 123.144,
    style: {
      fill: "url(#cU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cV",
    x1: 2138.448,
    x2: 2138.448,
    y1: 56.983,
    y2: -189.479,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bc3e23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bc3f23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbe6f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 869.178,
    cy: 110.727,
    r: 123.23,
    style: {
      fill: "url(#cV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cW",
    x1: 2135.502,
    x2: 2135.502,
    y1: 55.146,
    y2: -191.49,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bc3e23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bc3e23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbd6f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 865.676,
    cy: 111.197,
    r: 123.317,
    style: {
      fill: "url(#cW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cX",
    x1: 2132.44,
    x2: 2132.44,
    y1: 53.458,
    y2: -193.351,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bc3e24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bc3e24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbd6f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 862.185,
    cy: 111.855,
    r: 123.404,
    style: {
      fill: "url(#cX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cY",
    x1: 2129.258,
    x2: 2129.258,
    y1: 51.924,
    y2: -195.058,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bc3e24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bc3e24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbd6f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 858.706,
    cy: 112.708,
    r: 123.491,
    style: {
      fill: "url(#cY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cZ",
    x1: 2125.956,
    x2: 2125.956,
    y1: 50.549,
    y2: -196.608,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bc3e24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bc3e24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbd6f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 855.239,
    cy: 113.76,
    r: 123.578,
    style: {
      fill: "url(#cZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "da",
    x1: 2122.529,
    x2: 2122.529,
    y1: 49.335,
    y2: -197.995,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bb3d24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bb3e24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbd6f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 851.786,
    cy: 115.015,
    r: 123.664,
    style: {
      fill: "url(#da)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "db",
    x1: 2118.976,
    x2: 2118.976,
    y1: 48.288,
    y2: -199.215,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bb3d24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bb3e24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbd6f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 848.346,
    cy: 116.479,
    r: 123.751,
    style: {
      fill: "url(#db)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dc",
    x1: 2115.294,
    x2: 2115.294,
    y1: 47.412,
    y2: -200.265,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bb3d25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bb3e25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbd6f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 844.922,
    cy: 118.157,
    r: 123.838,
    style: {
      fill: "url(#dc)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dd",
    x1: 2111.479,
    x2: 2111.479,
    y1: 46.71,
    y2: -201.14,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bb3d25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#bb3e25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbd6f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 841.514,
    cy: 120.052,
    r: 123.925,
    style: {
      fill: "url(#dd)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "de",
    x1: 2107.531,
    x2: 2107.531,
    y1: 46.188,
    y2: -201.837,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ba3d25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ba3e25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbd70"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 838.122,
    cy: 122.171,
    r: 124.012,
    style: {
      fill: "url(#de)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "df",
    x1: 2103.446,
    x2: 2103.446,
    y1: 45.849,
    y2: -202.349,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ba3d25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ba3e25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbc70"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 834.748,
    cy: 124.518,
    r: 124.099,
    style: {
      fill: "url(#df)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dg",
    x1: 2099.46,
    x2: 2099.46,
    y1: 45.729,
    y2: -202.642,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ba3d25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ba3e25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbc70"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 831.593,
    cy: 126.965,
    r: 124.185,
    style: {
      fill: "url(#dg)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dh",
    x1: 2095.494,
    x2: 2095.494,
    y1: 45.833,
    y2: -202.713,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ba3d25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ba3e25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbc70"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 828.6,
    cy: 129.567,
    r: 124.272,
    style: {
      fill: "url(#dh)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "di",
    x1: 2091.549,
    x2: 2091.549,
    y1: 46.151,
    y2: -202.568,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ba3d26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ba3e26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbc70"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 825.764,
    cy: 132.316,
    r: 124.359,
    style: {
      fill: "url(#di)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dj",
    x1: 2087.63,
    x2: 2087.63,
    y1: 46.678,
    y2: -202.214,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b93d26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b93e26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbc70"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 823.084,
    cy: 135.207,
    r: 124.446,
    style: {
      fill: "url(#dj)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dk",
    x1: 2083.74,
    x2: 2083.74,
    y1: 47.407,
    y2: -201.659,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b93d26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b93e26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbc70"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 820.56,
    cy: 138.229,
    r: 124.533,
    style: {
      fill: "url(#dk)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dl",
    x1: 2079.885,
    x2: 2079.885,
    y1: 48.331,
    y2: -200.909,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b93d26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b93e26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbc70"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 818.19,
    cy: 141.376,
    r: 124.619,
    style: {
      fill: "url(#dl)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dm",
    x1: 2076.069,
    x2: 2076.069,
    y1: 49.443,
    y2: -199.97,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b93d26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b93e26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbc70"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 815.972,
    cy: 144.638,
    r: 124.706,
    style: {
      fill: "url(#dm)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dn",
    x1: 2072.296,
    x2: 2072.296,
    y1: 50.736,
    y2: -198.851,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b93d26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b93d26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbc71"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 813.907,
    cy: 148.009,
    r: 124.793,
    style: {
      fill: "url(#dn)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "do",
    x1: 2068.57,
    x2: 2068.57,
    y1: 52.203,
    y2: -197.558,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b83d27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b83d27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbb71"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 811.992,
    cy: 151.479,
    r: 124.88,
    style: {
      fill: "url(#do)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dp",
    x1: 2064.897,
    x2: 2064.897,
    y1: 53.837,
    y2: -196.097,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b83d27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b83d27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbb71"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 810.226,
    cy: 155.041,
    r: 124.967,
    style: {
      fill: "url(#dp)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dq",
    x1: 2061.28,
    x2: 2061.28,
    y1: 55.632,
    y2: -194.476,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b83d27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b83d27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbb71"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 808.608,
    cy: 158.687,
    r: 125.054,
    style: {
      fill: "url(#dq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dr",
    x1: 2057.724,
    x2: 2057.724,
    y1: 57.581,
    y2: -192.701,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b83c27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b83d27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbb71"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 807.137,
    cy: 162.408,
    r: 125.14,
    style: {
      fill: "url(#dr)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ds",
    x1: 2054.233,
    x2: 2054.233,
    y1: 59.675,
    y2: -190.78,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b83c27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b83d27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbb71"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 805.812,
    cy: 166.196,
    r: 125.227,
    style: {
      fill: "url(#ds)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dt",
    x1: 2050.813,
    x2: 2050.813,
    y1: 61.91,
    y2: -188.719,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b73c28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b73d28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbb71"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 804.631,
    cy: 170.044,
    r: 125.314,
    style: {
      fill: "url(#dt)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "du",
    x1: 2047.466,
    x2: 2047.466,
    y1: 64.278,
    y2: -186.524,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b73c28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b73d28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbb71"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 803.594,
    cy: 173.943,
    r: 125.401,
    style: {
      fill: "url(#du)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dv",
    x1: 2044.198,
    x2: 2044.198,
    y1: 66.772,
    y2: -184.204,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b73c28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b73d28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbb71"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 802.698,
    cy: 177.886,
    r: 125.488,
    style: {
      fill: "url(#dv)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dw",
    x1: 2041.013,
    x2: 2041.013,
    y1: 69.385,
    y2: -181.765,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b73c28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b73d28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbb72"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 801.944,
    cy: 181.863,
    r: 125.574,
    style: {
      fill: "url(#dw)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dx",
    x1: 2037.916,
    x2: 2037.916,
    y1: 72.111,
    y2: -179.213,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b73c28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b73d28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbb72"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 801.33,
    cy: 185.868,
    r: 125.661,
    style: {
      fill: "url(#dx)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dy",
    x1: 2034.911,
    x2: 2034.911,
    y1: 74.941,
    y2: -176.556,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b63c28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b63d28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffba72"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 800.854,
    cy: 189.891,
    r: 125.748,
    style: {
      fill: "url(#dy)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dz",
    x1: 2032.002,
    x2: 2032.002,
    y1: 77.871,
    y2: -173.8,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b63c29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b63d29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffba72"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 800.515,
    cy: 193.925,
    r: 125.835,
    style: {
      fill: "url(#dz)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dA",
    x1: 2029.194,
    x2: 2029.194,
    y1: 80.892,
    y2: -170.953,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b63c29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b63d29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffba72"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 800.313,
    cy: 197.962,
    r: 125.922,
    style: {
      fill: "url(#dA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dB",
    x1: 2026.491,
    x2: 2026.491,
    y1: 83.997,
    y2: -168.021,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b63c29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b63d29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffba72"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 800.246,
    cy: 201.993,
    r: 126.009,
    style: {
      fill: "url(#dB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dC",
    x1: 2023.898,
    x2: 2023.898,
    y1: 87.181,
    y2: -165.011,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b53c29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b53d29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffba72"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 800.312,
    cy: 206.011,
    r: 126.095,
    style: {
      fill: "url(#dC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dD",
    x1: 2021.34,
    x2: 2021.34,
    y1: 90.526,
    y2: -161.839,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b53c29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b53d29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffba72"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 800.511,
    cy: 210.127,
    r: 126.182,
    style: {
      fill: "url(#dD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dE",
    x1: 2018.841,
    x2: 2018.841,
    y1: 93.966,
    y2: -158.572,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b53c29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b53d29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffba72"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 800.818,
    cy: 214.276,
    r: 126.269,
    style: {
      fill: "url(#dE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dF",
    x1: 2016.445,
    x2: 2016.445,
    y1: 97.441,
    y2: -155.272,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b53c2a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b53c2a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffba73"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 801.225,
    cy: 218.382,
    r: 126.356,
    style: {
      fill: "url(#dF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dG",
    x1: 2014.149,
    x2: 2014.149,
    y1: 100.948,
    y2: -151.938,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b53c2a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b53c2a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffba73"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 801.727,
    cy: 222.449,
    r: 126.443,
    style: {
      fill: "url(#dG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dH",
    x1: 2011.948,
    x2: 2011.948,
    y1: 104.487,
    y2: -148.573,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b43c2a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b43c2a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb973"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 802.323,
    cy: 226.476,
    r: 126.529,
    style: {
      fill: "url(#dH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dI",
    x1: 2009.84,
    x2: 2009.84,
    y1: 108.057,
    y2: -145.176,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b43c2a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b43c2a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb973"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 803.009,
    cy: 230.466,
    r: 126.616,
    style: {
      fill: "url(#dI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dJ",
    x1: 2007.821,
    x2: 2007.821,
    y1: 111.657,
    y2: -141.75,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b43b2a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b43c2a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb973"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 803.782,
    cy: 234.419,
    r: 126.703,
    style: {
      fill: "url(#dJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dK",
    x1: 2005.888,
    x2: 2005.888,
    y1: 115.286,
    y2: -138.294,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b43b2b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b43c2b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb973"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 804.639,
    cy: 238.337,
    r: 126.79,
    style: {
      fill: "url(#dK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dL",
    x1: 2004.039,
    x2: 2004.039,
    y1: 118.943,
    y2: -134.811,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b43b2b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b43c2b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb973"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 805.577,
    cy: 242.222,
    r: 126.877,
    style: {
      fill: "url(#dL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dM",
    x1: 2002.269,
    x2: 2002.269,
    y1: 122.627,
    y2: -131.301,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b33b2b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b33c2b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb973"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 806.592,
    cy: 246.074,
    r: 126.963,
    style: {
      fill: "url(#dM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dN",
    x1: 2000.576,
    x2: 2000.576,
    y1: 126.336,
    y2: -127.766,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b33b2b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b33c2b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb973"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 807.682,
    cy: 249.895,
    r: 127.05,
    style: {
      fill: "url(#dN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dO",
    x1: 1998.956,
    x2: 1998.956,
    y1: 130.071,
    y2: -124.205,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b33b2b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b33c2b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb974"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 808.844,
    cy: 253.687,
    r: 127.137,
    style: {
      fill: "url(#dO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dP",
    x1: 1997.407,
    x2: 1997.407,
    y1: 133.829,
    y2: -120.62,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b33b2b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b33c2b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb974"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 810.074,
    cy: 257.451,
    r: 127.224,
    style: {
      fill: "url(#dP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dQ",
    x1: 1995.924,
    x2: 1995.924,
    y1: 137.61,
    y2: -117.013,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b33b2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b33c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb874"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 811.37,
    cy: 261.188,
    r: 127.311,
    style: {
      fill: "url(#dQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dR",
    x1: 1994.505,
    x2: 1994.505,
    y1: 141.413,
    y2: -113.383,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b23b2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b23c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb874"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 812.728,
    cy: 264.899,
    r: 127.398,
    style: {
      fill: "url(#dR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dS",
    x1: 1993.147,
    x2: 1993.147,
    y1: 145.237,
    y2: -109.733,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b23b2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b23c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb874"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 814.145,
    cy: 268.586,
    r: 127.484,
    style: {
      fill: "url(#dS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dT",
    x1: 1991.846,
    x2: 1991.846,
    y1: 149.08,
    y2: -106.063,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b23b2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b23c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb874"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 815.619,
    cy: 272.25,
    r: 127.571,
    style: {
      fill: "url(#dT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dU",
    x1: 1990.599,
    x2: 1990.599,
    y1: 152.943,
    y2: -102.374,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b23b2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b23c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb874"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 817.145,
    cy: 275.893,
    r: 127.658,
    style: {
      fill: "url(#dU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dV",
    x1: 1989.402,
    x2: 1989.402,
    y1: 156.823,
    y2: -98.668,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b23b2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b23c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb874"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 818.722,
    cy: 279.516,
    r: 127.745,
    style: {
      fill: "url(#dV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dW",
    x1: 1988.254,
    x2: 1988.254,
    y1: 160.72,
    y2: -94.944,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b13b2d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b13b2d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb874"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 820.345,
    cy: 283.12,
    r: 127.832,
    style: {
      fill: "url(#dW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dX",
    x1: 1987.15,
    x2: 1987.15,
    y1: 164.633,
    y2: -91.205,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b13b2d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b13b2d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb875"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 822.013,
    cy: 286.707,
    r: 127.918,
    style: {
      fill: "url(#dX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dY",
    x1: 1986.087,
    x2: 1986.087,
    y1: 168.561,
    y2: -87.451,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b13b2d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b13b2d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb875"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 823.721,
    cy: 290.278,
    r: 128.005,
    style: {
      fill: "url(#dY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dZ",
    x1: 1985.062,
    x2: 1985.062,
    y1: 172.502,
    y2: -83.683,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b13b2d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b13b2d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb875"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 825.467,
    cy: 293.834,
    r: 128.092,
    style: {
      fill: "url(#dZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ea",
    x1: 1984.072,
    x2: 1984.072,
    y1: 176.457,
    y2: -79.902,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b03b2d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b03b2d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb775"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 827.247,
    cy: 297.377,
    r: 128.179,
    style: {
      fill: "url(#ea)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eb",
    x1: 1983.114,
    x2: 1983.114,
    y1: 180.423,
    y2: -76.11,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b03a2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b03b2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb775"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 829.059,
    cy: 300.907,
    r: 128.266,
    style: {
      fill: "url(#eb)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ec",
    x1: 1982.184,
    x2: 1982.184,
    y1: 184.4,
    y2: -72.306,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b03a2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b03b2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb775"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 830.9,
    cy: 304.428,
    r: 128.353,
    style: {
      fill: "url(#ec)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ed",
    x1: 1981.279,
    x2: 1981.279,
    y1: 188.386,
    y2: -68.493,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b03a2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b03b2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb775"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 832.765,
    cy: 307.939,
    r: 128.439,
    style: {
      fill: "url(#ed)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ee",
    x1: 1980.396,
    x2: 1980.396,
    y1: 192.382,
    y2: -64.672,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b03a2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#b03b2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb775"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 834.653,
    cy: 311.442,
    r: 128.526,
    style: {
      fill: "url(#ee)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ef",
    x1: 1979.532,
    x2: 1979.532,
    y1: 196.385,
    y2: -60.842,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#af3a2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#af3b2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb776"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 836.56,
    cy: 314.939,
    r: 128.613,
    style: {
      fill: "url(#ef)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eg",
    x1: 1978.684,
    x2: 1978.684,
    y1: 200.395,
    y2: -57.006,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#af3a2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#af3b2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb776"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 838.484,
    cy: 318.43,
    r: 128.7,
    style: {
      fill: "url(#eg)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eh",
    x1: 1977.847,
    x2: 1977.847,
    y1: 204.41,
    y2: -53.164,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#af3a2f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#af3b2f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb776"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 840.42,
    cy: 321.918,
    r: 128.787,
    style: {
      fill: "url(#eh)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ei",
    x1: 1977.02,
    x2: 1977.02,
    y1: 208.43,
    y2: -49.317,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#af3a2f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#af3b2f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb776"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 842.366,
    cy: 325.403,
    r: 128.873,
    style: {
      fill: "url(#ei)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ej",
    x1: 1976.198,
    x2: 1976.198,
    y1: 212.455,
    y2: -45.467,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#af3a2f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#af3b2f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb676"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 844.32,
    cy: 328.888,
    r: 128.96,
    style: {
      fill: "url(#ej)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ek",
    x1: 1975.38,
    x2: 1975.38,
    y1: 216.481,
    y2: -41.614,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ae3a2f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ae3b2f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb676"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 846.276,
    cy: 332.372,
    r: 129.047,
    style: {
      fill: "url(#ek)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "el",
    x1: 1974.56,
    x2: 1974.56,
    y1: 220.51,
    y2: -37.759,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ae3a2f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ae3b2f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb676"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 848.234,
    cy: 335.858,
    r: 129.134,
    style: {
      fill: "url(#el)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "em",
    x1: 1973.737,
    x2: 1973.737,
    y1: 224.539,
    y2: -33.903,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ae3a2f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ae3b2f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb676"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 850.189,
    cy: 339.347,
    r: 129.221,
    style: {
      fill: "url(#em)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "en",
    x1: 1972.908,
    x2: 1972.908,
    y1: 228.568,
    y2: -30.048,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ae3a30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ae3b30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb676"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 852.139,
    cy: 342.841,
    r: 129.308,
    style: {
      fill: "url(#en)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eo",
    x1: 1972.067,
    x2: 1972.067,
    y1: 232.596,
    y2: -26.194,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ae3a30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ae3a30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb677"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 854.08,
    cy: 346.34,
    r: 129.394,
    style: {
      fill: "url(#eo)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ep",
    x1: 1971.214,
    x2: 1971.214,
    y1: 236.621,
    y2: -22.343,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ad3a30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ad3a30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb677"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 856.01,
    cy: 349.846,
    r: 129.481,
    style: {
      fill: "url(#ep)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eq",
    x1: 1970.343,
    x2: 1970.343,
    y1: 240.643,
    y2: -18.494,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ad3a30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ad3a30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb677"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 857.924,
    cy: 353.361,
    r: 129.568,
    style: {
      fill: "url(#eq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "er",
    x1: 1969.453,
    x2: 1969.453,
    y1: 244.66,
    y2: -14.65,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ad3a30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ad3a30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb677"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 859.821,
    cy: 356.885,
    r: 129.655,
    style: {
      fill: "url(#er)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es",
    x1: 1968.54,
    x2: 1968.54,
    y1: 248.673,
    y2: -10.812,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ad3a31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ad3a31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb577"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 861.697,
    cy: 360.42,
    r: 129.742,
    style: {
      fill: "url(#es)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "et",
    x1: 1967.601,
    x2: 1967.601,
    y1: 252.679,
    y2: -6.979,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ad3931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ad3a31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb577"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 863.549,
    cy: 363.968,
    r: 129.828,
    style: {
      fill: "url(#et)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eu",
    x1: 1966.632,
    x2: 1966.632,
    y1: 256.677,
    y2: -3.154,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ac3931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ac3a31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb577"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 865.375,
    cy: 367.53,
    r: 129.915,
    style: {
      fill: "url(#eu)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ev",
    x1: 1965.63,
    x2: 1965.63,
    y1: 260.667,
    y2: 0.662,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ac3931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ac3a31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb577"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 867.169,
    cy: 371.107,
    r: 130.002,
    style: {
      fill: "url(#ev)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ew",
    x1: 1964.593,
    x2: 1964.593,
    y1: 264.648,
    y2: 4.47,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ac3931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ac3a31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb577"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 868.931,
    cy: 374.701,
    r: 130.089,
    style: {
      fill: "url(#ew)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ex",
    x1: 1963.516,
    x2: 1963.516,
    y1: 268.619,
    y2: 8.266,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ac3931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ac3a31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb578"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 870.656,
    cy: 378.312,
    r: 130.176,
    style: {
      fill: "url(#ex)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ey",
    x1: 1962.397,
    x2: 1962.397,
    y1: 272.578,
    y2: 12.052,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ab3932"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ab3a32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb578"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 872.342,
    cy: 381.943,
    r: 130.262,
    style: {
      fill: "url(#ey)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ez",
    x1: 1961.233,
    x2: 1961.233,
    y1: 276.524,
    y2: 15.825,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ab3932"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ab3a32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb578"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 873.986,
    cy: 385.594,
    r: 130.349,
    style: {
      fill: "url(#ez)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eA",
    x1: 1960.02,
    x2: 1960.02,
    y1: 280.458,
    y2: 19.585,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ab3932"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ab3a32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb578"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 875.584,
    cy: 389.267,
    r: 130.436,
    style: {
      fill: "url(#eA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eB",
    x1: 1958.754,
    x2: 1958.754,
    y1: 284.377,
    y2: 23.33,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ab3932"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ab3a32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb578"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 877.133,
    cy: 392.964,
    r: 130.523,
    style: {
      fill: "url(#eB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eC",
    x1: 1957.411,
    x2: 1957.411,
    y1: 288.341,
    y2: 27.12,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ab3932"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#ab3a32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb478"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 878.653,
    cy: 396.745,
    r: 130.61,
    style: {
      fill: "url(#eC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eD",
    x1: 1955.975,
    x2: 1955.975,
    y1: 292.356,
    y2: 30.962,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#aa3932"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#aa3a32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb478"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 880.137,
    cy: 400.627,
    r: 130.697,
    style: {
      fill: "url(#eD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eE",
    x1: 1954.475,
    x2: 1954.475,
    y1: 296.329,
    y2: 34.761,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#aa3933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#aa3a33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb478"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 881.545,
    cy: 404.519,
    r: 130.783,
    style: {
      fill: "url(#eE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eF",
    x1: 1952.912,
    x2: 1952.912,
    y1: 300.26,
    y2: 38.519,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#aa3933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#aa3933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb478"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 882.879,
    cy: 408.421,
    r: 130.87,
    style: {
      fill: "url(#eF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eG",
    x1: 1951.288,
    x2: 1951.288,
    y1: 304.149,
    y2: 42.234,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#aa3933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#aa3933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb479"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 884.138,
    cy: 412.331,
    r: 130.957,
    style: {
      fill: "url(#eG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH",
    x1: 1949.603,
    x2: 1949.603,
    y1: 307.996,
    y2: 45.907,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#aa3933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#aa3933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb479"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 885.323,
    cy: 416.249,
    r: 131.044,
    style: {
      fill: "url(#eH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eI",
    x1: 1947.858,
    x2: 1947.858,
    y1: 311.8,
    y2: 49.538,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a93933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a93933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb479"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 886.435,
    cy: 420.175,
    r: 131.131,
    style: {
      fill: "url(#eI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eJ",
    x1: 1946.053,
    x2: 1946.053,
    y1: 315.562,
    y2: 53.126,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a93934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a93934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb479"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 887.474,
    cy: 424.108,
    r: 131.217,
    style: {
      fill: "url(#eJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eK",
    x1: 1944.189,
    x2: 1944.189,
    y1: 319.28,
    y2: 56.67,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a93834"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a93934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb479"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 888.441,
    cy: 428.047,
    r: 131.304,
    style: {
      fill: "url(#eK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eL",
    x1: 1942.268,
    x2: 1942.268,
    y1: 322.955,
    y2: 60.172,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a93834"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a93934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb379"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 889.336,
    cy: 431.991,
    r: 131.391,
    style: {
      fill: "url(#eL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eM",
    x1: 1940.29,
    x2: 1940.29,
    y1: 326.587,
    y2: 63.63,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a93834"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a93934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb379"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 890.159,
    cy: 435.94,
    r: 131.478,
    style: {
      fill: "url(#eM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eN",
    x1: 1938.255,
    x2: 1938.255,
    y1: 330.175,
    y2: 67.045,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a83834"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a83934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb379"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 890.911,
    cy: 439.894,
    r: 131.565,
    style: {
      fill: "url(#eN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eO",
    x1: 1936.165,
    x2: 1936.165,
    y1: 333.72,
    y2: 70.416,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a83834"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a83934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb379"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 891.592,
    cy: 443.851,
    r: 131.652,
    style: {
      fill: "url(#eO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eP",
    x1: 1934.02,
    x2: 1934.02,
    y1: 337.221,
    y2: 73.743,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a83835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a83935"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb37a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 892.204,
    cy: 447.811,
    r: 131.738,
    style: {
      fill: "url(#eP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eQ",
    x1: 1931.821,
    x2: 1931.821,
    y1: 340.678,
    y2: 77.026,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a83835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a83935"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb37a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 892.746,
    cy: 451.774,
    r: 131.825,
    style: {
      fill: "url(#eQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eR",
    x1: 1929.569,
    x2: 1929.569,
    y1: 344.09,
    y2: 80.265,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a83835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a83935"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb37a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 893.218,
    cy: 455.738,
    r: 131.912,
    style: {
      fill: "url(#eR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eS",
    x1: 1927.265,
    x2: 1927.265,
    y1: 347.458,
    y2: 83.46,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a73835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a73935"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb37a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 893.622,
    cy: 459.703,
    r: 131.999,
    style: {
      fill: "url(#eS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eT",
    x1: 1924.909,
    x2: 1924.909,
    y1: 350.782,
    y2: 86.61,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a73835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a73935"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb37a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 893.958,
    cy: 463.668,
    r: 132.086,
    style: {
      fill: "url(#eT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eU",
    x1: 1922.502,
    x2: 1922.502,
    y1: 354.061,
    y2: 89.715,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a73835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a73935"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb27a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 894.226,
    cy: 467.633,
    r: 132.172,
    style: {
      fill: "url(#eU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eV",
    x1: 1920.045,
    x2: 1920.045,
    y1: 357.295,
    y2: 92.775,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a73836"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a73936"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb27a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 894.427,
    cy: 471.597,
    r: 132.259,
    style: {
      fill: "url(#eV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eW",
    x1: 1917.539,
    x2: 1917.539,
    y1: 360.483,
    y2: 95.79,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a63836"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a63836"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb27a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 894.561,
    cy: 475.56,
    r: 132.346,
    style: {
      fill: "url(#eW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eX",
    x1: 1914.984,
    x2: 1914.984,
    y1: 363.626,
    y2: 98.76,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a63836"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a63836"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb27a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 894.628,
    cy: 479.52,
    r: 132.433,
    style: {
      fill: "url(#eX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eY",
    x1: 1912.382,
    x2: 1912.382,
    y1: 366.724,
    y2: 101.684,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a63836"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a63836"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb27b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 894.63,
    cy: 483.477,
    r: 132.52,
    style: {
      fill: "url(#eY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eZ",
    x1: 1909.733,
    x2: 1909.733,
    y1: 369.776,
    y2: 104.562,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a63836"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a63836"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb27b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 894.566,
    cy: 487.431,
    r: 132.607,
    style: {
      fill: "url(#eZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fa",
    x1: 1907.038,
    x2: 1907.038,
    y1: 372.783,
    y2: 107.395,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a63837"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a63837"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb27b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 894.438,
    cy: 491.381,
    r: 132.693,
    style: {
      fill: "url(#fa)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb",
    x1: 1904.297,
    x2: 1904.297,
    y1: 375.743,
    y2: 110.182,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a53837"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a53837"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb27b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 894.245,
    cy: 495.325,
    r: 132.78,
    style: {
      fill: "url(#fb)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fc",
    x1: 1901.512,
    x2: 1901.512,
    y1: 378.657,
    y2: 112.922,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a53737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a53837"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb27b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 893.988,
    cy: 499.264,
    r: 132.867,
    style: {
      fill: "url(#fc)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd",
    x1: 1898.683,
    x2: 1898.683,
    y1: 381.524,
    y2: 115.616,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a53737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a53837"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb27b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 893.667,
    cy: 503.197,
    r: 132.954,
    style: {
      fill: "url(#fd)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fe",
    x1: 1895.811,
    x2: 1895.811,
    y1: 384.345,
    y2: 118.263,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a53737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a53837"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb17b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 893.283,
    cy: 507.123,
    r: 133.041,
    style: {
      fill: "url(#fe)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff",
    x1: 1892.897,
    x2: 1892.897,
    y1: 387.12,
    y2: 120.864,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a53737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a53837"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb17b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 892.837,
    cy: 511.042,
    r: 133.127,
    style: {
      fill: "url(#ff)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fg",
    x1: 1889.941,
    x2: 1889.941,
    y1: 389.847,
    y2: 123.417,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a43738"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a43838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb17b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 892.329,
    cy: 514.952,
    r: 133.214,
    style: {
      fill: "url(#fg)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fh",
    x1: 1886.945,
    x2: 1886.945,
    y1: 392.527,
    y2: 125.924,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a43738"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a43838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb17c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 891.759,
    cy: 518.854,
    r: 133.301,
    style: {
      fill: "url(#fh)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fi",
    x1: 1883.909,
    x2: 1883.909,
    y1: 395.16,
    y2: 128.383,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a43738"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a43838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb17c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 891.128,
    cy: 522.746,
    r: 133.388,
    style: {
      fill: "url(#fi)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fj",
    x1: 1880.834,
    x2: 1880.834,
    y1: 397.745,
    y2: 130.794,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a43738"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a43838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb17c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 890.436,
    cy: 526.628,
    r: 133.475,
    style: {
      fill: "url(#fj)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fk",
    x1: 1877.721,
    x2: 1877.721,
    y1: 400.282,
    y2: 133.158,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a43738"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a43838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb17c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 889.683,
    cy: 530.5,
    r: 133.561,
    style: {
      fill: "url(#fk)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fl",
    x1: 1874.57,
    x2: 1874.57,
    y1: 402.772,
    y2: 135.474,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a33738"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a33838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb17c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 888.872,
    cy: 534.36,
    r: 133.648,
    style: {
      fill: "url(#fl)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fm",
    x1: 1871.382,
    x2: 1871.382,
    y1: 405.214,
    y2: 137.742,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a33739"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a33839"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb17c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 888,
    cy: 538.208,
    r: 133.735,
    style: {
      fill: "url(#fm)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fn",
    x1: 1868.158,
    x2: 1868.158,
    y1: 407.607,
    y2: 139.962,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a33739"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a33839"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb07c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 887.07,
    cy: 542.043,
    r: 133.822,
    style: {
      fill: "url(#fn)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fo",
    x1: 1864.899,
    x2: 1864.899,
    y1: 409.952,
    y2: 142.133,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a33739"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a33739"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb07c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 886.082,
    cy: 545.865,
    r: 133.909,
    style: {
      fill: "url(#fo)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fp",
    x1: 1861.606,
    x2: 1861.606,
    y1: 412.248,
    y2: 144.256,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a33739"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a33739"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb07c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 885.035,
    cy: 549.673,
    r: 133.996,
    style: {
      fill: "url(#fp)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fq",
    x1: 1858.279,
    x2: 1858.279,
    y1: 414.496,
    y2: 146.33,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a23739"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a23739"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb07d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 883.932,
    cy: 553.466,
    r: 134.082,
    style: {
      fill: "url(#fq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fr",
    x1: 1854.92,
    x2: 1854.92,
    y1: 416.695,
    y2: 148.355,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a2373a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a2373a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb07d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 882.771,
    cy: 557.244,
    r: 134.169,
    style: {
      fill: "url(#fr)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fs",
    x1: 1851.528,
    x2: 1851.528,
    y1: 418.844,
    y2: 150.331,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a2373a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a2373a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb07d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 881.554,
    cy: 561.006,
    r: 134.256,
    style: {
      fill: "url(#fs)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ft",
    x1: 1848.105,
    x2: 1848.105,
    y1: 420.944,
    y2: 152.257,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a2373a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a2373a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb07d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 880.28,
    cy: 564.751,
    r: 134.343,
    style: {
      fill: "url(#ft)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fu",
    x1: 1844.651,
    x2: 1844.651,
    y1: 422.995,
    y2: 154.134,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a1363a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a1373a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb07d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 878.952,
    cy: 568.479,
    r: 134.43,
    style: {
      fill: "url(#fu)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fv",
    x1: 1841.168,
    x2: 1841.168,
    y1: 424.996,
    y2: 155.962,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a1363a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a1373a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffb07d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 877.568,
    cy: 572.19,
    r: 134.516,
    style: {
      fill: "url(#fv)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fw",
    x1: 1837.656,
    x2: 1837.656,
    y1: 426.947,
    y2: 157.739,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a1363a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a1373a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaf7d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 876.129,
    cy: 575.881,
    r: 134.603,
    style: {
      fill: "url(#fw)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fx",
    x1: 1834.116,
    x2: 1834.116,
    y1: 428.848,
    y2: 159.466,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a1363b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a1373b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaf7d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 874.637,
    cy: 579.554,
    r: 134.69,
    style: {
      fill: "url(#fx)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fy",
    x1: 1830.548,
    x2: 1830.548,
    y1: 430.698,
    y2: 161.143,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a1363b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a1373b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaf7e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 873.09,
    cy: 583.206,
    r: 134.777,
    style: {
      fill: "url(#fy)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fz",
    x1: 1826.954,
    x2: 1826.954,
    y1: 432.499,
    y2: 162.77,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a0363b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a0373b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaf7e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 871.491,
    cy: 586.838,
    r: 134.864,
    style: {
      fill: "url(#fz)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fA",
    x1: 1823.334,
    x2: 1823.334,
    y1: 434.248,
    y2: 164.346,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a0363b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a0373b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaf7e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 869.839,
    cy: 590.449,
    r: 134.951,
    style: {
      fill: "url(#fA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fB",
    x1: 1819.689,
    x2: 1819.689,
    y1: 435.947,
    y2: 165.872,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a0363b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a0373b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaf7e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 868.134,
    cy: 594.038,
    r: 135.037,
    style: {
      fill: "url(#fB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fC",
    x1: 1816.02,
    x2: 1816.02,
    y1: 437.595,
    y2: 167.346,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a0363b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a0373b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaf7e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 866.378,
    cy: 597.605,
    r: 135.124,
    style: {
      fill: "url(#fC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fD",
    x1: 1812.327,
    x2: 1812.327,
    y1: 439.192,
    y2: 168.769,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a0363c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#a0373c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaf7e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 864.57,
    cy: 601.148,
    r: 135.211,
    style: {
      fill: "url(#fD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fE",
    x1: 1808.612,
    x2: 1808.612,
    y1: 440.738,
    y2: 170.141,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9f363c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9f373c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaf7e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 862.712,
    cy: 604.668,
    r: 135.298,
    style: {
      fill: "url(#fE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fF",
    x1: 1804.875,
    x2: 1804.875,
    y1: 442.231,
    y2: 171.461,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9f363c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9f363c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaf7e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 860.803,
    cy: 608.164,
    r: 135.385,
    style: {
      fill: "url(#fF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fG",
    x1: 1801.117,
    x2: 1801.117,
    y1: 443.674,
    y2: 172.73,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9f363c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9f363c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffae7e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 858.844,
    cy: 611.634,
    r: 135.471,
    style: {
      fill: "url(#fG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fH",
    x1: 1797.338,
    x2: 1797.338,
    y1: 445.064,
    y2: 173.946,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9f363c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9f363c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffae7f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 856.836,
    cy: 615.078,
    r: 135.558,
    style: {
      fill: "url(#fH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fI",
    x1: 1793.54,
    x2: 1793.54,
    y1: 446.402,
    y2: 175.111,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9f363d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9f363d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffae7f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 854.778,
    cy: 618.496,
    r: 135.645,
    style: {
      fill: "url(#fI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fJ",
    x1: 1789.723,
    x2: 1789.723,
    y1: 447.688,
    y2: 176.224,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9e363d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9e363d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffae7f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 852.672,
    cy: 621.887,
    r: 135.732,
    style: {
      fill: "url(#fJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fK",
    x1: 1785.888,
    x2: 1785.888,
    y1: 448.922,
    y2: 177.284,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9e363d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9e363d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffae7f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 850.519,
    cy: 625.251,
    r: 135.819,
    style: {
      fill: "url(#fK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fL",
    x1: 1782.036,
    x2: 1782.036,
    y1: 450.103,
    y2: 178.291,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9e363d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9e363d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffae7f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 848.317,
    cy: 628.586,
    r: 135.906,
    style: {
      fill: "url(#fL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fM",
    x1: 1778.168,
    x2: 1778.168,
    y1: 451.231,
    y2: 179.246,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9e353d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9e363d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffae7f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 846.069,
    cy: 631.892,
    r: 135.992,
    style: {
      fill: "url(#fM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fN",
    x1: 1774.283,
    x2: 1774.283,
    y1: 452.307,
    y2: 180.147,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9e353d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9e363d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffae7f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 843.773,
    cy: 635.168,
    r: 136.079,
    style: {
      fill: "url(#fN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fO",
    x1: 1770.384,
    x2: 1770.384,
    y1: 453.329,
    y2: 180.996,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9d353e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9d363e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffae7f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 841.432,
    cy: 638.414,
    r: 136.166,
    style: {
      fill: "url(#fO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fP",
    x1: 1766.472,
    x2: 1766.472,
    y1: 454.298,
    y2: 181.791,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9d353e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9d363e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffad7f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 839.045,
    cy: 641.63,
    r: 136.253,
    style: {
      fill: "url(#fP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fQ",
    x1: 1762.545,
    x2: 1762.545,
    y1: 455.213,
    y2: 182.532,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9d353e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9d363e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffad80"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 836.613,
    cy: 644.813,
    r: 136.34,
    style: {
      fill: "url(#fQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fR",
    x1: 1758.606,
    x2: 1758.606,
    y1: 456.074,
    y2: 183.22,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9d353e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9d363e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffad80"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 834.136,
    cy: 647.965,
    r: 136.426,
    style: {
      fill: "url(#fR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fS",
    x1: 1754.656,
    x2: 1754.656,
    y1: 456.882,
    y2: 183.854,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9c353e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9c363e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffad80"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 831.614,
    cy: 651.083,
    r: 136.513,
    style: {
      fill: "url(#fS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fT",
    x1: 1750.695,
    x2: 1750.695,
    y1: 457.636,
    y2: 184.434,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9c353e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9c363e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffad80"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 829.049,
    cy: 654.168,
    r: 136.6,
    style: {
      fill: "url(#fT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fU",
    x1: 1746.723,
    x2: 1746.723,
    y1: 458.335,
    y2: 184.96,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9c353f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9c363f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffad80"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 826.441,
    cy: 657.219,
    r: 136.687,
    style: {
      fill: "url(#fU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fV",
    x1: 1742.742,
    x2: 1742.742,
    y1: 458.98,
    y2: 185.431,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9c353f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9c363f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffad80"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 823.789,
    cy: 660.235,
    r: 136.774,
    style: {
      fill: "url(#fV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fW",
    x1: 1738.753,
    x2: 1738.753,
    y1: 459.57,
    y2: 185.848,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9c353f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9c363f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffad80"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 821.096,
    cy: 663.215,
    r: 136.86,
    style: {
      fill: "url(#fW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fX",
    x1: 1734.755,
    x2: 1734.755,
    y1: 460.106,
    y2: 186.21,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9b353f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9b353f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffad80"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 818.36,
    cy: 666.159,
    r: 136.947,
    style: {
      fill: "url(#fX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fY",
    x1: 1730.751,
    x2: 1730.751,
    y1: 460.586,
    y2: 186.517,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9b353f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9b353f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffac80"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 815.583,
    cy: 669.067,
    r: 137.034,
    style: {
      fill: "url(#fY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fZ",
    x1: 1726.74,
    x2: 1726.74,
    y1: 461.012,
    y2: 186.769,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9b3540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9b3540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffac81"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 812.764,
    cy: 671.937,
    r: 137.121,
    style: {
      fill: "url(#fZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ga",
    x1: 1722.724,
    x2: 1722.724,
    y1: 461.382,
    y2: 186.965,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9b3540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9b3540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffac81"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 809.905,
    cy: 674.768,
    r: 137.208,
    style: {
      fill: "url(#ga)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gb",
    x1: 1718.704,
    x2: 1718.704,
    y1: 461.696,
    y2: 187.106,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9b3540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9b3540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffac81"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 807.007,
    cy: 677.561,
    r: 137.295,
    style: {
      fill: "url(#gb)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gc",
    x1: 1714.679,
    x2: 1714.679,
    y1: 461.955,
    y2: 187.191,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9a3540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9a3540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffac81"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 804.068,
    cy: 680.315,
    r: 137.381,
    style: {
      fill: "url(#gc)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gd",
    x1: 1710.651,
    x2: 1710.651,
    y1: 462.158,
    y2: 187.22,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9a3440"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9a3540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffac81"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 801.091,
    cy: 683.029,
    r: 137.468,
    style: {
      fill: "url(#gd)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ge",
    x1: 1706.621,
    x2: 1706.621,
    y1: 462.305,
    y2: 187.194,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9a3440"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9a3540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffac81"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 798.074,
    cy: 685.702,
    r: 137.555,
    style: {
      fill: "url(#ge)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gf",
    x1: 1702.589,
    x2: 1702.589,
    y1: 462.395,
    y2: 187.111,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9a3441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9a3541"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffac81"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 795.02,
    cy: 688.333,
    r: 137.642,
    style: {
      fill: "url(#gf)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gg",
    x1: 1698.557,
    x2: 1698.557,
    y1: 462.429,
    y2: 186.971,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9a3441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#9a3541"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffac81"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 791.928,
    cy: 690.923,
    r: 137.729,
    style: {
      fill: "url(#gg)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gh",
    x1: 1694.525,
    x2: 1694.525,
    y1: 462.407,
    y2: 186.775,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#993441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#993541"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffac81"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 788.798,
    cy: 693.469,
    r: 137.815,
    style: {
      fill: "url(#gh)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gi",
    x1: 1690.493,
    x2: 1690.493,
    y1: 462.328,
    y2: 186.522,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#993441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#993541"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffab82"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 785.632,
    cy: 695.973,
    r: 137.902,
    style: {
      fill: "url(#gi)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gj",
    x1: 1686.463,
    x2: 1686.463,
    y1: 462.192,
    y2: 186.212,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#993441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#993541"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffab82"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 782.429,
    cy: 698.432,
    r: 137.989,
    style: {
      fill: "url(#gj)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gk",
    x1: 1682.435,
    x2: 1682.435,
    y1: 461.998,
    y2: 185.845,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#993441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#993541"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffab82"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 779.191,
    cy: 700.847,
    r: 138.076,
    style: {
      fill: "url(#gk)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gl",
    x1: 1678.411,
    x2: 1678.411,
    y1: 461.747,
    y2: 185.421,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#993442"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#993542"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffab82"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 775.917,
    cy: 703.217,
    r: 138.163,
    style: {
      fill: "url(#gl)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gm",
    x1: 1674.39,
    x2: 1674.39,
    y1: 461.439,
    y2: 184.939,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#983442"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#983542"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffab82"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 772.608,
    cy: 705.541,
    r: 138.25,
    style: {
      fill: "url(#gm)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gn",
    x1: 1670.3,
    x2: 1670.3,
    y1: 461.064,
    y2: 184.39,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#983442"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#983542"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffab82"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 769.203,
    cy: 707.86,
    r: 138.336,
    style: {
      fill: "url(#gn)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "go",
    x1: 1666.216,
    x2: 1666.216,
    y1: 460.63,
    y2: 183.783,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#983442"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#983442"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffab82"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 765.764,
    cy: 710.13,
    r: 138.423,
    style: {
      fill: "url(#go)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp",
    x1: 1662.154,
    x2: 1662.154,
    y1: 460.139,
    y2: 183.118,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#983442"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#983442"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffab82"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 762.304,
    cy: 712.344,
    r: 138.51,
    style: {
      fill: "url(#gp)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gq",
    x1: 1658.113,
    x2: 1658.113,
    y1: 459.592,
    y2: 182.398,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#973443"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#973443"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffab82"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 758.823,
    cy: 714.501,
    r: 138.597,
    style: {
      fill: "url(#gq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gr",
    x1: 1654.095,
    x2: 1654.095,
    y1: 458.99,
    y2: 181.622,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#973443"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#973443"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaa83"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 755.322,
    cy: 716.602,
    r: 138.684,
    style: {
      fill: "url(#gr)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gs",
    x1: 1650.099,
    x2: 1650.099,
    y1: 458.332,
    y2: 180.79,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#973443"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#973443"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaa83"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 751.802,
    cy: 718.646,
    r: 138.77,
    style: {
      fill: "url(#gs)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gt",
    x1: 1646.126,
    x2: 1646.126,
    y1: 457.62,
    y2: 179.904,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#973443"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#973443"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaa83"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 748.263,
    cy: 720.634,
    r: 138.857,
    style: {
      fill: "url(#gt)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gu",
    x1: 1642.175,
    x2: 1642.175,
    y1: 456.853,
    y2: 178.964,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#973443"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#973443"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaa83"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 744.705,
    cy: 722.566,
    r: 138.944,
    style: {
      fill: "url(#gu)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gv",
    x1: 1638.246,
    x2: 1638.246,
    y1: 456.033,
    y2: 177.97,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#963343"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#963443"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaa83"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 741.128,
    cy: 724.443,
    r: 139.031,
    style: {
      fill: "url(#gv)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gw",
    x1: 1634.341,
    x2: 1634.341,
    y1: 455.159,
    y2: 176.922,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#963344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#963444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaa83"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 737.534,
    cy: 726.265,
    r: 139.118,
    style: {
      fill: "url(#gw)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gx",
    x1: 1630.459,
    x2: 1630.459,
    y1: 454.232,
    y2: 175.822,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#963344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#963444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaa83"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 733.923,
    cy: 728.032,
    r: 139.204,
    style: {
      fill: "url(#gx)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gy",
    x1: 1626.6,
    x2: 1626.6,
    y1: 453.253,
    y2: 174.669,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#963344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#963444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaa83"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 730.294,
    cy: 729.744,
    r: 139.291,
    style: {
      fill: "url(#gy)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gz",
    x1: 1622.764,
    x2: 1622.764,
    y1: 452.222,
    y2: 173.465,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#963344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#963444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaa83"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 726.648,
    cy: 731.402,
    r: 139.378,
    style: {
      fill: "url(#gz)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gA",
    x1: 1618.951,
    x2: 1618.951,
    y1: 451.14,
    y2: 172.209,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#953344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#953444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa984"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 722.987,
    cy: 733.005,
    r: 139.465,
    style: {
      fill: "url(#gA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gB",
    x1: 1615.162,
    x2: 1615.162,
    y1: 450.007,
    y2: 170.902,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#953344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#953444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa984"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 719.31,
    cy: 734.555,
    r: 139.552,
    style: {
      fill: "url(#gB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gC",
    x1: 1611.397,
    x2: 1611.397,
    y1: 448.823,
    y2: 169.545,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#953345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#953445"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa984"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 715.617,
    cy: 736.051,
    r: 139.639,
    style: {
      fill: "url(#gC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gD",
    x1: 1607.655,
    x2: 1607.655,
    y1: 447.59,
    y2: 168.138,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#953345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#953445"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa984"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 711.909,
    cy: 737.494,
    r: 139.725,
    style: {
      fill: "url(#gD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gE",
    x1: 1603.938,
    x2: 1603.938,
    y1: 446.307,
    y2: 166.681,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#953345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#953445"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa984"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 708.187,
    cy: 738.883,
    r: 139.812,
    style: {
      fill: "url(#gE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gF",
    x1: 1600.245,
    x2: 1600.245,
    y1: 444.975,
    y2: 165.175,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#943345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#943445"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa984"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 704.451,
    cy: 740.22,
    r: 139.899,
    style: {
      fill: "url(#gF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gG",
    x1: 1596.575,
    x2: 1596.575,
    y1: 443.594,
    y2: 163.621,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#943345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#943345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa984"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 700.701,
    cy: 741.505,
    r: 139.986,
    style: {
      fill: "url(#gG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gH",
    x1: 1592.931,
    x2: 1592.931,
    y1: 442.165,
    y2: 162.019,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#943346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#943346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa984"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 696.938,
    cy: 742.737,
    r: 140.073,
    style: {
      fill: "url(#gH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gI",
    x1: 1589.311,
    x2: 1589.311,
    y1: 440.689,
    y2: 160.369,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#943346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#943346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa984"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 693.162,
    cy: 743.917,
    r: 140.159,
    style: {
      fill: "url(#gI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gJ",
    x1: 1585.715,
    x2: 1585.715,
    y1: 439.166,
    y2: 158.672,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#943346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#943346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa885"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 689.373,
    cy: 745.045,
    r: 140.246,
    style: {
      fill: "url(#gJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gK",
    x1: 1582.144,
    x2: 1582.144,
    y1: 437.596,
    y2: 156.929,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#933346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#933346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa885"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 685.573,
    cy: 746.122,
    r: 140.333,
    style: {
      fill: "url(#gK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gL",
    x1: 1578.599,
    x2: 1578.599,
    y1: 435.98,
    y2: 155.139,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#933346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#933346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa885"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 681.761,
    cy: 747.148,
    r: 140.42,
    style: {
      fill: "url(#gL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gM",
    x1: 1575.078,
    x2: 1575.078,
    y1: 434.318,
    y2: 153.303,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#933346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#933346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa885"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 677.938,
    cy: 748.123,
    r: 140.507,
    style: {
      fill: "url(#gM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gN",
    x1: 1571.583,
    x2: 1571.583,
    y1: 432.611,
    y2: 151.423,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#933247"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#933347"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa885"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 674.104,
    cy: 749.047,
    r: 140.594,
    style: {
      fill: "url(#gN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gO",
    x1: 1568.113,
    x2: 1568.113,
    y1: 430.859,
    y2: 149.497,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#923247"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#923347"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa885"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 670.259,
    cy: 749.921,
    r: 140.68,
    style: {
      fill: "url(#gO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gP",
    x1: 1564.668,
    x2: 1564.668,
    y1: 429.063,
    y2: 147.528,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#923247"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#923347"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa885"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 666.405,
    cy: 750.744,
    r: 140.767,
    style: {
      fill: "url(#gP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gQ",
    x1: 1561.249,
    x2: 1561.249,
    y1: 427.223,
    y2: 145.514,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#923247"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#923347"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa885"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 662.541,
    cy: 751.518,
    r: 140.854,
    style: {
      fill: "url(#gQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gR",
    x1: 1557.856,
    x2: 1557.856,
    y1: 425.341,
    y2: 143.458,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#923247"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#923347"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa886"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 658.668,
    cy: 752.242,
    r: 140.941,
    style: {
      fill: "url(#gR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gS",
    x1: 1554.489,
    x2: 1554.489,
    y1: 423.415,
    y2: 141.358,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#923247"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#923347"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa886"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 654.787,
    cy: 752.917,
    r: 141.028,
    style: {
      fill: "url(#gS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gT",
    x1: 1551.148,
    x2: 1551.148,
    y1: 421.446,
    y2: 139.216,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#913248"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#913348"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa786"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 650.897,
    cy: 753.542,
    r: 141.114,
    style: {
      fill: "url(#gT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gU",
    x1: 1547.833,
    x2: 1547.833,
    y1: 419.436,
    y2: 137.033,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#913248"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#913348"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa786"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 647,
    cy: 754.119,
    r: 141.201,
    style: {
      fill: "url(#gU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gV",
    x1: 1544.545,
    x2: 1544.545,
    y1: 417.385,
    y2: 134.808,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#913248"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#913348"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa786"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 643.095,
    cy: 754.648,
    r: 141.288,
    style: {
      fill: "url(#gV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gW",
    x1: 1541.283,
    x2: 1541.283,
    y1: 415.293,
    y2: 132.542,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#913248"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#913348"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa786"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 639.183,
    cy: 755.128,
    r: 141.375,
    style: {
      fill: "url(#gW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gX",
    x1: 1538.048,
    x2: 1538.048,
    y1: 413.16,
    y2: 130.235,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#913248"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#913248"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa786"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 635.265,
    cy: 755.56,
    r: 141.462,
    style: {
      fill: "url(#gX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gY",
    x1: 1534.84,
    x2: 1534.84,
    y1: 410.987,
    y2: 127.889,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#903249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#903249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa786"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 631.34,
    cy: 755.944,
    r: 141.549,
    style: {
      fill: "url(#gY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gZ",
    x1: 1531.658,
    x2: 1531.658,
    y1: 408.775,
    y2: 125.503,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#903249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#903249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa786"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 627.41,
    cy: 756.281,
    r: 141.635,
    style: {
      fill: "url(#gZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ha",
    x1: 1528.503,
    x2: 1528.503,
    y1: 406.524,
    y2: 123.078,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#903249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#903249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa787"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 623.474,
    cy: 756.571,
    r: 141.722,
    style: {
      fill: "url(#ha)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hb",
    x1: 1525.376,
    x2: 1525.376,
    y1: 404.234,
    y2: 120.615,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#903249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#903249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa787"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 619.534,
    cy: 756.814,
    r: 141.809,
    style: {
      fill: "url(#hb)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hc",
    x1: 1522.276,
    x2: 1522.276,
    y1: 401.906,
    y2: 118.114,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#903249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#903249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa687"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 615.589,
    cy: 757.01,
    r: 141.896,
    style: {
      fill: "url(#hc)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hd",
    x1: 1519.204,
    x2: 1519.204,
    y1: 399.541,
    y2: 115.575,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8f3249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8f3249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa687"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 611.64,
    cy: 757.16,
    r: 141.983,
    style: {
      fill: "url(#hd)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "he",
    x1: 1516.159,
    x2: 1516.159,
    y1: 397.139,
    y2: 112.999,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8f324a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8f324a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa687"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 607.687,
    cy: 757.263,
    r: 142.069,
    style: {
      fill: "url(#he)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hf",
    x1: 1513.142,
    x2: 1513.142,
    y1: 394.7,
    y2: 110.386,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8f314a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8f324a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa687"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 603.732,
    cy: 757.321,
    r: 142.156,
    style: {
      fill: "url(#hf)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hg",
    x1: 1510.152,
    x2: 1510.152,
    y1: 392.225,
    y2: 107.737,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8f314a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8f324a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa687"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 599.773,
    cy: 757.333,
    r: 142.243,
    style: {
      fill: "url(#hg)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hh",
    x1: 1507.191,
    x2: 1507.191,
    y1: 389.714,
    y2: 105.053,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8f314a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8f324a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa687"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 595.812,
    cy: 757.3,
    r: 142.33,
    style: {
      fill: "url(#hh)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hi",
    x1: 1504.258,
    x2: 1504.258,
    y1: 387.168,
    y2: 102.333,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8e314a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8e324a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa687"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 591.849,
    cy: 757.222,
    r: 142.417,
    style: {
      fill: "url(#hi)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hj",
    x1: 1501.354,
    x2: 1501.354,
    y1: 384.587,
    y2: 99.579,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8e314a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8e324a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa688"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 587.885,
    cy: 757.099,
    r: 142.503,
    style: {
      fill: "url(#hj)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hk",
    x1: 1498.477,
    x2: 1498.477,
    y1: 381.972,
    y2: 96.79,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8e314b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8e324b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa688"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 583.919,
    cy: 756.931,
    r: 142.59,
    style: {
      fill: "url(#hk)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hl",
    x1: 1495.63,
    x2: 1495.63,
    y1: 379.324,
    y2: 93.968,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8e314b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8e324b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa588"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 579.953,
    cy: 756.719,
    r: 142.677,
    style: {
      fill: "url(#hl)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hm",
    x1: 1492.811,
    x2: 1492.811,
    y1: 376.642,
    y2: 91.112,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8d314b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8d324b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa588"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 575.987,
    cy: 756.463,
    r: 142.764,
    style: {
      fill: "url(#hm)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hn",
    x1: 1490.021,
    x2: 1490.021,
    y1: 373.927,
    y2: 88.224,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8d314b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8d324b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa588"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 572.021,
    cy: 756.164,
    r: 142.851,
    style: {
      fill: "url(#hn)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ho",
    x1: 1487.26,
    x2: 1487.26,
    y1: 371.18,
    y2: 85.303,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8d314b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8d314b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa588"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 568.055,
    cy: 755.821,
    r: 142.938,
    style: {
      fill: "url(#ho)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hp",
    x1: 1484.529,
    x2: 1484.529,
    y1: 368.401,
    y2: 82.351,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8d314c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8d314c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa588"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 564.09,
    cy: 755.435,
    r: 143.024,
    style: {
      fill: "url(#hp)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hq",
    x1: 1481.826,
    x2: 1481.826,
    y1: 365.59,
    y2: 79.367,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8d314c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8d314c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa588"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 560.127,
    cy: 755.005,
    r: 143.111,
    style: {
      fill: "url(#hq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hr",
    x1: 1479.153,
    x2: 1479.153,
    y1: 362.749,
    y2: 76.352,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8c314c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8c314c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa588"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 556.165,
    cy: 754.534,
    r: 143.198,
    style: {
      fill: "url(#hr)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hs",
    x1: 1476.51,
    x2: 1476.51,
    y1: 359.878,
    y2: 73.307,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8c314c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8c314c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa589"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 552.206,
    cy: 754.019,
    r: 143.285,
    style: {
      fill: "url(#hs)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ht",
    x1: 1473.896,
    x2: 1473.896,
    y1: 356.976,
    y2: 70.231,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8c314c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8c314c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa589"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 548.25,
    cy: 753.463,
    r: 143.372,
    style: {
      fill: "url(#ht)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hu",
    x1: 1471.312,
    x2: 1471.312,
    y1: 354.045,
    y2: 67.127,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8c314c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8c314c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa589"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 544.296,
    cy: 752.865,
    r: 143.458,
    style: {
      fill: "url(#hu)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hv",
    x1: 1468.758,
    x2: 1468.758,
    y1: 351.085,
    y2: 63.993,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8c314d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8c314d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa489"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 540.346,
    cy: 752.225,
    r: 143.545,
    style: {
      fill: "url(#hv)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hw",
    x1: 1466.235,
    x2: 1466.235,
    y1: 348.096,
    y2: 60.831,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8b304d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8b314d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa489"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 536.4,
    cy: 751.544,
    r: 143.632,
    style: {
      fill: "url(#hw)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hx",
    x1: 1463.741,
    x2: 1463.741,
    y1: 345.08,
    y2: 57.641,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8b304d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8b314d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa489"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 532.458,
    cy: 750.822,
    r: 143.719,
    style: {
      fill: "url(#hx)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hy",
    x1: 1461.278,
    x2: 1461.278,
    y1: 342.036,
    y2: 54.423,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8b304d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8b314d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa489"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 528.521,
    cy: 750.059,
    r: 143.806,
    style: {
      fill: "url(#hy)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hz",
    x1: 1458.846,
    x2: 1458.846,
    y1: 338.965,
    y2: 51.178,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8b304d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8b314d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa489"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 524.59,
    cy: 749.255,
    r: 143.893,
    style: {
      fill: "url(#hz)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hA",
    x1: 1456.444,
    x2: 1456.444,
    y1: 335.867,
    y2: 47.907,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8b304d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8b314d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa489"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 520.664,
    cy: 748.411,
    r: 143.979,
    style: {
      fill: "url(#hA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hB",
    x1: 1454.073,
    x2: 1454.073,
    y1: 332.743,
    y2: 44.609,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8a304e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8a314e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa48a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 516.743,
    cy: 747.528,
    r: 144.066,
    style: {
      fill: "url(#hB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hC",
    x1: 1451.734,
    x2: 1451.734,
    y1: 329.593,
    y2: 41.286,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8a304e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8a314e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa48a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 512.83,
    cy: 746.604,
    r: 144.153,
    style: {
      fill: "url(#hC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hD",
    x1: 1449.425,
    x2: 1449.425,
    y1: 326.419,
    y2: 37.938,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8a304e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8a314e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa48a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 508.923,
    cy: 745.641,
    r: 144.24,
    style: {
      fill: "url(#hD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hE",
    x1: 1447.148,
    x2: 1447.148,
    y1: 323.219,
    y2: 34.565,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8a304e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8a314e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa38a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 505.023,
    cy: 744.639,
    r: 144.327,
    style: {
      fill: "url(#hE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hF",
    x1: 1444.901,
    x2: 1444.901,
    y1: 319.996,
    y2: 31.168,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8a304e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#8a314e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa38a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 501.132,
    cy: 743.598,
    r: 144.413,
    style: {
      fill: "url(#hF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hG",
    x1: 1442.687,
    x2: 1442.687,
    y1: 316.748,
    y2: 27.747,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#89304f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#89304f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa38a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 497.248,
    cy: 742.518,
    r: 144.5,
    style: {
      fill: "url(#hG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hH",
    x1: 1440.504,
    x2: 1440.504,
    y1: 313.478,
    y2: 24.302,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#89304f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#89304f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa38a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 493.373,
    cy: 741.4,
    r: 144.587,
    style: {
      fill: "url(#hH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hI",
    x1: 1438.353,
    x2: 1438.353,
    y1: 310.184,
    y2: 20.835,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#89304f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#89304f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa38a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 489.506,
    cy: 740.244,
    r: 144.674,
    style: {
      fill: "url(#hI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hJ",
    x1: 1436.234,
    x2: 1436.234,
    y1: 306.868,
    y2: 17.346,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#89304f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#89304f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa38a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 485.65,
    cy: 739.05,
    r: 144.761,
    style: {
      fill: "url(#hJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hK",
    x1: 1434.147,
    x2: 1434.147,
    y1: 303.531,
    y2: 13.835,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88304f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#88304f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa38b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 481.802,
    cy: 737.818,
    r: 144.848,
    style: {
      fill: "url(#hK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hL",
    x1: 1432.093,
    x2: 1432.093,
    y1: 300.172,
    y2: 10.302,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88304f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#88304f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa38b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 477.966,
    cy: 736.549,
    r: 144.934,
    style: {
      fill: "url(#hL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hM",
    x1: 1430.07,
    x2: 1430.07,
    y1: 296.792,
    y2: 6.749,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#883050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#883050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa38b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 474.139,
    cy: 735.243,
    r: 145.021,
    style: {
      fill: "url(#hM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hN",
    x1: 1428.081,
    x2: 1428.081,
    y1: 293.392,
    y2: 3.175,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#883050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#883050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa28b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 470.324,
    cy: 733.9,
    r: 145.108,
    style: {
      fill: "url(#hN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hO",
    x1: 1426.124,
    x2: 1426.124,
    y1: 289.972,
    y2: -0.419,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#882f50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#883050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa28b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 466.521,
    cy: 732.52,
    r: 145.195,
    style: {
      fill: "url(#hO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hP",
    x1: 1424.199,
    x2: 1424.199,
    y1: 286.532,
    y2: -4.032,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#872f50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#873050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa28b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 462.729,
    cy: 731.105,
    r: 145.282,
    style: {
      fill: "url(#hP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hQ",
    x1: 1422.308,
    x2: 1422.308,
    y1: 283.074,
    y2: -7.664,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#872f50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#873050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa28b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 458.949,
    cy: 729.653,
    r: 145.368,
    style: {
      fill: "url(#hQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hR",
    x1: 1420.45,
    x2: 1420.45,
    y1: 279.597,
    y2: -11.315,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#872f50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#873050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa28b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 455.183,
    cy: 728.166,
    r: 145.455,
    style: {
      fill: "url(#hR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hS",
    x1: 1418.625,
    x2: 1418.625,
    y1: 276.101,
    y2: -14.984,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#872f51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#873051"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa28b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 451.429,
    cy: 726.643,
    r: 145.542,
    style: {
      fill: "url(#hS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hT",
    x1: 1416.833,
    x2: 1416.833,
    y1: 272.589,
    y2: -18.67,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#872f51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#873051"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa28c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 447.689,
    cy: 725.085,
    r: 145.629,
    style: {
      fill: "url(#hT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hU",
    x1: 1415.075,
    x2: 1415.075,
    y1: 269.059,
    y2: -22.373,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#862f51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#863051"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa28c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 443.963,
    cy: 723.492,
    r: 145.716,
    style: {
      fill: "url(#hU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hV",
    x1: 1413.351,
    x2: 1413.351,
    y1: 265.513,
    y2: -26.093,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#862f51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#863051"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa28c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 440.252,
    cy: 721.864,
    r: 145.803,
    style: {
      fill: "url(#hV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hW",
    x1: 1411.66,
    x2: 1411.66,
    y1: 261.95,
    y2: -29.829,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#862f51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#863051"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa28c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 436.555,
    cy: 720.202,
    r: 145.889,
    style: {
      fill: "url(#hW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hX",
    x1: 1410.004,
    x2: 1410.004,
    y1: 258.373,
    y2: -33.581,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#862f52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#862f52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa18c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 432.873,
    cy: 718.506,
    r: 145.976,
    style: {
      fill: "url(#hX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hY",
    x1: 1408.381,
    x2: 1408.381,
    y1: 254.779,
    y2: -37.348,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#862f52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#862f52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa18c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 429.207,
    cy: 716.776,
    r: 146.063,
    style: {
      fill: "url(#hY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hZ",
    x1: 1406.793,
    x2: 1406.793,
    y1: 251.171,
    y2: -41.129,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#852f52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#852f52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa18c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 425.558,
    cy: 715.012,
    r: 146.15,
    style: {
      fill: "url(#hZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ia",
    x1: 1405.239,
    x2: 1405.239,
    y1: 247.549,
    y2: -44.925,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#852f52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#852f52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa18c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 421.924,
    cy: 713.215,
    r: 146.237,
    style: {
      fill: "url(#ia)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ib",
    x1: 1403.719,
    x2: 1403.719,
    y1: 243.914,
    y2: -48.734,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#852f52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#852f52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa18c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 418.308,
    cy: 711.385,
    r: 146.323,
    style: {
      fill: "url(#ib)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic",
    x1: 1402.234,
    x2: 1402.234,
    y1: 240.264,
    y2: -52.557,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#852f52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#852f52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa18d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 414.709,
    cy: 709.523,
    r: 146.41,
    style: {
      fill: "url(#ic)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id",
    x1: 1400.784,
    x2: 1400.784,
    y1: 236.603,
    y2: -56.392,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#852f53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#852f53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa18d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 411.128,
    cy: 707.627,
    r: 146.497,
    style: {
      fill: "url(#id)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ie",
    x1: 1399.369,
    x2: 1399.369,
    y1: 232.929,
    y2: -60.24,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#842f53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#842f53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa18d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 407.565,
    cy: 705.7,
    r: 146.584,
    style: {
      fill: "url(#ie)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "if",
    x1: 1397.989,
    x2: 1397.989,
    y1: 229.243,
    y2: -64.1,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#842f53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#842f53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa18d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 404.02,
    cy: 703.74,
    r: 146.671,
    style: {
      fill: "url(#if)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig",
    x1: 1396.644,
    x2: 1396.644,
    y1: 225.545,
    y2: -67.971,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#842e53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#842f53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa08d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 400.495,
    cy: 701.749,
    r: 146.757,
    style: {
      fill: "url(#ig)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ih",
    x1: 1395.334,
    x2: 1395.334,
    y1: 221.837,
    y2: -71.853,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#842e53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#842f53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa08d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 396.989,
    cy: 699.726,
    r: 146.844,
    style: {
      fill: "url(#ih)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ii",
    x1: 1394.06,
    x2: 1394.06,
    y1: 218.119,
    y2: -75.745,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#832e53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#832f53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa08d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 393.503,
    cy: 697.672,
    r: 146.931,
    style: {
      fill: "url(#ii)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ij",
    x1: 1392.822,
    x2: 1392.822,
    y1: 214.39,
    y2: -79.647,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#832e54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#832f54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa08d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 390.037,
    cy: 695.588,
    r: 147.018,
    style: {
      fill: "url(#ij)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ik",
    x1: 1391.619,
    x2: 1391.619,
    y1: 210.652,
    y2: -83.558,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#832e54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#832f54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa08e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 386.592,
    cy: 693.472,
    r: 147.105,
    style: {
      fill: "url(#ik)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "il",
    x1: 1390.452,
    x2: 1390.452,
    y1: 206.905,
    y2: -87.479,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#832e54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#832f54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa08e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 383.168,
    cy: 691.326,
    r: 147.192,
    style: {
      fill: "url(#il)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "im",
    x1: 1389.321,
    x2: 1389.321,
    y1: 203.15,
    y2: -91.408,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#832e54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#832f54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa08e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 379.765,
    cy: 689.15,
    r: 147.278,
    style: {
      fill: "url(#im)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "in",
    x1: 1388.226,
    x2: 1388.226,
    y1: 199.387,
    y2: -95.345,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#822e54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#822f54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa08e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 376.385,
    cy: 686.944,
    r: 147.365,
    style: {
      fill: "url(#in)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "io",
    x1: 1387.168,
    x2: 1387.168,
    y1: 195.616,
    y2: -99.289,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#822e54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#822f54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa08e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 373.027,
    cy: 684.709,
    r: 147.452,
    style: {
      fill: "url(#io)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ip",
    x1: 1386.146,
    x2: 1386.146,
    y1: 191.838,
    y2: -103.241,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#822e55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#822e55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9f8e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 369.691,
    cy: 682.444,
    r: 147.539,
    style: {
      fill: "url(#ip)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iq",
    x1: 1385.161,
    x2: 1385.161,
    y1: 188.054,
    y2: -107.199,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#822e55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#822e55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9f8e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 366.379,
    cy: 680.15,
    r: 147.626,
    style: {
      fill: "url(#iq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ir",
    x1: 1384.212,
    x2: 1384.212,
    y1: 184.263,
    y2: -111.163,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#822e55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#822e55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9f8e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 363.09,
    cy: 677.828,
    r: 147.712,
    style: {
      fill: "url(#ir)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "is",
    x1: 1383.301,
    x2: 1383.301,
    y1: 180.467,
    y2: -115.133,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#812e55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#812e55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9f8e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 359.826,
    cy: 675.477,
    r: 147.799,
    style: {
      fill: "url(#is)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "it",
    x1: 1382.426,
    x2: 1382.426,
    y1: 176.665,
    y2: -119.108,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#812e55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#812e55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9f8f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 356.586,
    cy: 673.097,
    r: 147.886,
    style: {
      fill: "url(#it)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iu",
    x1: 1381.589,
    x2: 1381.589,
    y1: 172.859,
    y2: -123.088,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#812e56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#812e56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9f8f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 353.371,
    cy: 670.69,
    r: 147.973,
    style: {
      fill: "url(#iu)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iv",
    x1: 1380.788,
    x2: 1380.788,
    y1: 169.049,
    y2: -127.072,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#812e56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#812e56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9f8f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 350.181,
    cy: 668.255,
    r: 148.06,
    style: {
      fill: "url(#iv)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iw",
    x1: 1380.026,
    x2: 1380.026,
    y1: 165.235,
    y2: -131.059,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#812e56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#812e56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9f8f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 347.017,
    cy: 665.792,
    r: 148.147,
    style: {
      fill: "url(#iw)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix",
    x1: 1379.3,
    x2: 1379.3,
    y1: 161.418,
    y2: -135.05,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#802e56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#802e56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9f8f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 343.879,
    cy: 663.303,
    r: 148.233,
    style: {
      fill: "url(#ix)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iy",
    x1: 1378.613,
    x2: 1378.613,
    y1: 157.598,
    y2: -139.043,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#802d56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#802e56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9f8f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 340.768,
    cy: 660.786,
    r: 148.32,
    style: {
      fill: "url(#iy)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iz",
    x1: 1377.963,
    x2: 1377.963,
    y1: 153.776,
    y2: -143.039,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#802d56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#802e56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9e8f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 337.684,
    cy: 658.243,
    r: 148.407,
    style: {
      fill: "url(#iz)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iA",
    x1: 1377.352,
    x2: 1377.352,
    y1: 149.952,
    y2: -147.037,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#802d57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#802e57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9e8f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 334.627,
    cy: 655.673,
    r: 148.494,
    style: {
      fill: "url(#iA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iB",
    x1: 1376.778,
    x2: 1376.778,
    y1: 146.126,
    y2: -151.036,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#802d57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#802e57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9e8f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 331.598,
    cy: 653.077,
    r: 148.581,
    style: {
      fill: "url(#iB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iC",
    x1: 1376.243,
    x2: 1376.243,
    y1: 142.3,
    y2: -155.036,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7f2d57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7f2e57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9e90"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 328.597,
    cy: 650.456,
    r: 148.667,
    style: {
      fill: "url(#iC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iD",
    x1: 1375.746,
    x2: 1375.746,
    y1: 138.474,
    y2: -159.036,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7f2d57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7f2e57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9e90"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 325.624,
    cy: 647.808,
    r: 148.754,
    style: {
      fill: "url(#iD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iE",
    x1: 1375.288,
    x2: 1375.288,
    y1: 134.647,
    y2: -163.036,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7f2d57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7f2e57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9e90"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 322.681,
    cy: 645.136,
    r: 148.841,
    style: {
      fill: "url(#iE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iF",
    x1: 1374.869,
    x2: 1374.869,
    y1: 130.821,
    y2: -167.036,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7f2d57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7f2e57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9e90"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 319.768,
    cy: 642.438,
    r: 148.928,
    style: {
      fill: "url(#iF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iG",
    x1: 1374.488,
    x2: 1374.488,
    y1: 126.996,
    y2: -171.034,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7e2d58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7e2d58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9e90"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 316.884,
    cy: 639.716,
    r: 149.015,
    style: {
      fill: "url(#iG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iH",
    x1: 1374.147,
    x2: 1374.147,
    y1: 123.173,
    y2: -175.031,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7e2d58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7e2d58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9e90"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 314.031,
    cy: 636.969,
    r: 149.102,
    style: {
      fill: "url(#iH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iI",
    x1: 1373.844,
    x2: 1373.844,
    y1: 119.352,
    y2: -179.026,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7e2d58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7e2d58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9d90"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 311.208,
    cy: 634.198,
    r: 149.188,
    style: {
      fill: "url(#iI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iJ",
    x1: 1373.581,
    x2: 1373.581,
    y1: 115.533,
    y2: -183.019,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7e2d58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7e2d58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9d90"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 308.417,
    cy: 631.402,
    r: 149.275,
    style: {
      fill: "url(#iJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iK",
    x1: 1373.357,
    x2: 1373.357,
    y1: 111.717,
    y2: -187.008,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7e2d58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7e2d58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9d90"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 305.657,
    cy: 628.583,
    r: 149.362,
    style: {
      fill: "url(#iK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iL",
    x1: 1373.173,
    x2: 1373.173,
    y1: 107.904,
    y2: -190.994,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7d2d59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7d2d59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9d91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 302.929,
    cy: 625.741,
    r: 149.449,
    style: {
      fill: "url(#iL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iM",
    x1: 1373.028,
    x2: 1373.028,
    y1: 104.096,
    y2: -194.976,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7d2d59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7d2d59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9d91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 300.234,
    cy: 622.876,
    r: 149.536,
    style: {
      fill: "url(#iM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iN",
    x1: 1372.923,
    x2: 1372.923,
    y1: 100.292,
    y2: -198.954,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7d2d59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7d2d59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9d91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 297.571,
    cy: 619.987,
    r: 149.622,
    style: {
      fill: "url(#iN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iO",
    x1: 1372.858,
    x2: 1372.858,
    y1: 96.493,
    y2: -202.927,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7d2d59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7d2d59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9d91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 294.942,
    cy: 617.076,
    r: 149.709,
    style: {
      fill: "url(#iO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iP",
    x1: 1372.834,
    x2: 1372.834,
    y1: 92.698,
    y2: -206.895,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7d2d59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7d2d59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9d91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 292.347,
    cy: 614.143,
    r: 149.796,
    style: {
      fill: "url(#iP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iQ",
    x1: 1372.849,
    x2: 1372.849,
    y1: 88.91,
    y2: -210.856,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7c2c59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7c2d59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9d91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 289.785,
    cy: 611.187,
    r: 149.883,
    style: {
      fill: "url(#iQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iR",
    x1: 1372.905,
    x2: 1372.905,
    y1: 85.129,
    y2: -214.812,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7c2c5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7c2d5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9c91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 287.259,
    cy: 608.21,
    r: 149.97,
    style: {
      fill: "url(#iR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iS",
    x1: 1373.002,
    x2: 1373.002,
    y1: 81.354,
    y2: -218.761,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7c2c5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7c2d5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9c91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 284.767,
    cy: 605.211,
    r: 150.056,
    style: {
      fill: "url(#iS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iT",
    x1: 1373.139,
    x2: 1373.139,
    y1: 77.586,
    y2: -222.702,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7c2c5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7c2d5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9c91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 282.31,
    cy: 602.19,
    r: 150.143,
    style: {
      fill: "url(#iT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iU",
    x1: 1373.318,
    x2: 1373.318,
    y1: 73.81,
    y2: -226.651,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7c2c5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7c2d5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9c92"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 279.88,
    cy: 599.136,
    r: 150.23,
    style: {
      fill: "url(#iU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iV",
    x1: 1373.543,
    x2: 1373.543,
    y1: 70.02,
    y2: -230.615,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7b2c5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7b2d5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9c92"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 277.475,
    cy: 596.041,
    r: 150.317,
    style: {
      fill: "url(#iV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iW",
    x1: 1373.812,
    x2: 1373.812,
    y1: 66.227,
    y2: -234.582,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7b2c5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7b2d5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9c92"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 275.102,
    cy: 592.914,
    r: 150.404,
    style: {
      fill: "url(#iW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iX",
    x1: 1374.127,
    x2: 1374.127,
    y1: 62.432,
    y2: -238.55,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7b2c5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7b2d5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9c92"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 272.761,
    cy: 589.756,
    r: 150.491,
    style: {
      fill: "url(#iX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iY",
    x1: 1374.487,
    x2: 1374.487,
    y1: 58.635,
    y2: -242.521,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7b2c5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7b2c5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9c92"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 270.453,
    cy: 586.568,
    r: 150.577,
    style: {
      fill: "url(#iY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iZ",
    x1: 1374.892,
    x2: 1374.892,
    y1: 54.837,
    y2: -246.492,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7b2c5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7b2c5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9c92"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 268.178,
    cy: 583.348,
    r: 150.664,
    style: {
      fill: "url(#iZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ja",
    x1: 1375.341,
    x2: 1375.341,
    y1: 51.039,
    y2: -250.464,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7a2c5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7a2c5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9c92"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 265.937,
    cy: 580.1,
    r: 150.751,
    style: {
      fill: "url(#ja)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jb",
    x1: 1375.835,
    x2: 1375.835,
    y1: 47.241,
    y2: -254.436,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7a2c5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7a2c5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9b92"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 263.728,
    cy: 576.822,
    r: 150.838,
    style: {
      fill: "url(#jb)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jc",
    x1: 1376.372,
    x2: 1376.372,
    y1: 43.444,
    y2: -258.407,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7a2c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7a2c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9b92"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 261.554,
    cy: 573.515,
    r: 150.925,
    style: {
      fill: "url(#jc)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jd",
    x1: 1376.954,
    x2: 1376.954,
    y1: 39.648,
    y2: -262.377,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7a2c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#7a2c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9b93"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 259.414,
    cy: 570.181,
    r: 151.011,
    style: {
      fill: "url(#jd)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "je",
    x1: 1377.58,
    x2: 1377.58,
    y1: 35.854,
    y2: -266.344,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#792c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#792c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9b93"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 257.308,
    cy: 566.819,
    r: 151.098,
    style: {
      fill: "url(#je)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jf",
    x1: 1378.249,
    x2: 1378.249,
    y1: 32.062,
    y2: -270.309,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#792c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#792c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9b93"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 255.236,
    cy: 563.431,
    r: 151.185,
    style: {
      fill: "url(#jf)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jg",
    x1: 1378.962,
    x2: 1378.962,
    y1: 28.274,
    y2: -274.271,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#792c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#792c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9b93"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 253.199,
    cy: 560.016,
    r: 151.272,
    style: {
      fill: "url(#jg)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jh",
    x1: 1379.718,
    x2: 1379.718,
    y1: 24.489,
    y2: -278.229,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#792b5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#792c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9b93"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 251.198,
    cy: 556.576,
    r: 151.359,
    style: {
      fill: "url(#jh)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ji",
    x1: 1380.517,
    x2: 1380.517,
    y1: 20.709,
    y2: -282.183,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#792b5d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#792c5d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9b93"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 249.231,
    cy: 553.11,
    r: 151.446,
    style: {
      fill: "url(#ji)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jj",
    x1: 1381.359,
    x2: 1381.359,
    y1: 16.934,
    y2: -286.132,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#782b5d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#782c5d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9b93"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 247.301,
    cy: 549.62,
    r: 151.532,
    style: {
      fill: "url(#jj)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jk",
    x1: 1382.244,
    x2: 1382.244,
    y1: 13.165,
    y2: -290.075,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#782b5d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#782c5d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9a93"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 245.406,
    cy: 546.106,
    r: 151.619,
    style: {
      fill: "url(#jk)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jl",
    x1: 1383.171,
    x2: 1383.171,
    y1: 9.401,
    y2: -294.012,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#782b5d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#782c5d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9a93"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 243.547,
    cy: 542.568,
    r: 151.706,
    style: {
      fill: "url(#jl)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jm",
    x1: 1384.141,
    x2: 1384.141,
    y1: 5.645,
    y2: -297.942,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#782b5d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#782c5d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9a94"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 241.725,
    cy: 539.008,
    r: 151.793,
    style: {
      fill: "url(#jm)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jn",
    x1: 1385.154,
    x2: 1385.154,
    y1: 1.896,
    y2: -301.865,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#782b5d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#782c5d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9a94"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 239.939,
    cy: 535.425,
    r: 151.88,
    style: {
      fill: "url(#jn)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jo",
    x1: 1386.208,
    x2: 1386.208,
    y1: -1.845,
    y2: -305.779,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#772b5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#772c5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9a94"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 238.19,
    cy: 531.821,
    r: 151.966,
    style: {
      fill: "url(#jo)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jp",
    x1: 1387.304,
    x2: 1387.304,
    y1: -5.578,
    y2: -309.686,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#772b5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#772b5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9a94"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 236.479,
    cy: 528.196,
    r: 152.053,
    style: {
      fill: "url(#jp)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jq",
    x1: 1388.442,
    x2: 1388.442,
    y1: -9.301,
    y2: -313.583,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#772b5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#772b5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9a94"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 234.805,
    cy: 524.55,
    r: 152.14,
    style: {
      fill: "url(#jq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jr",
    x1: 1389.621,
    x2: 1389.621,
    y1: -13.015,
    y2: -317.47,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#772b5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#772b5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9a94"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 233.169,
    cy: 520.884,
    r: 152.227,
    style: {
      fill: "url(#jr)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "js",
    x1: 1390.842,
    x2: 1390.842,
    y1: -16.718,
    y2: -321.347,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#772b5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#772b5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9a94"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 231.57,
    cy: 517.199,
    r: 152.314,
    style: {
      fill: "url(#js)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jt",
    x1: 1392.104,
    x2: 1392.104,
    y1: -20.41,
    y2: -325.213,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#762b5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#762b5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9994"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 230.01,
    cy: 513.495,
    r: 152.4,
    style: {
      fill: "url(#jt)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ju",
    x1: 1393.407,
    x2: 1393.407,
    y1: -24.091,
    y2: -329.067,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#762b5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#762b5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9994"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 228.488,
    cy: 509.772,
    r: 152.487,
    style: {
      fill: "url(#ju)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jv",
    x1: 1394.751,
    x2: 1394.751,
    y1: -27.759,
    y2: -332.909,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#762b5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#762b5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9995"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 227.006,
    cy: 506.032,
    r: 152.574,
    style: {
      fill: "url(#jv)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jw",
    x1: 1396.136,
    x2: 1396.136,
    y1: -31.415,
    y2: -336.738,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#762b5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#762b5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9995"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 225.562,
    cy: 502.275,
    r: 152.661,
    style: {
      fill: "url(#jw)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jx",
    x1: 1397.561,
    x2: 1397.561,
    y1: -35.057,
    y2: -340.554,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#762b5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#762b5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9995"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 224.157,
    cy: 498.501,
    r: 152.748,
    style: {
      fill: "url(#jx)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jy",
    x1: 1399.026,
    x2: 1399.026,
    y1: -38.685,
    y2: -344.356,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#752b5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#752b5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9995"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 222.792,
    cy: 494.711,
    r: 152.835,
    style: {
      fill: "url(#jy)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jz",
    x1: 1400.532,
    x2: 1400.532,
    y1: -42.299,
    y2: -348.143,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#752a60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#752b60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9995"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 221.467,
    cy: 490.906,
    r: 152.921,
    style: {
      fill: "url(#jz)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jA",
    x1: 1402.077,
    x2: 1402.077,
    y1: -45.897,
    y2: -351.915,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#752a60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#752b60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9995"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 220.182,
    cy: 487.086,
    r: 153.008,
    style: {
      fill: "url(#jA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jB",
    x1: 1403.662,
    x2: 1403.662,
    y1: -49.479,
    y2: -355.671,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#752a60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#752b60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9995"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 218.937,
    cy: 483.252,
    r: 153.095,
    style: {
      fill: "url(#jB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jC",
    x1: 1405.287,
    x2: 1405.287,
    y1: -53.045,
    y2: -359.41,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#742a60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#742b60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9995"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 217.733,
    cy: 479.404,
    r: 153.182,
    style: {
      fill: "url(#jC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jD",
    x1: 1406.951,
    x2: 1406.951,
    y1: -56.594,
    y2: -363.133,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#742a60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#742b60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9896"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 216.57,
    cy: 475.542,
    r: 153.269,
    style: {
      fill: "url(#jD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jE",
    x1: 1408.655,
    x2: 1408.655,
    y1: -60.126,
    y2: -366.838,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#742a60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#742b60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9896"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 215.448,
    cy: 471.669,
    r: 153.355,
    style: {
      fill: "url(#jE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jF",
    x1: 1410.398,
    x2: 1410.398,
    y1: -63.639,
    y2: -370.525,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#742a61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#742b61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9896"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 214.367,
    cy: 467.783,
    r: 153.442,
    style: {
      fill: "url(#jF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jG",
    x1: 1412.179,
    x2: 1412.179,
    y1: -67.133,
    y2: -374.193,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#742a61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#742a61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9896"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 213.328,
    cy: 463.886,
    r: 153.529,
    style: {
      fill: "url(#jG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jH",
    x1: 1413.999,
    x2: 1413.999,
    y1: -70.608,
    y2: -377.841,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#732a61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#732a61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9896"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 212.331,
    cy: 459.978,
    r: 153.616,
    style: {
      fill: "url(#jH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jI",
    x1: 1415.858,
    x2: 1415.858,
    y1: -74.063,
    y2: -381.47,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#732a61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#732a61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9896"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 211.376,
    cy: 456.059,
    r: 153.703,
    style: {
      fill: "url(#jI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jJ",
    x1: 1417.755,
    x2: 1417.755,
    y1: -77.497,
    y2: -385.078,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#732a61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#732a61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9896"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 210.464,
    cy: 452.131,
    r: 153.79,
    style: {
      fill: "url(#jJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jK",
    x1: 1419.691,
    x2: 1419.691,
    y1: -80.91,
    y2: -388.664,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#732a62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#732a62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9896"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 209.594,
    cy: 448.194,
    r: 153.876,
    style: {
      fill: "url(#jK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jL",
    x1: 1421.664,
    x2: 1421.664,
    y1: -84.302,
    y2: -392.229,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#732a62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#732a62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9896"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 208.768,
    cy: 444.248,
    r: 153.963,
    style: {
      fill: "url(#jL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jM",
    x1: 1423.676,
    x2: 1423.676,
    y1: -87.67,
    y2: -395.771,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#722a62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#722a62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9797"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 207.984,
    cy: 440.294,
    r: 154.05,
    style: {
      fill: "url(#jM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jN",
    x1: 1425.725,
    x2: 1425.725,
    y1: -91.016,
    y2: -399.291,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#722a62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#722a62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9797"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 207.244,
    cy: 436.332,
    r: 154.137,
    style: {
      fill: "url(#jN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jO",
    x1: 1427.811,
    x2: 1427.811,
    y1: -94.338,
    y2: -402.786,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#722a62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#722a62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9797"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 206.548,
    cy: 432.364,
    r: 154.224,
    style: {
      fill: "url(#jO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jP",
    x1: 1429.935,
    x2: 1429.935,
    y1: -97.636,
    y2: -406.258,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#722a62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#722a62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9797"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 205.896,
    cy: 428.39,
    r: 154.31,
    style: {
      fill: "url(#jP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jQ",
    x1: 1432.096,
    x2: 1432.096,
    y1: -100.908,
    y2: -409.704,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#722a63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#722a63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9797"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 205.288,
    cy: 424.409,
    r: 154.397,
    style: {
      fill: "url(#jQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jR",
    x1: 1434.294,
    x2: 1434.294,
    y1: -104.156,
    y2: -413.125,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#712963"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#712a63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9797"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 204.725,
    cy: 420.424,
    r: 154.484,
    style: {
      fill: "url(#jR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jS",
    x1: 1436.528,
    x2: 1436.528,
    y1: -107.377,
    y2: -416.52,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#712963"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#712a63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9797"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 204.206,
    cy: 416.434,
    r: 154.571,
    style: {
      fill: "url(#jS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jT",
    x1: 1438.799,
    x2: 1438.799,
    y1: -110.572,
    y2: -419.889,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#712963"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#712a63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9797"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 203.733,
    cy: 412.44,
    r: 154.658,
    style: {
      fill: "url(#jT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jU",
    x1: 1441.107,
    x2: 1441.107,
    y1: -113.739,
    y2: -423.23,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#712963"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#712a63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9797"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 203.305,
    cy: 408.442,
    r: 154.745,
    style: {
      fill: "url(#jU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jV",
    x1: 1443.451,
    x2: 1443.451,
    y1: -116.879,
    y2: -426.543,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#712963"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#712a63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9698"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 202.923,
    cy: 404.442,
    r: 154.831,
    style: {
      fill: "url(#jV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jW",
    x1: 1445.831,
    x2: 1445.831,
    y1: -119.99,
    y2: -429.828,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#702964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#702a64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9698"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 202.586,
    cy: 400.439,
    r: 154.918,
    style: {
      fill: "url(#jW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jX",
    x1: 1448.247,
    x2: 1448.247,
    y1: -123.072,
    y2: -433.083,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#702964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#702a64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9698"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 202.296,
    cy: 396.434,
    r: 155.005,
    style: {
      fill: "url(#jX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jY",
    x1: 1450.699,
    x2: 1450.699,
    y1: -126.124,
    y2: -436.309,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#702964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#702964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9698"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 202.052,
    cy: 392.429,
    r: 155.092,
    style: {
      fill: "url(#jY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jZ",
    x1: 1453.186,
    x2: 1453.186,
    y1: -129.147,
    y2: -439.505,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#702964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#702964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9698"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 201.855,
    cy: 388.422,
    r: 155.179,
    style: {
      fill: "url(#jZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ka",
    x1: 1455.709,
    x2: 1455.709,
    y1: -132.138,
    y2: -442.67,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6f2964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6f2964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9698"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 201.705,
    cy: 384.416,
    r: 155.265,
    style: {
      fill: "url(#ka)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kb",
    x1: 1458.267,
    x2: 1458.267,
    y1: -135.098,
    y2: -445.803,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6f2965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6f2965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9698"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 201.602,
    cy: 380.41,
    r: 155.352,
    style: {
      fill: "url(#kb)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kc",
    x1: 1460.86,
    x2: 1460.86,
    y1: -138.025,
    y2: -448.904,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6f2965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6f2965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9698"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 201.546,
    cy: 376.405,
    r: 155.439,
    style: {
      fill: "url(#kc)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kd",
    x1: 1463.487,
    x2: 1463.487,
    y1: -140.92,
    y2: -451.973,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6f2965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6f2965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9698"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 201.538,
    cy: 372.402,
    r: 155.526,
    style: {
      fill: "url(#kd)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ke",
    x1: 1466.15,
    x2: 1466.15,
    y1: -143.782,
    y2: -455.009,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6f2965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6f2965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9599"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 201.578,
    cy: 368.401,
    r: 155.613,
    style: {
      fill: "url(#ke)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kf",
    x1: 1468.847,
    x2: 1468.847,
    y1: -146.61,
    y2: -458.01,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6e2965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6e2965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9599"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 201.667,
    cy: 364.403,
    r: 155.699,
    style: {
      fill: "url(#kf)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kg",
    x1: 1471.578,
    x2: 1471.578,
    y1: -149.403,
    y2: -460.977,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6e2965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6e2965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9599"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 201.803,
    cy: 360.408,
    r: 155.786,
    style: {
      fill: "url(#kg)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kh",
    x1: 1474.344,
    x2: 1474.344,
    y1: -152.161,
    y2: -463.909,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6e2966"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6e2966"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9599"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 201.989,
    cy: 356.417,
    r: 155.873,
    style: {
      fill: "url(#kh)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ki",
    x1: 1477.143,
    x2: 1477.143,
    y1: -154.884,
    y2: -466.805,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6e2966"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6e2966"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9599"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 202.224,
    cy: 352.431,
    r: 155.96,
    style: {
      fill: "url(#ki)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kj",
    x1: 1479.976,
    x2: 1479.976,
    y1: -157.57,
    y2: -469.665,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6e2866"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6e2966"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9599"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 202.508,
    cy: 348.45,
    r: 156.047,
    style: {
      fill: "url(#kj)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kk",
    x1: 1482.843,
    x2: 1482.843,
    y1: -160.219,
    y2: -472.488,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6d2866"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6d2966"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9599"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 202.841,
    cy: 344.474,
    r: 156.134,
    style: {
      fill: "url(#kk)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kl",
    x1: 1485.743,
    x2: 1485.743,
    y1: -162.831,
    y2: -475.273,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6d2866"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6d2966"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9599"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 203.225,
    cy: 340.505,
    r: 156.22,
    style: {
      fill: "url(#kl)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "km",
    x1: 1488.677,
    x2: 1488.677,
    y1: -165.405,
    y2: -478.02,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6d2866"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6d2966"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9599"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 203.658,
    cy: 336.542,
    r: 156.307,
    style: {
      fill: "url(#km)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kn",
    x1: 1491.643,
    x2: 1491.643,
    y1: -167.94,
    y2: -480.729,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6d2867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6d2967"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff959a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 204.142,
    cy: 332.587,
    r: 156.394,
    style: {
      fill: "url(#kn)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ko",
    x1: 1494.643,
    x2: 1494.643,
    y1: -170.435,
    y2: -483.398,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6d2867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6d2967"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff949a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 204.677,
    cy: 328.64,
    r: 156.481,
    style: {
      fill: "url(#ko)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kp",
    x1: 1497.675,
    x2: 1497.675,
    y1: -172.891,
    y2: -486.028,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6c2867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6c2867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff949a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 205.262,
    cy: 324.701,
    r: 156.568,
    style: {
      fill: "url(#kp)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kq",
    x1: 1500.74,
    x2: 1500.74,
    y1: -175.307,
    y2: -488.617,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6c2867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6c2867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff949a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 205.899,
    cy: 320.771,
    r: 156.654,
    style: {
      fill: "url(#kq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kr",
    x1: 1503.837,
    x2: 1503.837,
    y1: -177.681,
    y2: -491.165,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6c2867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6c2867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff949a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 206.587,
    cy: 316.851,
    r: 156.741,
    style: {
      fill: "url(#kr)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ks",
    x1: 1506.967,
    x2: 1506.967,
    y1: -180.013,
    y2: -493.671,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6c2868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6c2868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff949a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 207.327,
    cy: 312.941,
    r: 156.828,
    style: {
      fill: "url(#ks)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kt",
    x1: 1510.128,
    x2: 1510.128,
    y1: -182.303,
    y2: -496.134,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6c2868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6c2868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff949a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 208.118,
    cy: 309.042,
    r: 156.915,
    style: {
      fill: "url(#kt)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ku",
    x1: 1513.322,
    x2: 1513.322,
    y1: -184.55,
    y2: -498.555,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6b2868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6b2868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff949a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 208.962,
    cy: 305.154,
    r: 157.002,
    style: {
      fill: "url(#ku)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kv",
    x1: 1516.547,
    x2: 1516.547,
    y1: -186.754,
    y2: -500.933,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6b2868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6b2868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff949a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 209.859,
    cy: 301.278,
    r: 157.089,
    style: {
      fill: "url(#kv)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kw",
    x1: 1519.803,
    x2: 1519.803,
    y1: -188.914,
    y2: -503.266,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6b2868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6b2868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff949b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 210.808,
    cy: 297.414,
    r: 157.175,
    style: {
      fill: "url(#kw)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kx",
    x1: 1523.091,
    x2: 1523.091,
    y1: -191.029,
    y2: -505.554,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6b2868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6b2868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff939b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 211.81,
    cy: 293.564,
    r: 157.262,
    style: {
      fill: "url(#kx)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ky",
    x1: 1526.41,
    x2: 1526.41,
    y1: -193.098,
    y2: -507.797,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6a2869"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6a2869"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff939b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 212.865,
    cy: 289.727,
    r: 157.349,
    style: {
      fill: "url(#ky)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kz",
    x1: 1529.76,
    x2: 1529.76,
    y1: -195.122,
    y2: -509.995,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6a2869"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6a2869"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff939b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 213.974,
    cy: 285.905,
    r: 157.436,
    style: {
      fill: "url(#kz)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kA",
    x1: 1533.141,
    x2: 1533.141,
    y1: -197.099,
    y2: -512.145,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6a2769"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6a2869"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff939b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 215.137,
    cy: 282.097,
    r: 157.523,
    style: {
      fill: "url(#kA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kB",
    x1: 1536.552,
    x2: 1536.552,
    y1: -199.029,
    y2: -514.249,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6a2769"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6a2869"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff939b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 216.353,
    cy: 278.304,
    r: 157.609,
    style: {
      fill: "url(#kB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kC",
    x1: 1539.994,
    x2: 1539.994,
    y1: -200.911,
    y2: -516.304,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6a2769"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#6a2869"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff939b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 217.624,
    cy: 274.528,
    r: 157.696,
    style: {
      fill: "url(#kC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kD",
    x1: 1543.466,
    x2: 1543.466,
    y1: -202.744,
    y2: -518.312,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#692769"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#692869"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff939b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 218.95,
    cy: 270.768,
    r: 157.783,
    style: {
      fill: "url(#kD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kE",
    x1: 1546.969,
    x2: 1546.969,
    y1: -204.529,
    y2: -520.27,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#69276a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#69286a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff939b"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 220.331,
    cy: 267.025,
    r: 157.87,
    style: {
      fill: "url(#kE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kF",
    x1: 1550.501,
    x2: 1550.501,
    y1: -206.265,
    y2: -522.179,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#69276a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#69286a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff939c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 221.766,
    cy: 263.299,
    r: 157.957,
    style: {
      fill: "url(#kF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kG",
    x1: 1554.063,
    x2: 1554.063,
    y1: -207.95,
    y2: -524.038,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#69276a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#69286a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff929c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 223.257,
    cy: 259.592,
    r: 158.044,
    style: {
      fill: "url(#kG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kH",
    x1: 1557.654,
    x2: 1557.654,
    y1: -209.584,
    y2: -525.846,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#69276a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#69276a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff929c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 224.804,
    cy: 255.903,
    r: 158.13,
    style: {
      fill: "url(#kH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kI",
    x1: 1561.275,
    x2: 1561.275,
    y1: -211.167,
    y2: -527.603,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68276a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#68276a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff929c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 226.406,
    cy: 252.234,
    r: 158.217,
    style: {
      fill: "url(#kI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kJ",
    x1: 1564.925,
    x2: 1564.925,
    y1: -212.698,
    y2: -529.308,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68276b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#68276b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff929c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 228.065,
    cy: 248.584,
    r: 158.304,
    style: {
      fill: "url(#kJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kK",
    x1: 1568.604,
    x2: 1568.604,
    y1: -214.177,
    y2: -530.96,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68276b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#68276b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff929c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 229.78,
    cy: 244.955,
    r: 158.391,
    style: {
      fill: "url(#kK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kL",
    x1: 1572.633,
    x2: 1572.633,
    y1: -215.731,
    y2: -532.688,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68276b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#68276b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff929c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 231.708,
    cy: 241.04,
    r: 158.478,
    style: {
      fill: "url(#kL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kM",
    x1: 1576.778,
    x2: 1576.778,
    y1: -217.247,
    y2: -534.377,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68276b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#68276b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff929c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 233.75,
    cy: 237.076,
    r: 158.564,
    style: {
      fill: "url(#kM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kN",
    x1: 1580.922,
    x2: 1580.922,
    y1: -218.673,
    y2: -535.977,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#67276b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#67276b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff929c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 235.85,
    cy: 233.18,
    r: 158.651,
    style: {
      fill: "url(#kN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kO",
    x1: 1585.065,
    x2: 1585.065,
    y1: -220.012,
    y2: -537.489,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#67276b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#67276b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff929d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 238.006,
    cy: 229.352,
    r: 158.738,
    style: {
      fill: "url(#kO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kP",
    x1: 1589.205,
    x2: 1589.205,
    y1: -221.263,
    y2: -538.914,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#67276c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#67276c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff929d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 240.217,
    cy: 225.591,
    r: 158.825,
    style: {
      fill: "url(#kP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kQ",
    x1: 1593.341,
    x2: 1593.341,
    y1: -222.426,
    y2: -540.251,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#67276c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#67276c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff919d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 242.483,
    cy: 221.899,
    r: 158.912,
    style: {
      fill: "url(#kQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kR",
    x1: 1597.472,
    x2: 1597.472,
    y1: -223.503,
    y2: -541.501,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#67276c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#67276c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff919d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 244.803,
    cy: 218.275,
    r: 158.998,
    style: {
      fill: "url(#kR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kS",
    x1: 1601.599,
    x2: 1601.599,
    y1: -224.494,
    y2: -542.665,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#66266c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#66276c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff919d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 247.176,
    cy: 214.719,
    r: 159.085,
    style: {
      fill: "url(#kS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kT",
    x1: 1605.719,
    x2: 1605.719,
    y1: -225.398,
    y2: -543.744,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#66266c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#66276c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff919d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 249.601,
    cy: 211.231,
    r: 159.172,
    style: {
      fill: "url(#kT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kU",
    x1: 1609.832,
    x2: 1609.832,
    y1: -226.218,
    y2: -544.737,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#66266c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#66276c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff919d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 252.076,
    cy: 207.813,
    r: 159.259,
    style: {
      fill: "url(#kU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kV",
    x1: 1613.938,
    x2: 1613.938,
    y1: -226.953,
    y2: -545.645,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#66266d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#66276d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff919d"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 254.602,
    cy: 204.463,
    r: 159.346,
    style: {
      fill: "url(#kV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kW",
    x1: 1618.035,
    x2: 1618.035,
    y1: -227.603,
    y2: -546.47,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#65266d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#65276d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff919e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 257.176,
    cy: 201.182,
    r: 159.433,
    style: {
      fill: "url(#kW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kX",
    x1: 1622.123,
    x2: 1622.123,
    y1: -228.17,
    y2: -547.21,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#65266d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#65276d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff919e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 259.798,
    cy: 197.971,
    r: 159.519,
    style: {
      fill: "url(#kX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kY",
    x1: 1626.2,
    x2: 1626.2,
    y1: -228.654,
    y2: -547.867,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#65266d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#65266d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff919e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 262.468,
    cy: 194.829,
    r: 159.606,
    style: {
      fill: "url(#kY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kZ",
    x1: 1630.267,
    x2: 1630.267,
    y1: -229.054,
    y2: -548.442,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#65266d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#65266d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff909e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 265.184,
    cy: 191.756,
    r: 159.693,
    style: {
      fill: "url(#kZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "la",
    x1: 1634.322,
    x2: 1634.322,
    y1: -229.373,
    y2: -548.934,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#65266e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#65266e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff909e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 267.944,
    cy: 188.753,
    r: 159.78,
    style: {
      fill: "url(#la)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lb",
    x1: 1638.364,
    x2: 1638.364,
    y1: -229.61,
    y2: -549.344,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#64266e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#64266e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff909e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 270.75,
    cy: 185.82,
    r: 159.867,
    style: {
      fill: "url(#lb)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lc",
    x1: 1642.393,
    x2: 1642.393,
    y1: -229.765,
    y2: -549.673,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#64266e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#64266e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff909e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 273.598,
    cy: 182.957,
    r: 159.953,
    style: {
      fill: "url(#lc)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ld",
    x1: 1646.408,
    x2: 1646.408,
    y1: -229.84,
    y2: -549.922,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#64266e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#64266e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff909e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 276.489,
    cy: 180.164,
    r: 160.04,
    style: {
      fill: "url(#ld)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "le",
    x1: 1650.407,
    x2: 1650.407,
    y1: -229.835,
    y2: -550.09,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#64266e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#64266e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff909e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 279.421,
    cy: 177.442,
    r: 160.127,
    style: {
      fill: "url(#le)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lf",
    x1: 1654.39,
    x2: 1654.39,
    y1: -229.75,
    y2: -550.179,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#64266e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#64266e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff909f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 282.393,
    cy: 174.79,
    r: 160.214,
    style: {
      fill: "url(#lf)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg",
    x1: 1658.357,
    x2: 1658.357,
    y1: -229.585,
    y2: -550.188,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#63266f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#63266f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff909f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 285.406,
    cy: 172.208,
    r: 160.301,
    style: {
      fill: "url(#lg)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lh",
    x1: 1662.306,
    x2: 1662.306,
    y1: -229.342,
    y2: -550.118,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#63266f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#63266f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff909f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 288.456,
    cy: 169.698,
    r: 160.388,
    style: {
      fill: "url(#lh)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "li",
    x1: 1666.237,
    x2: 1666.237,
    y1: -229.02,
    y2: -549.971,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#63266f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#63266f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8f9f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 291.545,
    cy: 167.258,
    r: 160.474,
    style: {
      fill: "url(#li)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lj",
    x1: 1670.149,
    x2: 1670.149,
    y1: -228.621,
    y2: -549.745,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#63266f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#63266f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8f9f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 294.67,
    cy: 164.89,
    r: 160.561,
    style: {
      fill: "url(#lj)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lk",
    x1: 1674.04,
    x2: 1674.04,
    y1: -228.145,
    y2: -549.442,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#63256f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#63266f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8f9f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 297.83,
    cy: 162.593,
    r: 160.648,
    style: {
      fill: "url(#lk)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ll",
    x1: 1677.911,
    x2: 1677.911,
    y1: -227.592,
    y2: -549.063,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#62256f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#62266f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8f9f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 301.026,
    cy: 160.367,
    r: 160.735,
    style: {
      fill: "url(#ll)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lm",
    x1: 1681.76,
    x2: 1681.76,
    y1: -226.962,
    y2: -548.607,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#622570"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#622670"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8f9f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 304.255,
    cy: 158.213,
    r: 160.822,
    style: {
      fill: "url(#lm)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ln",
    x1: 1685.587,
    x2: 1685.587,
    y1: -226.257,
    y2: -548.075,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#622570"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#622670"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8f9f"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 307.517,
    cy: 156.131,
    r: 160.908,
    style: {
      fill: "url(#ln)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lo",
    x1: 1689.39,
    x2: 1689.39,
    y1: -225.477,
    y2: -547.469,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#622570"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#622670"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8fa0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 310.811,
    cy: 154.121,
    r: 160.995,
    style: {
      fill: "url(#lo)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lp",
    x1: 1693.17,
    x2: 1693.17,
    y1: -224.622,
    y2: -546.787,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#622570"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#622670"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8fa0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 314.137,
    cy: 152.182,
    r: 161.082,
    style: {
      fill: "url(#lp)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lq",
    x1: 1696.924,
    x2: 1696.924,
    y1: -223.692,
    y2: -546.031,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612570"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#612570"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8fa0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 317.492,
    cy: 150.317,
    r: 161.169,
    style: {
      fill: "url(#lq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lr",
    x1: 1700.653,
    x2: 1700.653,
    y1: -222.689,
    y2: -545.202,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#612571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8fa0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 320.876,
    cy: 148.523,
    r: 161.256,
    style: {
      fill: "url(#lr)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ls",
    x1: 1704.354,
    x2: 1704.354,
    y1: -221.613,
    y2: -544.299,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#612571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ea0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 324.288,
    cy: 146.803,
    r: 161.343,
    style: {
      fill: "url(#ls)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lt",
    x1: 1708.029,
    x2: 1708.029,
    y1: -220.464,
    y2: -543.324,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#612571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ea0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 327.728,
    cy: 145.155,
    r: 161.429,
    style: {
      fill: "url(#lt)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lu",
    x1: 1711.675,
    x2: 1711.675,
    y1: -219.242,
    y2: -542.276,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#602571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#602571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ea0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 331.194,
    cy: 143.58,
    r: 161.516,
    style: {
      fill: "url(#lu)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lv",
    x1: 1715.293,
    x2: 1715.293,
    y1: -217.949,
    y2: -541.157,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#602571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#602571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ea0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 334.685,
    cy: 142.078,
    r: 161.603,
    style: {
      fill: "url(#lv)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lw",
    x1: 1718.88,
    x2: 1718.88,
    y1: -216.585,
    y2: -539.966,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#602571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#602571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ea0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 338.201,
    cy: 140.649,
    r: 161.69,
    style: {
      fill: "url(#lw)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lx",
    x1: 1722.437,
    x2: 1722.437,
    y1: -215.15,
    y2: -538.704,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#602572"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#602572"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ea1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 341.74,
    cy: 139.294,
    r: 161.777,
    style: {
      fill: "url(#lx)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ly",
    x1: 1725.962,
    x2: 1725.962,
    y1: -213.644,
    y2: -537.373,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#602572"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#602572"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ea1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 345.301,
    cy: 138.013,
    r: 161.863,
    style: {
      fill: "url(#ly)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lz",
    x1: 1729.455,
    x2: 1729.455,
    y1: -212.069,
    y2: -535.971,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5f2572"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5f2572"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ea1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 348.884,
    cy: 136.805,
    r: 161.95,
    style: {
      fill: "url(#lz)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lA",
    x1: 1732.915,
    x2: 1732.915,
    y1: -210.425,
    y2: -534.5,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5f2572"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5f2572"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ea1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 352.488,
    cy: 135.671,
    r: 162.037,
    style: {
      fill: "url(#lA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lB",
    x1: 1736.341,
    x2: 1736.341,
    y1: -208.712,
    y2: -532.961,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5f2572"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5f2572"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8da1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 356.111,
    cy: 134.612,
    r: 162.124,
    style: {
      fill: "url(#lB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lC",
    x1: 1739.732,
    x2: 1739.732,
    y1: -206.931,
    y2: -531.353,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5f2472"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5f2572"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8da1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 359.753,
    cy: 133.626,
    r: 162.211,
    style: {
      fill: "url(#lC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lD",
    x1: 1743.087,
    x2: 1743.087,
    y1: -205.082,
    y2: -529.678,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5f2473"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5f2573"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8da1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 363.412,
    cy: 132.715,
    r: 162.298,
    style: {
      fill: "url(#lD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lE",
    x1: 1746.406,
    x2: 1746.406,
    y1: -203.165,
    y2: -527.935,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5e2473"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5e2573"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8da1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 367.089,
    cy: 131.879,
    r: 162.384,
    style: {
      fill: "url(#lE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lF",
    x1: 1749.688,
    x2: 1749.688,
    y1: -201.182,
    y2: -526.126,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5e2473"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5e2573"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8da1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 370.781,
    cy: 131.117,
    r: 162.471,
    style: {
      fill: "url(#lF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lG",
    x1: 1752.931,
    x2: 1752.931,
    y1: -199.133,
    y2: -524.25,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5e2473"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5e2573"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8da2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 374.488,
    cy: 130.43,
    r: 162.558,
    style: {
      fill: "url(#lG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lH",
    x1: 1756.136,
    x2: 1756.136,
    y1: -197.018,
    y2: -522.309,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5e2473"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5e2473"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8da2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 378.209,
    cy: 129.818,
    r: 162.645,
    style: {
      fill: "url(#lH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lI",
    x1: 1759.301,
    x2: 1759.301,
    y1: -194.838,
    y2: -520.302,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5e2474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5e2474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8da2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 381.943,
    cy: 129.282,
    r: 162.732,
    style: {
      fill: "url(#lI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lJ",
    x1: 1762.426,
    x2: 1762.426,
    y1: -192.592,
    y2: -518.231,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5d2474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5d2474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8da2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 385.689,
    cy: 128.821,
    r: 162.818,
    style: {
      fill: "url(#lJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lK",
    x1: 1765.509,
    x2: 1765.509,
    y1: -190.283,
    y2: -516.095,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5d2474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5d2474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ca2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 389.446,
    cy: 128.435,
    r: 162.905,
    style: {
      fill: "url(#lK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lL",
    x1: 1768.55,
    x2: 1768.55,
    y1: -187.91,
    y2: -513.895,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5d2474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5d2474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ca2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 393.214,
    cy: 128.126,
    r: 162.992,
    style: {
      fill: "url(#lL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lM",
    x1: 1771.548,
    x2: 1771.548,
    y1: -185.474,
    y2: -511.633,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5d2474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5d2474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ca2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 396.99,
    cy: 127.892,
    r: 163.079,
    style: {
      fill: "url(#lM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lN",
    x1: 1774.502,
    x2: 1774.502,
    y1: -182.975,
    y2: -509.307,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5d2474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5d2474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ca2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 400.775,
    cy: 127.734,
    r: 163.166,
    style: {
      fill: "url(#lN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lO",
    x1: 1777.412,
    x2: 1777.412,
    y1: -180.413,
    y2: -506.92,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5c2475"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5c2475"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ca2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 404.567,
    cy: 127.652,
    r: 163.252,
    style: {
      fill: "url(#lO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lP",
    x1: 1780.276,
    x2: 1780.276,
    y1: -177.79,
    y2: -504.47,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5c2475"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5c2475"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ca3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 408.366,
    cy: 127.647,
    r: 163.339,
    style: {
      fill: "url(#lP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lQ",
    x1: 1783.094,
    x2: 1783.094,
    y1: -175.106,
    y2: -501.96,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5c2475"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5c2475"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ca3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 412.17,
    cy: 127.718,
    r: 163.426,
    style: {
      fill: "url(#lQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lR",
    x1: 1785.865,
    x2: 1785.865,
    y1: -172.361,
    y2: -499.388,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5c2475"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5c2475"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ca3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 415.978,
    cy: 127.866,
    r: 163.513,
    style: {
      fill: "url(#lR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lS",
    x1: 1788.588,
    x2: 1788.588,
    y1: -169.556,
    y2: -496.757,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5b2475"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5b2475"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ca3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 419.79,
    cy: 128.091,
    r: 163.6,
    style: {
      fill: "url(#lS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lT",
    x1: 1791.262,
    x2: 1791.262,
    y1: -166.691,
    y2: -494.065,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5b2375"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5b2475"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ca3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 423.604,
    cy: 128.393,
    r: 163.687,
    style: {
      fill: "url(#lT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lU",
    x1: 1793.886,
    x2: 1793.886,
    y1: -163.767,
    y2: -491.315,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5b2376"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5b2476"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ba3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 427.421,
    cy: 128.772,
    r: 163.773,
    style: {
      fill: "url(#lU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lV",
    x1: 1796.46,
    x2: 1796.46,
    y1: -160.784,
    y2: -488.505,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5b2376"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5b2476"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ba3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 431.237,
    cy: 129.229,
    r: 163.86,
    style: {
      fill: "url(#lV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lW",
    x1: 1798.983,
    x2: 1798.983,
    y1: -157.742,
    y2: -485.637,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5b2376"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5b2476"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ba3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 435.054,
    cy: 129.763,
    r: 163.947,
    style: {
      fill: "url(#lW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lX",
    x1: 1801.454,
    x2: 1801.454,
    y1: -154.643,
    y2: -482.712,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5a2376"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5a2476"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ba3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 438.869,
    cy: 130.375,
    r: 164.034,
    style: {
      fill: "url(#lX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lY",
    x1: 1803.872,
    x2: 1803.872,
    y1: -151.487,
    y2: -479.729,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5a2376"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5a2376"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ba4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 442.683,
    cy: 131.064,
    r: 164.121,
    style: {
      fill: "url(#lY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lZ",
    x1: 1806.237,
    x2: 1806.237,
    y1: -148.274,
    y2: -476.69,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5a2377"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5a2377"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ba4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 446.493,
    cy: 131.832,
    r: 164.207,
    style: {
      fill: "url(#lZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ma",
    x1: 1808.547,
    x2: 1808.547,
    y1: -145.005,
    y2: -473.594,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5a2377"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5a2377"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ba4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 450.299,
    cy: 132.677,
    r: 164.294,
    style: {
      fill: "url(#ma)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mb",
    x1: 1810.801,
    x2: 1810.801,
    y1: -141.68,
    y2: -470.443,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5a2377"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#5a2377"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ba4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 454.1,
    cy: 133.602,
    r: 164.381,
    style: {
      fill: "url(#mb)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mc",
    x1: 1813,
    x2: 1813,
    y1: -138.299,
    y2: -467.236,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#592377"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#592377"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8ba4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 457.895,
    cy: 134.604,
    r: 164.468,
    style: {
      fill: "url(#mc)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "md",
    x1: 1815.141,
    x2: 1815.141,
    y1: -134.864,
    y2: -463.975,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#592377"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#592377"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8aa4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 461.683,
    cy: 135.685,
    r: 164.555,
    style: {
      fill: "url(#md)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "me",
    x1: 1817.225,
    x2: 1817.225,
    y1: -131.375,
    y2: -460.659,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#592377"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#592377"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8aa4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 465.464,
    cy: 136.846,
    r: 164.642,
    style: {
      fill: "url(#me)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mf",
    x1: 1819.251,
    x2: 1819.251,
    y1: -127.832,
    y2: -457.29,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#592378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#592378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8aa4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 469.235,
    cy: 138.085,
    r: 164.728,
    style: {
      fill: "url(#mf)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mg",
    x1: 1821.216,
    x2: 1821.216,
    y1: -124.236,
    y2: -453.868,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#592378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#592378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8aa4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 472.997,
    cy: 139.403,
    r: 164.815,
    style: {
      fill: "url(#mg)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mh",
    x1: 1823.122,
    x2: 1823.122,
    y1: -120.587,
    y2: -450.392,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#582378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#582378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8aa5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 476.749,
    cy: 140.8,
    r: 164.902,
    style: {
      fill: "url(#mh)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mi",
    x1: 1824.967,
    x2: 1824.967,
    y1: -116.886,
    y2: -446.865,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#582378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#582378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8aa5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 480.488,
    cy: 142.278,
    r: 164.989,
    style: {
      fill: "url(#mi)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mj",
    x1: 1826.749,
    x2: 1826.749,
    y1: -113.133,
    y2: -443.285,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#582378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#582378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8aa5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 484.215,
    cy: 143.834,
    r: 165.076,
    style: {
      fill: "url(#mj)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mk",
    x1: 1828.469,
    x2: 1828.469,
    y1: -109.329,
    y2: -439.655,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#582378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#582378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8aa5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 487.929,
    cy: 145.471,
    r: 165.162,
    style: {
      fill: "url(#mk)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ml",
    x1: 1830.126,
    x2: 1830.126,
    y1: -105.474,
    y2: -435.973,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#582279"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#582379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8aa5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 491.628,
    cy: 147.187,
    r: 165.249,
    style: {
      fill: "url(#ml)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mm",
    x1: 1831.718,
    x2: 1831.718,
    y1: -101.568,
    y2: -432.242,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#572279"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#572379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff89a5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 495.311,
    cy: 148.984,
    r: 165.336,
    style: {
      fill: "url(#mm)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mn",
    x1: 1833.245,
    x2: 1833.245,
    y1: -97.613,
    y2: -428.46,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#572279"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#572379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff89a5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 498.979,
    cy: 150.861,
    r: 165.423,
    style: {
      fill: "url(#mn)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mo",
    x1: 1834.706,
    x2: 1834.706,
    y1: -93.609,
    y2: -424.63,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#572279"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#572379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff89a5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 502.629,
    cy: 152.818,
    r: 165.51,
    style: {
      fill: "url(#mo)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mp",
    x1: 1836.1,
    x2: 1836.1,
    y1: -89.556,
    y2: -420.75,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#572279"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#572379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff89a6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 506.26,
    cy: 154.856,
    r: 165.596,
    style: {
      fill: "url(#mp)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mq",
    x1: 1837.427,
    x2: 1837.427,
    y1: -85.455,
    y2: -416.823,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56227a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#56227a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff89a6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 509.873,
    cy: 156.975,
    r: 165.683,
    style: {
      fill: "url(#mq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mr",
    x1: 1838.685,
    x2: 1838.685,
    y1: -81.306,
    y2: -412.848,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56227a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#56227a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff89a6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 513.465,
    cy: 159.175,
    r: 165.77,
    style: {
      fill: "url(#mr)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ms",
    x1: 1839.874,
    x2: 1839.874,
    y1: -77.11,
    y2: -408.825,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56227a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#56227a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff89a6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 517.037,
    cy: 161.456,
    r: 165.857,
    style: {
      fill: "url(#ms)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mt",
    x1: 1840.993,
    x2: 1840.993,
    y1: -72.867,
    y2: -404.756,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56227a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#56227a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff89a6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 520.586,
    cy: 163.818,
    r: 165.944,
    style: {
      fill: "url(#mt)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mu",
    x1: 1842.041,
    x2: 1842.041,
    y1: -68.578,
    y2: -400.64,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56227a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#56227a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff89a6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 524.112,
    cy: 166.262,
    r: 166.031,
    style: {
      fill: "url(#mu)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mv",
    x1: 1843.017,
    x2: 1843.017,
    y1: -64.243,
    y2: -396.479,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55227a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#55227a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff89a6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 527.615,
    cy: 168.787,
    r: 166.117,
    style: {
      fill: "url(#mv)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mw",
    x1: 1843.921,
    x2: 1843.921,
    y1: -59.862,
    y2: -392.272,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55227b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#55227b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff88a6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 531.092,
    cy: 171.394,
    r: 166.204,
    style: {
      fill: "url(#mw)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mx",
    x1: 1844.751,
    x2: 1844.751,
    y1: -55.438,
    y2: -388.021,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55227b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#55227b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff88a6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 534.544,
    cy: 174.083,
    r: 166.291,
    style: {
      fill: "url(#mx)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "my",
    x1: 1845.507,
    x2: 1845.507,
    y1: -50.968,
    y2: -383.725,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55227b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#55227b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff88a7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 537.969,
    cy: 176.854,
    r: 166.378,
    style: {
      fill: "url(#my)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mz",
    x1: 1846.188,
    x2: 1846.188,
    y1: -46.455,
    y2: -379.386,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55227b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#55227b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff88a7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 541.366,
    cy: 179.708,
    r: 166.465,
    style: {
      fill: "url(#mz)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mA",
    x1: 1846.779,
    x2: 1846.779,
    y1: -42.023,
    y2: -375.127,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54227b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#54227b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff88a7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 544.642,
    cy: 182.559,
    r: 166.551,
    style: {
      fill: "url(#mA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mB",
    x1: 1847.291,
    x2: 1847.291,
    y1: -37.708,
    y2: -370.985,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54227b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#54227b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff88a7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 547.781,
    cy: 185.376,
    r: 166.638,
    style: {
      fill: "url(#mB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mC",
    x1: 1847.74,
    x2: 1847.74,
    y1: -33.402,
    y2: -366.853,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54227c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#54227c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff88a7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 550.867,
    cy: 188.226,
    r: 166.725,
    style: {
      fill: "url(#mC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mD",
    x1: 1848.128,
    x2: 1848.128,
    y1: -29.106,
    y2: -362.731,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54217c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#54227c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff88a7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 553.9,
    cy: 191.108,
    r: 166.812,
    style: {
      fill: "url(#mD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mE",
    x1: 1848.454,
    x2: 1848.454,
    y1: -24.821,
    y2: -358.62,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54217c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#54227c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff88a7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 556.88,
    cy: 194.023,
    r: 166.899,
    style: {
      fill: "url(#mE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mF",
    x1: 1848.719,
    x2: 1848.719,
    y1: -20.547,
    y2: -354.519,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53217c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#53227c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff87a7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 559.807,
    cy: 196.971,
    r: 166.986,
    style: {
      fill: "url(#mF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mG",
    x1: 1848.924,
    x2: 1848.924,
    y1: -16.283,
    y2: -350.429,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53217c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#53227c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff87a7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 562.681,
    cy: 199.949,
    r: 167.072,
    style: {
      fill: "url(#mG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mH",
    x1: 1849.069,
    x2: 1849.069,
    y1: -12.031,
    y2: -346.351,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53217d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#53217d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff87a8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 565.502,
    cy: 202.959,
    r: 167.159,
    style: {
      fill: "url(#mH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mI",
    x1: 1849.154,
    x2: 1849.154,
    y1: -7.791,
    y2: -342.285,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53217d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#53217d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff87a8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 568.271,
    cy: 205.998,
    r: 167.246,
    style: {
      fill: "url(#mI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mJ",
    x1: 1849.179,
    x2: 1849.179,
    y1: -3.563,
    y2: -338.23,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53217d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#53217d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff87a8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 570.987,
    cy: 209.068,
    r: 167.333,
    style: {
      fill: "url(#mJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mK",
    x1: 1849.146,
    x2: 1849.146,
    y1: 0.652,
    y2: -334.188,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#52217d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#52217d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff87a8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 573.65,
    cy: 212.168,
    r: 167.42,
    style: {
      fill: "url(#mK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mL",
    x1: 1849.054,
    x2: 1849.054,
    y1: 4.856,
    y2: -330.159,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#52217d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#52217d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff87a8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 576.26,
    cy: 215.296,
    r: 167.506,
    style: {
      fill: "url(#mL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mM",
    x1: 1848.904,
    x2: 1848.904,
    y1: 9.046,
    y2: -326.142,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#52217d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#52217d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff87a8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 578.819,
    cy: 218.453,
    r: 167.593,
    style: {
      fill: "url(#mM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mN",
    x1: 1848.696,
    x2: 1848.696,
    y1: 13.222,
    y2: -322.139,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#52217e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#52217e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff87a8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 581.325,
    cy: 221.637,
    r: 167.68,
    style: {
      fill: "url(#mN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mO",
    x1: 1848.431,
    x2: 1848.431,
    y1: 17.386,
    y2: -318.15,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#51217e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#51217e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff86a8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 583.779,
    cy: 224.85,
    r: 167.767,
    style: {
      fill: "url(#mO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mP",
    x1: 1848.109,
    x2: 1848.109,
    y1: 21.535,
    y2: -314.174,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#51217e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#51217e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff86a8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 586.181,
    cy: 228.089,
    r: 167.854,
    style: {
      fill: "url(#mP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mQ",
    x1: 1847.73,
    x2: 1847.73,
    y1: 25.67,
    y2: -310.213,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#51217e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#51217e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff86a9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 588.531,
    cy: 231.354,
    r: 167.941,
    style: {
      fill: "url(#mQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mR",
    x1: 1847.295,
    x2: 1847.295,
    y1: 29.79,
    y2: -306.266,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#51217e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#51217e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff86a9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 590.829,
    cy: 234.646,
    r: 168.027,
    style: {
      fill: "url(#mR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mS",
    x1: 1846.804,
    x2: 1846.804,
    y1: 33.896,
    y2: -302.334,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#51217e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#51217e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff86a9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 593.075,
    cy: 237.963,
    r: 168.114,
    style: {
      fill: "url(#mS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mT",
    x1: 1846.258,
    x2: 1846.258,
    y1: 37.986,
    y2: -298.417,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#50217f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#50217f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff86a9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 595.27,
    cy: 241.305,
    r: 168.201,
    style: {
      fill: "url(#mT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mU",
    x1: 1845.657,
    x2: 1845.657,
    y1: 42.061,
    y2: -294.516,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#50217f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#50217f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff86a9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 597.413,
    cy: 244.672,
    r: 168.288,
    style: {
      fill: "url(#mU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mV",
    x1: 1845.002,
    x2: 1845.002,
    y1: 46.12,
    y2: -290.63,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#50207f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#50217f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff86a9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 599.504,
    cy: 248.062,
    r: 168.375,
    style: {
      fill: "url(#mV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mW",
    x1: 1844.292,
    x2: 1844.292,
    y1: 50.163,
    y2: -286.761,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#50207f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#50217f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff86a9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 601.544,
    cy: 251.476,
    r: 168.461,
    style: {
      fill: "url(#mW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mX",
    x1: 1843.528,
    x2: 1843.528,
    y1: 54.19,
    y2: -282.908,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#50207f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#50217f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff86a9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 603.532,
    cy: 254.913,
    r: 168.548,
    style: {
      fill: "url(#mX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mY",
    x1: 1842.711,
    x2: 1842.711,
    y1: 58.2,
    y2: -279.071,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4f2080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4f2180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff85a9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 605.47,
    cy: 258.373,
    r: 168.635,
    style: {
      fill: "url(#mY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mZ",
    x1: 1841.841,
    x2: 1841.841,
    y1: 62.193,
    y2: -275.252,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4f2080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4f2080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff85aa"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 607.356,
    cy: 261.855,
    r: 168.722,
    style: {
      fill: "url(#mZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "na",
    x1: 1840.918,
    x2: 1840.918,
    y1: 66.168,
    y2: -271.45,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4f2080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4f2080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff85aa"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 609.191,
    cy: 265.358,
    r: 168.809,
    style: {
      fill: "url(#na)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nb",
    x1: 1839.944,
    x2: 1839.944,
    y1: 70.126,
    y2: -267.666,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4f2080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4f2080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff85aa"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 610.975,
    cy: 268.882,
    r: 168.895,
    style: {
      fill: "url(#nb)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nc",
    x1: 1838.917,
    x2: 1838.917,
    y1: 74.066,
    y2: -263.9,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4f2080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4f2080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff85aa"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 612.709,
    cy: 272.427,
    r: 168.982,
    style: {
      fill: "url(#nc)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nd",
    x1: 1837.839,
    x2: 1837.839,
    y1: 77.988,
    y2: -260.152,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4e2080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4e2080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff85aa"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 614.391,
    cy: 275.991,
    r: 169.069,
    style: {
      fill: "url(#nd)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ne",
    x1: 1836.71,
    x2: 1836.71,
    y1: 81.891,
    y2: -256.422,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4e2081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4e2081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff85aa"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 616.023,
    cy: 279.575,
    r: 169.156,
    style: {
      fill: "url(#ne)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nf",
    x1: 1835.53,
    x2: 1835.53,
    y1: 85.775,
    y2: -252.712,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4e2081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4e2081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff85aa"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 617.604,
    cy: 283.179,
    r: 169.243,
    style: {
      fill: "url(#nf)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ng",
    x1: 1834.3,
    x2: 1834.3,
    y1: 89.64,
    y2: -249.021,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4e2081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4e2081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff85aa"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 619.135,
    cy: 286.801,
    r: 169.33,
    style: {
      fill: "url(#ng)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nh",
    x1: 1833.02,
    x2: 1833.02,
    y1: 93.485,
    y2: -245.349,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4e2081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4e2081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff84aa"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 620.616,
    cy: 290.44,
    r: 169.416,
    style: {
      fill: "url(#nh)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ni",
    x1: 1831.691,
    x2: 1831.691,
    y1: 97.311,
    y2: -241.697,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d2081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4d2081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff84ab"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 622.046,
    cy: 294.098,
    r: 169.503,
    style: {
      fill: "url(#ni)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nj",
    x1: 1830.313,
    x2: 1830.313,
    y1: 101.116,
    y2: -238.065,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d2081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4d2081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff84ab"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 623.425,
    cy: 297.772,
    r: 169.59,
    style: {
      fill: "url(#nj)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nk",
    x1: 1828.886,
    x2: 1828.886,
    y1: 104.901,
    y2: -234.454,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d2082"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4d2082"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff84ab"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 624.755,
    cy: 301.463,
    r: 169.677,
    style: {
      fill: "url(#nk)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nl",
    x1: 1827.411,
    x2: 1827.411,
    y1: 108.665,
    y2: -230.864,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d2082"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4d2082"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff84ab"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 626.035,
    cy: 305.17,
    r: 169.764,
    style: {
      fill: "url(#nl)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nm",
    x1: 1825.888,
    x2: 1825.888,
    y1: 112.408,
    y2: -227.295,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4c1f82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4c2082"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff84ab"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 627.265,
    cy: 308.893,
    r: 169.85,
    style: {
      fill: "url(#nm)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nn",
    x1: 1824.317,
    x2: 1824.317,
    y1: 116.129,
    y2: -223.747,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4c1f82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4c2082"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff84ab"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 628.445,
    cy: 312.631,
    r: 169.937,
    style: {
      fill: "url(#nn)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no",
    x1: 1822.7,
    x2: 1822.7,
    y1: 119.829,
    y2: -220.221,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4c1f82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4c2082"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff84ab"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 629.575,
    cy: 316.383,
    r: 170.024,
    style: {
      fill: "url(#no)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "np",
    x1: 1821.035,
    x2: 1821.035,
    y1: 123.507,
    y2: -216.716,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4c1f83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4c2083"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff84ab"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 630.655,
    cy: 320.149,
    r: 170.111,
    style: {
      fill: "url(#np)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nq",
    x1: 1819.325,
    x2: 1819.325,
    y1: 127.162,
    y2: -213.235,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4c1f83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4c1f83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff83ab"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 631.686,
    cy: 323.929,
    r: 170.198,
    style: {
      fill: "url(#nq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nr",
    x1: 1817.569,
    x2: 1817.569,
    y1: 130.795,
    y2: -209.776,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4b1f83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4b1f83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff83ac"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 632.668,
    cy: 327.722,
    r: 170.285,
    style: {
      fill: "url(#nr)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ns",
    x1: 1815.767,
    x2: 1815.767,
    y1: 134.405,
    y2: -206.339,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4b1f83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4b1f83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff83ac"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 633.6,
    cy: 331.528,
    r: 170.371,
    style: {
      fill: "url(#ns)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nt",
    x1: 1813.92,
    x2: 1813.92,
    y1: 137.991,
    y2: -202.927,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4b1f83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4b1f83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff83ac"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 634.482,
    cy: 335.345,
    r: 170.458,
    style: {
      fill: "url(#nt)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nu",
    x1: 1812.029,
    x2: 1812.029,
    y1: 141.554,
    y2: -199.537,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4b1f83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4b1f83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff83ac"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 635.316,
    cy: 339.175,
    r: 170.545,
    style: {
      fill: "url(#nu)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nv",
    x1: 1810.093,
    x2: 1810.093,
    y1: 145.093,
    y2: -196.172,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4b1f84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4b1f84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff83ac"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 636.1,
    cy: 343.015,
    r: 170.632,
    style: {
      fill: "url(#nv)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nw",
    x1: 1808.113,
    x2: 1808.113,
    y1: 148.608,
    y2: -192.831,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4a1f84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4a1f84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff83ac"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 636.836,
    cy: 346.866,
    r: 170.719,
    style: {
      fill: "url(#nw)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nx",
    x1: 1806.09,
    x2: 1806.09,
    y1: 152.098,
    y2: -189.514,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4a1f84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4a1f84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff83ac"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 637.522,
    cy: 350.727,
    r: 170.805,
    style: {
      fill: "url(#nx)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ny",
    x1: 1804.024,
    x2: 1804.024,
    y1: 155.563,
    y2: -186.223,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4a1f84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4a1f84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff83ac"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 638.16,
    cy: 354.598,
    r: 170.892,
    style: {
      fill: "url(#ny)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nz",
    x1: 1801.915,
    x2: 1801.915,
    y1: 159.003,
    y2: -182.956,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4a1f84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4a1f84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff83ac"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 638.749,
    cy: 358.478,
    r: 170.979,
    style: {
      fill: "url(#nz)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nA",
    x1: 1799.764,
    x2: 1799.764,
    y1: 162.418,
    y2: -179.715,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4a1f84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4a1f84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff82ad"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 639.29,
    cy: 362.366,
    r: 171.066,
    style: {
      fill: "url(#nA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nB",
    x1: 1797.57,
    x2: 1797.57,
    y1: 165.807,
    y2: -176.5,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#491f85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#491f85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff82ad"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 639.781,
    cy: 366.263,
    r: 171.153,
    style: {
      fill: "url(#nB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nC",
    x1: 1795.336,
    x2: 1795.336,
    y1: 169.17,
    y2: -173.311,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#491f85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#491f85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff82ad"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 640.225,
    cy: 370.167,
    r: 171.24,
    style: {
      fill: "url(#nC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nD",
    x1: 1793.06,
    x2: 1793.06,
    y1: 172.506,
    y2: -170.148,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#491f85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#491f85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff82ad"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 640.62,
    cy: 374.078,
    r: 171.326,
    style: {
      fill: "url(#nD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nE",
    x1: 1790.743,
    x2: 1790.743,
    y1: 175.816,
    y2: -167.012,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#491e85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#491f85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff82ad"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 640.967,
    cy: 377.996,
    r: 171.413,
    style: {
      fill: "url(#nE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nF",
    x1: 1788.387,
    x2: 1788.387,
    y1: 179.099,
    y2: -163.903,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#491e85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#491f85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff82ad"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 641.265,
    cy: 381.92,
    r: 171.5,
    style: {
      fill: "url(#nF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nG",
    x1: 1785.99,
    x2: 1785.99,
    y1: 182.354,
    y2: -160.821,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#481e86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#481f86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff82ad"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 641.516,
    cy: 385.85,
    r: 171.587,
    style: {
      fill: "url(#nG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nH",
    x1: 1783.553,
    x2: 1783.553,
    y1: 185.582,
    y2: -157.767,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#481e86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#481f86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff82ad"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 641.718,
    cy: 389.785,
    r: 171.674,
    style: {
      fill: "url(#nH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nI",
    x1: 1781.078,
    x2: 1781.078,
    y1: 188.781,
    y2: -154.741,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#481e86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#481e86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff82ad"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 641.873,
    cy: 393.724,
    r: 171.76,
    style: {
      fill: "url(#nI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nJ",
    x1: 1778.564,
    x2: 1778.564,
    y1: 191.953,
    y2: -151.743,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#481e86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#481e86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff81ae"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 641.98,
    cy: 397.668,
    r: 171.847,
    style: {
      fill: "url(#nJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nK",
    x1: 1776.012,
    x2: 1776.012,
    y1: 195.095,
    y2: -148.774,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#471e86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#471e86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff81ae"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 642.039,
    cy: 401.615,
    r: 171.934,
    style: {
      fill: "url(#nK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nL",
    x1: 1773.421,
    x2: 1773.421,
    y1: 198.209,
    y2: -145.834,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#471e86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#471e86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff81ae"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 642.05,
    cy: 405.566,
    r: 172.021,
    style: {
      fill: "url(#nL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nM",
    x1: 1770.793,
    x2: 1770.793,
    y1: 201.294,
    y2: -142.923,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#471e87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#471e87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff81ae"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 642.014,
    cy: 409.519,
    r: 172.108,
    style: {
      fill: "url(#nM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nN",
    x1: 1768.128,
    x2: 1768.128,
    y1: 204.349,
    y2: -140.041,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#471e87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#471e87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff81ae"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 641.931,
    cy: 413.474,
    r: 172.194,
    style: {
      fill: "url(#nN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nO",
    x1: 1765.426,
    x2: 1765.426,
    y1: 207.374,
    y2: -137.19,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#471e87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#471e87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff81ae"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 641.8,
    cy: 417.431,
    r: 172.281,
    style: {
      fill: "url(#nO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nP",
    x1: 1762.688,
    x2: 1762.688,
    y1: 210.369,
    y2: -134.368,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#461e87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#461e87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff81ae"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 641.622,
    cy: 421.39,
    r: 172.368,
    style: {
      fill: "url(#nP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nQ",
    x1: 1759.914,
    x2: 1759.914,
    y1: 213.334,
    y2: -131.577,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#461e87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#461e87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff81ae"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 641.397,
    cy: 425.348,
    r: 172.455,
    style: {
      fill: "url(#nQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nR",
    x1: 1757.104,
    x2: 1757.104,
    y1: 216.268,
    y2: -128.817,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#461e87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#461e87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff81af"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 641.125,
    cy: 429.308,
    r: 172.542,
    style: {
      fill: "url(#nR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nS",
    x1: 1754.259,
    x2: 1754.259,
    y1: 219.171,
    y2: -126.088,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#461e88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#461e88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff80af"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 640.805,
    cy: 433.266,
    r: 172.629,
    style: {
      fill: "url(#nS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nT",
    x1: 1751.38,
    x2: 1751.38,
    y1: 222.042,
    y2: -123.39,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#461e88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#461e88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff80af"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 640.439,
    cy: 437.224,
    r: 172.715,
    style: {
      fill: "url(#nT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nU",
    x1: 1748.466,
    x2: 1748.466,
    y1: 224.882,
    y2: -120.724,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#451e88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#451e88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff80af"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 640.026,
    cy: 441.181,
    r: 172.802,
    style: {
      fill: "url(#nU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nV",
    x1: 1745.518,
    x2: 1745.518,
    y1: 227.689,
    y2: -118.09,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#451e88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#451e88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff80af"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 639.567,
    cy: 445.136,
    r: 172.889,
    style: {
      fill: "url(#nV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nW",
    x1: 1742.536,
    x2: 1742.536,
    y1: 230.464,
    y2: -115.489,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#451d88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#451e88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff80af"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 639.061,
    cy: 449.088,
    r: 172.976,
    style: {
      fill: "url(#nW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nX",
    x1: 1739.522,
    x2: 1739.522,
    y1: 233.207,
    y2: -112.92,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#451d89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#451e89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff80af"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 638.508,
    cy: 453.038,
    r: 173.063,
    style: {
      fill: "url(#nX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nY",
    x1: 1736.474,
    x2: 1736.474,
    y1: 235.917,
    y2: -110.384,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#451d89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#451e89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff80af"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 637.909,
    cy: 456.985,
    r: 173.149,
    style: {
      fill: "url(#nY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nZ",
    x1: 1733.394,
    x2: 1733.394,
    y1: 238.593,
    y2: -107.881,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#441d89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#441d89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff80af"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 637.264,
    cy: 460.927,
    r: 173.236,
    style: {
      fill: "url(#nZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oa",
    x1: 1730.282,
    x2: 1730.282,
    y1: 241.236,
    y2: -105.412,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#441d89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#441d89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff80b0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 636.572,
    cy: 464.866,
    r: 173.323,
    style: {
      fill: "url(#oa)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ob",
    x1: 1727.139,
    x2: 1727.139,
    y1: 243.845,
    y2: -102.977,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#441d89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#441d89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7fb0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 635.835,
    cy: 468.799,
    r: 173.41,
    style: {
      fill: "url(#ob)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oc",
    x1: 1723.964,
    x2: 1723.964,
    y1: 246.419,
    y2: -100.576,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#441d89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#441d89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7fb0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 635.051,
    cy: 472.728,
    r: 173.497,
    style: {
      fill: "url(#oc)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "od",
    x1: 1720.758,
    x2: 1720.758,
    y1: 248.959,
    y2: -98.209,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#441d8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#441d8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7fb0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 634.221,
    cy: 476.65,
    r: 173.584,
    style: {
      fill: "url(#od)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oe",
    x1: 1717.523,
    x2: 1717.523,
    y1: 251.464,
    y2: -95.878,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#431d8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#431d8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7fb0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 633.346,
    cy: 480.567,
    r: 173.67,
    style: {
      fill: "url(#oe)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "of",
    x1: 1714.256,
    x2: 1714.256,
    y1: 253.935,
    y2: -93.581,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#431d8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#431d8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7fb0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 632.425,
    cy: 484.476,
    r: 173.757,
    style: {
      fill: "url(#of)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "og",
    x1: 1710.961,
    x2: 1710.961,
    y1: 256.369,
    y2: -91.32,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#431d8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#431d8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7fb0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 631.458,
    cy: 488.379,
    r: 173.844,
    style: {
      fill: "url(#og)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oh",
    x1: 1707.636,
    x2: 1707.636,
    y1: 258.768,
    y2: -89.095,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#431d8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#431d8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7fb0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 630.445,
    cy: 492.273,
    r: 173.931,
    style: {
      fill: "url(#oh)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oi",
    x1: 1704.283,
    x2: 1704.283,
    y1: 261.131,
    y2: -86.906,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#421d8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#421d8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7fb0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 629.388,
    cy: 496.16,
    r: 174.018,
    style: {
      fill: "url(#oi)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oj",
    x1: 1700.901,
    x2: 1700.901,
    y1: 263.457,
    y2: -84.753,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#421d8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#421d8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7fb1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 628.284,
    cy: 500.037,
    r: 174.104,
    style: {
      fill: "url(#oj)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ok",
    x1: 1697.491,
    x2: 1697.491,
    y1: 265.747,
    y2: -82.637,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#421d8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#421d8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7fb1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 627.136,
    cy: 503.906,
    r: 174.191,
    style: {
      fill: "url(#ok)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ol",
    x1: 1694.053,
    x2: 1694.053,
    y1: 267.999,
    y2: -80.558,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#421d8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#421d8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7eb1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 625.942,
    cy: 507.764,
    r: 174.278,
    style: {
      fill: "url(#ol)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "om",
    x1: 1690.588,
    x2: 1690.588,
    y1: 270.214,
    y2: -78.517,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#421d8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#421d8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7eb1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 624.703,
    cy: 511.613,
    r: 174.365,
    style: {
      fill: "url(#om)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "on",
    x1: 1687.096,
    x2: 1687.096,
    y1: 272.392,
    y2: -76.513,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#411d8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#411d8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7eb1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 623.419,
    cy: 515.451,
    r: 174.452,
    style: {
      fill: "url(#on)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oo",
    x1: 1683.578,
    x2: 1683.578,
    y1: 274.532,
    y2: -74.547,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#411c8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#411d8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7eb1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 622.09,
    cy: 519.277,
    r: 174.539,
    style: {
      fill: "url(#oo)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "op",
    x1: 1680.034,
    x2: 1680.034,
    y1: 276.633,
    y2: -72.619,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#411c8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#411d8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7eb1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 620.717,
    cy: 523.092,
    r: 174.625,
    style: {
      fill: "url(#op)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oq",
    x1: 1676.464,
    x2: 1676.464,
    y1: 278.696,
    y2: -70.73,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#411c8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#411c8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7eb1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 619.298,
    cy: 526.894,
    r: 174.712,
    style: {
      fill: "url(#oq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "or",
    x1: 1672.869,
    x2: 1672.869,
    y1: 280.719,
    y2: -68.88,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#411c8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#411c8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7eb1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 617.835,
    cy: 530.684,
    r: 174.799,
    style: {
      fill: "url(#or)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "os",
    x1: 1669.249,
    x2: 1669.249,
    y1: 282.704,
    y2: -67.069,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#401c8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#401c8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7eb2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 616.328,
    cy: 534.461,
    r: 174.886,
    style: {
      fill: "url(#os)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ot",
    x1: 1665.604,
    x2: 1665.604,
    y1: 284.649,
    y2: -65.297,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#401c8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#401c8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7eb2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 614.776,
    cy: 538.224,
    r: 174.973,
    style: {
      fill: "url(#ot)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ou",
    x1: 1661.936,
    x2: 1661.936,
    y1: 286.554,
    y2: -63.566,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#401c8d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#401c8d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7db2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 613.18,
    cy: 541.972,
    r: 175.059,
    style: {
      fill: "url(#ou)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ov",
    x1: 1658.244,
    x2: 1658.244,
    y1: 288.42,
    y2: -61.874,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#401c8d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#401c8d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7db2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 611.539,
    cy: 545.706,
    r: 175.146,
    style: {
      fill: "url(#ov)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ow",
    x1: 1654.528,
    x2: 1654.528,
    y1: 290.244,
    y2: -60.223,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#401c8d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#401c8d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7db2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 609.854,
    cy: 549.425,
    r: 175.233,
    style: {
      fill: "url(#ow)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ox",
    x1: 1650.79,
    x2: 1650.79,
    y1: 292.028,
    y2: -58.613,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3f1c8d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3f1c8d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7db2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 608.125,
    cy: 553.128,
    r: 175.32,
    style: {
      fill: "url(#ox)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oy",
    x1: 1647.029,
    x2: 1647.029,
    y1: 293.771,
    y2: -57.044,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3f1c8d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3f1c8d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7db2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 606.353,
    cy: 556.815,
    r: 175.407,
    style: {
      fill: "url(#oy)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oz",
    x1: 1643.259,
    x2: 1643.259,
    y1: 295.467,
    y2: -55.522,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3f1c8d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3f1c8d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7db2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 604.542,
    cy: 560.473,
    r: 175.493,
    style: {
      fill: "url(#oz)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oA",
    x1: 1639.482,
    x2: 1639.482,
    y1: 297.116,
    y2: -54.046,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3f1c8e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3f1c8e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7db2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 602.696,
    cy: 564.101,
    r: 175.58,
    style: {
      fill: "url(#oA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oB",
    x1: 1635.693,
    x2: 1635.693,
    y1: 298.721,
    y2: -52.614,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3f1c8e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3f1c8e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7db3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 600.811,
    cy: 567.703,
    r: 175.667,
    style: {
      fill: "url(#oB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oC",
    x1: 1631.892,
    x2: 1631.892,
    y1: 300.282,
    y2: -51.227,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3e1c8e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3e1c8e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7db3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 598.888,
    cy: 571.279,
    r: 175.754,
    style: {
      fill: "url(#oC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oD",
    x1: 1628.08,
    x2: 1628.08,
    y1: 301.799,
    y2: -49.884,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3e1c8e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3e1c8e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7cb3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 596.928,
    cy: 574.829,
    r: 175.841,
    style: {
      fill: "url(#oD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oE",
    x1: 1624.257,
    x2: 1624.257,
    y1: 303.271,
    y2: -48.586,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3e1c8e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3e1c8e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7cb3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 594.93,
    cy: 578.353,
    r: 175.928,
    style: {
      fill: "url(#oE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oF",
    x1: 1620.424,
    x2: 1620.424,
    y1: 304.7,
    y2: -47.331,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3e1b8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3e1c8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7cb3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 592.896,
    cy: 581.851,
    r: 176.014,
    style: {
      fill: "url(#oF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oG",
    x1: 1616.58,
    x2: 1616.58,
    y1: 306.084,
    y2: -46.12,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3d1b8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3d1c8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7cb3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 590.825,
    cy: 585.322,
    r: 176.101,
    style: {
      fill: "url(#oG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oH",
    x1: 1612.727,
    x2: 1612.727,
    y1: 307.425,
    y2: -44.953,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3d1b8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3d1c8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7cb3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 588.718,
    cy: 588.767,
    r: 176.188,
    style: {
      fill: "url(#oH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oI",
    x1: 1608.864,
    x2: 1608.864,
    y1: 308.722,
    y2: -43.829,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3d1b8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3d1b8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7cb3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 586.575,
    cy: 592.185,
    r: 176.275,
    style: {
      fill: "url(#oI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oJ",
    x1: 1604.993,
    x2: 1604.993,
    y1: 309.976,
    y2: -42.749,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3d1b8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3d1b8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7cb3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 584.397,
    cy: 595.577,
    r: 176.362,
    style: {
      fill: "url(#oJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oK",
    x1: 1601.112,
    x2: 1601.112,
    y1: 311.186,
    y2: -41.712,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3d1b8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3d1b8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7cb4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 582.183,
    cy: 598.941,
    r: 176.448,
    style: {
      fill: "url(#oK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oL",
    x1: 1597.224,
    x2: 1597.224,
    y1: 312.353,
    y2: -40.719,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3c1b90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3c1b90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7cb4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 579.935,
    cy: 602.278,
    r: 176.535,
    style: {
      fill: "url(#oL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oM",
    x1: 1593.327,
    x2: 1593.327,
    y1: 313.477,
    y2: -39.769,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3c1b90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3c1b90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7cb4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 577.652,
    cy: 605.588,
    r: 176.622,
    style: {
      fill: "url(#oM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oN",
    x1: 1589.422,
    x2: 1589.422,
    y1: 314.558,
    y2: -38.862,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3c1b90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3c1b90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7bb4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 575.335,
    cy: 608.871,
    r: 176.709,
    style: {
      fill: "url(#oN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oO",
    x1: 1585.511,
    x2: 1585.511,
    y1: 315.596,
    y2: -37.997,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3c1b90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3c1b90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7bb4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 572.985,
    cy: 612.126,
    r: 176.796,
    style: {
      fill: "url(#oO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oP",
    x1: 1581.592,
    x2: 1581.592,
    y1: 316.591,
    y2: -37.176,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3c1b90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3c1b90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7bb4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 570.601,
    cy: 615.353,
    r: 176.883,
    style: {
      fill: "url(#oP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oQ",
    x1: 1577.667,
    x2: 1577.667,
    y1: 317.543,
    y2: -36.397,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3b1b90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3b1b90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7bb4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 568.184,
    cy: 618.553,
    r: 176.969,
    style: {
      fill: "url(#oQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oR",
    x1: 1573.735,
    x2: 1573.735,
    y1: 318.453,
    y2: -35.661,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3b1b91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3b1b91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7bb4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 565.734,
    cy: 621.724,
    r: 177.056,
    style: {
      fill: "url(#oR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oS",
    x1: 1569.798,
    x2: 1569.798,
    y1: 319.32,
    y2: -34.967,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3b1b91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3b1b91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7bb4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 563.252,
    cy: 624.868,
    r: 177.143,
    style: {
      fill: "url(#oS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oT",
    x1: 1565.855,
    x2: 1565.855,
    y1: 320.145,
    y2: -34.316,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3b1b91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3b1b91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7bb5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 560.738,
    cy: 627.983,
    r: 177.23,
    style: {
      fill: "url(#oT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oU",
    x1: 1561.907,
    x2: 1561.907,
    y1: 320.928,
    y2: -33.707,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3b1b91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3b1b91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7bb5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 558.192,
    cy: 631.07,
    r: 177.317,
    style: {
      fill: "url(#oU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oV",
    x1: 1557.954,
    x2: 1557.954,
    y1: 321.669,
    y2: -33.139,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3a1b91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3a1b91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7bb5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 555.615,
    cy: 634.128,
    r: 177.403,
    style: {
      fill: "url(#oV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oW",
    x1: 1553.996,
    x2: 1553.996,
    y1: 322.368,
    y2: -32.614,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3a1b92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3a1b92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7ab5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 553.006,
    cy: 637.157,
    r: 177.49,
    style: {
      fill: "url(#oW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oX",
    x1: 1550.035,
    x2: 1550.035,
    y1: 323.024,
    y2: -32.131,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3a1a92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3a1b92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7ab5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 550.368,
    cy: 640.158,
    r: 177.577,
    style: {
      fill: "url(#oX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oY",
    x1: 1546.07,
    x2: 1546.07,
    y1: 323.64,
    y2: -31.69,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3a1a92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3a1b92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7ab5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 547.698,
    cy: 643.13,
    r: 177.664,
    style: {
      fill: "url(#oY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oZ",
    x1: 1542.101,
    x2: 1542.101,
    y1: 324.213,
    y2: -31.29,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3a1a92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#3a1a92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7ab5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 544.999,
    cy: 646.072,
    r: 177.751,
    style: {
      fill: "url(#oZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pa",
    x1: 1538.129,
    x2: 1538.129,
    y1: 324.745,
    y2: -30.931,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#391a92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#391a92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7ab5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 542.27,
    cy: 648.985,
    r: 177.838,
    style: {
      fill: "url(#pa)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pb",
    x1: 1534.155,
    x2: 1534.155,
    y1: 325.236,
    y2: -30.614,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#391a92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#391a92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7ab5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 539.512,
    cy: 651.869,
    r: 177.924,
    style: {
      fill: "url(#pb)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pc",
    x1: 1530.178,
    x2: 1530.178,
    y1: 325.685,
    y2: -30.339,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#391a93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#391a93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7ab6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 536.725,
    cy: 654.724,
    r: 178.011,
    style: {
      fill: "url(#pc)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pd",
    x1: 1526.199,
    x2: 1526.199,
    y1: 326.093,
    y2: -30.104,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#391a93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#391a93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7ab6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 533.909,
    cy: 657.548,
    r: 178.098,
    style: {
      fill: "url(#pd)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pe",
    x1: 1522.219,
    x2: 1522.219,
    y1: 326.461,
    y2: -29.91,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#381a93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#381a93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7ab6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 531.066,
    cy: 660.343,
    r: 178.185,
    style: {
      fill: "url(#pe)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pf",
    x1: 1518.237,
    x2: 1518.237,
    y1: 326.787,
    y2: -29.758,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#381a93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#381a93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff79b6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 528.194,
    cy: 663.108,
    r: 178.272,
    style: {
      fill: "url(#pf)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pg",
    x1: 1514.254,
    x2: 1514.254,
    y1: 327.072,
    y2: -29.646,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#381a93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#381a93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff79b6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 525.294,
    cy: 665.842,
    r: 178.358,
    style: {
      fill: "url(#pg)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ph",
    x1: 1510.271,
    x2: 1510.271,
    y1: 327.317,
    y2: -29.575,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#381a93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#381a93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff79b6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 522.368,
    cy: 668.547,
    r: 178.445,
    style: {
      fill: "url(#ph)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pi",
    x1: 1506.287,
    x2: 1506.287,
    y1: 327.521,
    y2: -29.544,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#381a94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#381a94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff79b6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 519.414,
    cy: 671.221,
    r: 178.532,
    style: {
      fill: "url(#pi)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pj",
    x1: 1502.304,
    x2: 1502.304,
    y1: 327.685,
    y2: -29.554,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#371a94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#371a94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff79b6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 516.434,
    cy: 673.864,
    r: 178.619,
    style: {
      fill: "url(#pj)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pk",
    x1: 1498.321,
    x2: 1498.321,
    y1: 327.808,
    y2: -29.605,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#371a94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#371a94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff79b7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 513.428,
    cy: 676.477,
    r: 178.706,
    style: {
      fill: "url(#pk)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pl",
    x1: 1494.339,
    x2: 1494.339,
    y1: 327.892,
    y2: -29.695,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#371a94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#371a94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff79b7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 510.396,
    cy: 679.058,
    r: 178.792,
    style: {
      fill: "url(#pl)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pm",
    x1: 1490.358,
    x2: 1490.358,
    y1: 327.935,
    y2: -29.825,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#371a94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#371a94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff79b7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 507.338,
    cy: 681.609,
    r: 178.879,
    style: {
      fill: "url(#pm)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pn",
    x1: 1486.379,
    x2: 1486.379,
    y1: 327.938,
    y2: -29.996,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#371a95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#371a95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff79b7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 504.255,
    cy: 684.129,
    r: 178.966,
    style: {
      fill: "url(#pn)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "po",
    x1: 1482.401,
    x2: 1482.401,
    y1: 327.901,
    y2: -30.206,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#361a95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#361a95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff79b7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 501.148,
    cy: 686.617,
    r: 179.053,
    style: {
      fill: "url(#po)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pp",
    x1: 1478.426,
    x2: 1478.426,
    y1: 327.825,
    y2: -30.456,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#361995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#361a95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff78b7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 498.016,
    cy: 689.074,
    r: 179.14,
    style: {
      fill: "url(#pp)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pq",
    x1: 1474.454,
    x2: 1474.454,
    y1: 327.709,
    y2: -30.746,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#361995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#361a95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff78b7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 494.86,
    cy: 691.5,
    r: 179.227,
    style: {
      fill: "url(#pq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pr",
    x1: 1470.484,
    x2: 1470.484,
    y1: 327.553,
    y2: -31.075,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#361995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#361995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff78b7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 491.68,
    cy: 693.893,
    r: 179.313,
    style: {
      fill: "url(#pr)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ps",
    x1: 1466.518,
    x2: 1466.518,
    y1: 327.358,
    y2: -31.444,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#361995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#361995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff78b7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 488.476,
    cy: 696.255,
    r: 179.4,
    style: {
      fill: "url(#ps)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pt",
    x1: 1462.555,
    x2: 1462.555,
    y1: 327.124,
    y2: -31.852,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#351996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#351996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff78b8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 485.25,
    cy: 698.585,
    r: 179.487,
    style: {
      fill: "url(#pt)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pu",
    x1: 1458.596,
    x2: 1458.596,
    y1: 326.85,
    y2: -32.299,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#351996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#351996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff78b8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 700.882,
    r: 179.574,
    style: {
      fill: "url(#pu)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pv",
    x1: 1454.642,
    x2: 1454.642,
    y1: 326.538,
    y2: -32.785,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#351996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#351996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff78b8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 478.729,
    cy: 703.148,
    r: 179.661,
    style: {
      fill: "url(#pv)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pw",
    x1: 1450.692,
    x2: 1450.692,
    y1: 326.187,
    y2: -33.31,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#351996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#351996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff78b8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 475.435,
    cy: 705.381,
    r: 179.747,
    style: {
      fill: "url(#pw)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "px",
    x1: 1446.748,
    x2: 1446.748,
    y1: 325.796,
    y2: -33.874,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#351996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#351996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff78b8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 472.119,
    cy: 707.581,
    r: 179.834,
    style: {
      fill: "url(#px)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "py",
    x1: 1442.809,
    x2: 1442.809,
    y1: 325.368,
    y2: -34.476,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#341996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#341996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff77b8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 468.782,
    cy: 709.749,
    r: 179.921,
    style: {
      fill: "url(#py)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pz",
    x1: 1438.875,
    x2: 1438.875,
    y1: 324.9,
    y2: -35.117,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#341997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#341997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff77b8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 465.425,
    cy: 711.883,
    r: 180.008,
    style: {
      fill: "url(#pz)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pA",
    x1: 1434.948,
    x2: 1434.948,
    y1: 324.394,
    y2: -35.797,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#341997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#341997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff77b8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 462.046,
    cy: 713.985,
    r: 180.095,
    style: {
      fill: "url(#pA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pB",
    x1: 1431.027,
    x2: 1431.027,
    y1: 323.85,
    y2: -36.514,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#341997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#341997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff77b8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 458.647,
    cy: 716.054,
    r: 180.182,
    style: {
      fill: "url(#pB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pC",
    x1: 1427.113,
    x2: 1427.113,
    y1: 323.268,
    y2: -37.27,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#331997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#331997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff77b9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 455.228,
    cy: 718.089,
    r: 180.268,
    style: {
      fill: "url(#pC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pD",
    x1: 1423.207,
    x2: 1423.207,
    y1: 322.647,
    y2: -38.065,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#331997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#331997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff77b9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 451.789,
    cy: 720.091,
    r: 180.355,
    style: {
      fill: "url(#pD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pE",
    x1: 1419.308,
    x2: 1419.308,
    y1: 321.989,
    y2: -38.897,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#331998"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#331998"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff77b9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 448.331,
    cy: 722.059,
    r: 180.442,
    style: {
      fill: "url(#pE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pF",
    x1: 1415.417,
    x2: 1415.417,
    y1: 321.293,
    y2: -39.766,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#331998"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#331998"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff77b9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 444.854,
    cy: 723.994,
    r: 180.529,
    style: {
      fill: "url(#pF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pG",
    x1: 1411.534,
    x2: 1411.534,
    y1: 320.559,
    y2: -40.674,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#331998"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#331998"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff77b9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 441.359,
    cy: 725.894,
    r: 180.616,
    style: {
      fill: "url(#pG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pH",
    x1: 1407.659,
    x2: 1407.659,
    y1: 319.787,
    y2: -41.619,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#321898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#321998"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff76b9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 437.845,
    cy: 727.761,
    r: 180.702,
    style: {
      fill: "url(#pH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pI",
    x1: 1403.794,
    x2: 1403.794,
    y1: 318.978,
    y2: -42.602,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#321898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#321898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff76b9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 434.313,
    cy: 729.593,
    r: 180.789,
    style: {
      fill: "url(#pI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pJ",
    x1: 1399.938,
    x2: 1399.938,
    y1: 318.131,
    y2: -43.622,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#321898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#321898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff76b9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 430.764,
    cy: 731.391,
    r: 180.876,
    style: {
      fill: "url(#pJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pK",
    x1: 1396.091,
    x2: 1396.091,
    y1: 317.248,
    y2: -44.68,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#321899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#321899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff76b9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 427.197,
    cy: 733.155,
    r: 180.963,
    style: {
      fill: "url(#pK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pL",
    x1: 1392.255,
    x2: 1392.255,
    y1: 316.327,
    y2: -45.774,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#321899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#321899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff76ba"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 423.613,
    cy: 734.884,
    r: 181.05,
    style: {
      fill: "url(#pL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pM",
    x1: 1388.429,
    x2: 1388.429,
    y1: 315.369,
    y2: -46.906,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#311899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff76ba"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 420.013,
    cy: 736.579,
    r: 181.137,
    style: {
      fill: "url(#pM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pN",
    x1: 1384.613,
    x2: 1384.613,
    y1: 314.374,
    y2: -48.074,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#311899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff76ba"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 416.397,
    cy: 738.238,
    r: 181.223,
    style: {
      fill: "url(#pN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pO",
    x1: 1380.809,
    x2: 1380.809,
    y1: 313.342,
    y2: -49.28,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#311899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff76ba"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 412.765,
    cy: 739.863,
    r: 181.31,
    style: {
      fill: "url(#pO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pP",
    x1: 1377.016,
    x2: 1377.016,
    y1: 312.274,
    y2: -50.522,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#311899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff76ba"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 409.117,
    cy: 741.452,
    r: 181.397,
    style: {
      fill: "url(#pP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pQ",
    x1: 1373.235,
    x2: 1373.235,
    y1: 311.169,
    y2: -51.8,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31189a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#31189a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff76ba"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 405.454,
    cy: 743.006,
    r: 181.484,
    style: {
      fill: "url(#pQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pR",
    x1: 1369.466,
    x2: 1369.466,
    y1: 310.027,
    y2: -53.115,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#30189a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#30189a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff75ba"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 401.776,
    cy: 744.525,
    r: 181.571,
    style: {
      fill: "url(#pR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pS",
    x1: 1365.71,
    x2: 1365.71,
    y1: 308.85,
    y2: -54.467,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#30189a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#30189a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff75ba"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 398.084,
    cy: 746.008,
    r: 181.657,
    style: {
      fill: "url(#pS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pT",
    x1: 1361.967,
    x2: 1361.967,
    y1: 307.636,
    y2: -55.854,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#30189a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#30189a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff75ba"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 394.377,
    cy: 747.455,
    r: 181.744,
    style: {
      fill: "url(#pT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pU",
    x1: 1358.236,
    x2: 1358.236,
    y1: 306.386,
    y2: -57.278,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#30189a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#30189a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff75bb"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 390.657,
    cy: 748.866,
    r: 181.831,
    style: {
      fill: "url(#pU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pV",
    x1: 1354.519,
    x2: 1354.519,
    y1: 305.1,
    y2: -58.737,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#30189b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#30189b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff75bb"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 386.923,
    cy: 750.241,
    r: 181.918,
    style: {
      fill: "url(#pV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pW",
    x1: 1350.817,
    x2: 1350.817,
    y1: 303.778,
    y2: -60.233,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2f189b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2f189b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff75bb"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 383.176,
    cy: 751.58,
    r: 182.005,
    style: {
      fill: "url(#pW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pX",
    x1: 1347.128,
    x2: 1347.128,
    y1: 302.421,
    y2: -61.764,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2f189b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2f189b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff75bb"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 379.416,
    cy: 752.883,
    r: 182.091,
    style: {
      fill: "url(#pX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pY",
    x1: 1343.454,
    x2: 1343.454,
    y1: 301.028,
    y2: -63.33,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2f179b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2f189b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff75bb"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 375.644,
    cy: 754.15,
    r: 182.178,
    style: {
      fill: "url(#pY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pZ",
    x1: 1339.795,
    x2: 1339.795,
    y1: 299.599,
    y2: -64.933,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2f179b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2f189b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff75bb"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 371.86,
    cy: 755.379,
    r: 182.265,
    style: {
      fill: "url(#pZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qa",
    x1: 1336.151,
    x2: 1336.151,
    y1: 298.135,
    y2: -66.57,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2e179b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2e179b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff74bb"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 368.064,
    cy: 756.572,
    r: 182.352,
    style: {
      fill: "url(#qa)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qb",
    x1: 1332.523,
    x2: 1332.523,
    y1: 296.636,
    y2: -68.243,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2e179c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2e179c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff74bb"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 364.256,
    cy: 757.728,
    r: 182.439,
    style: {
      fill: "url(#qb)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qc",
    x1: 1328.911,
    x2: 1328.911,
    y1: 295.101,
    y2: -69.951,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2e179c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2e179c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff74bb"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 360.438,
    cy: 758.847,
    r: 182.526,
    style: {
      fill: "url(#qc)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qd",
    x1: 1325.316,
    x2: 1325.316,
    y1: 293.532,
    y2: -71.694,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2e179c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2e179c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff74bc"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 356.608,
    cy: 759.929,
    r: 182.612,
    style: {
      fill: "url(#qd)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qe",
    x1: 1321.737,
    x2: 1321.737,
    y1: 291.928,
    y2: -73.472,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2e179c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2e179c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff74bc"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 352.769,
    cy: 760.974,
    r: 182.699,
    style: {
      fill: "url(#qe)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qf",
    x1: 1318.175,
    x2: 1318.175,
    y1: 290.288,
    y2: -75.285,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d179c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2d179c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff74bc"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 348.919,
    cy: 761.981,
    r: 182.786,
    style: {
      fill: "url(#qf)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qg",
    x1: 1314.631,
    x2: 1314.631,
    y1: 288.615,
    y2: -77.133,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d179c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2d179c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff74bc"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 345.06,
    cy: 762.95,
    r: 182.873,
    style: {
      fill: "url(#qg)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qh",
    x1: 1311.104,
    x2: 1311.104,
    y1: 286.906,
    y2: -79.015,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d179d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2d179d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff74bc"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 341.191,
    cy: 763.882,
    r: 182.96,
    style: {
      fill: "url(#qh)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qi",
    x1: 1307.596,
    x2: 1307.596,
    y1: 285.163,
    y2: -80.931,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d179d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2d179d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff74bc"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 337.313,
    cy: 764.776,
    r: 183.046,
    style: {
      fill: "url(#qi)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qj",
    x1: 1304.106,
    x2: 1304.106,
    y1: 283.386,
    y2: -82.882,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d179d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2d179d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff73bc"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 333.427,
    cy: 765.632,
    r: 183.133,
    style: {
      fill: "url(#qj)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qk",
    x1: 1300.635,
    x2: 1300.635,
    y1: 281.575,
    y2: -84.867,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2c179d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2c179d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff73bc"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 329.532,
    cy: 766.449,
    r: 183.22,
    style: {
      fill: "url(#qk)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ql",
    x1: 1297.183,
    x2: 1297.183,
    y1: 279.729,
    y2: -86.886,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2c179d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2c179d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff73bc"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 325.629,
    cy: 767.228,
    r: 183.307,
    style: {
      fill: "url(#ql)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qm",
    x1: 1293.751,
    x2: 1293.751,
    y1: 277.85,
    y2: -88.939,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2c179e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2c179e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff73bd"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 321.719,
    cy: 767.969,
    r: 183.394,
    style: {
      fill: "url(#qm)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qn",
    x1: 1290.338,
    x2: 1290.338,
    y1: 275.937,
    y2: -91.026,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2c179e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2c179e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff73bd"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 317.801,
    cy: 768.671,
    r: 183.481,
    style: {
      fill: "url(#qn)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qo",
    x1: 1286.946,
    x2: 1286.946,
    y1: 273.99,
    y2: -93.146,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2c179e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2c179e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff73bd"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 313.877,
    cy: 769.335,
    r: 183.567,
    style: {
      fill: "url(#qo)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qp",
    x1: 1283.575,
    x2: 1283.575,
    y1: 272.009,
    y2: -95.3,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2b179e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2b179e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff73bd"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 309.946,
    cy: 769.959,
    r: 183.654,
    style: {
      fill: "url(#qp)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qq",
    x1: 1280.224,
    x2: 1280.224,
    y1: 269.995,
    y2: -97.488,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2b169e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2b179e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff73bd"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 306.008,
    cy: 770.545,
    r: 183.741,
    style: {
      fill: "url(#qq)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qr",
    x1: 1276.895,
    x2: 1276.895,
    y1: 267.948,
    y2: -99.709,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2b169e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2b169e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff73bd"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 302.065,
    cy: 771.091,
    r: 183.828,
    style: {
      fill: "url(#qr)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qs",
    x1: 1273.588,
    x2: 1273.588,
    y1: 265.867,
    y2: -101.964,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2b169f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2b169f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff73bd"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 298.116,
    cy: 771.598,
    r: 183.915,
    style: {
      fill: "url(#qs)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qt",
    x1: 1270.302,
    x2: 1270.302,
    y1: 263.753,
    y2: -104.251,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2b169f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2b169f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff72bd"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 294.162,
    cy: 772.065,
    r: 184.001,
    style: {
      fill: "url(#qt)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qu",
    x1: 1267.039,
    x2: 1267.039,
    y1: 261.606,
    y2: -106.572,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2a169f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2a169f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff72bd"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 290.203,
    cy: 772.493,
    r: 184.088,
    style: {
      fill: "url(#qu)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qv",
    x1: 1263.799,
    x2: 1263.799,
    y1: 259.427,
    y2: -108.925,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2a169f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2a169f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff72be"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 286.239,
    cy: 772.881,
    r: 184.175,
    style: {
      fill: "url(#qv)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qw",
    x1: 1260.582,
    x2: 1260.582,
    y1: 257.214,
    y2: -111.311,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2a169f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2a169f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff72be"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 282.271,
    cy: 773.229,
    r: 184.262,
    style: {
      fill: "url(#qw)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qx",
    x1: 1257.388,
    x2: 1257.388,
    y1: 254.969,
    y2: -113.73,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2a169f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2a169f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff72be"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 278.3,
    cy: 773.537,
    r: 184.349,
    style: {
      fill: "url(#qx)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qy",
    x1: 1254.218,
    x2: 1254.218,
    y1: 252.691,
    y2: -116.181,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2916a0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2916a0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff72be"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 274.324,
    cy: 773.805,
    r: 184.436,
    style: {
      fill: "url(#qy)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qz",
    x1: 1251.072,
    x2: 1251.072,
    y1: 250.381,
    y2: -118.665,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2916a0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2916a0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff72be"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 270.346,
    cy: 774.032,
    r: 184.522,
    style: {
      fill: "url(#qz)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qA",
    x1: 1247.951,
    x2: 1247.951,
    y1: 248.038,
    y2: -121.181,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2916a0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2916a0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff72be"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 266.365,
    cy: 774.219,
    r: 184.609,
    style: {
      fill: "url(#qA)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qB",
    x1: 1244.855,
    x2: 1244.855,
    y1: 245.664,
    y2: -123.73,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2916a0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2916a0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff72be"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 262.381,
    cy: 774.366,
    r: 184.696,
    style: {
      fill: "url(#qB)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qC",
    x1: 1241.784,
    x2: 1241.784,
    y1: 243.257,
    y2: -126.31,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2916a0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2916a0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff71be"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 258.396,
    cy: 774.471,
    r: 184.783,
    style: {
      fill: "url(#qC)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qD",
    x1: 1238.738,
    x2: 1238.738,
    y1: 240.818,
    y2: -128.923,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2816a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2816a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff71bf"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 254.408,
    cy: 774.536,
    r: 184.87,
    style: {
      fill: "url(#qD)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qE",
    x1: 1235.718,
    x2: 1235.718,
    y1: 238.347,
    y2: -131.567,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2816a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2816a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff71bf"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 250.419,
    cy: 774.56,
    r: 184.956,
    style: {
      fill: "url(#qE)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qF",
    x1: 1232.725,
    x2: 1232.725,
    y1: 235.845,
    y2: -134.243,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2816a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2816a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff71bf"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 246.429,
    cy: 774.542,
    r: 185.043,
    style: {
      fill: "url(#qF)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qG",
    x1: 1229.758,
    x2: 1229.758,
    y1: 233.311,
    y2: -136.95,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2816a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2816a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff71bf"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 242.438,
    cy: 774.483,
    r: 185.13,
    style: {
      fill: "url(#qG)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qH",
    x1: 1226.819,
    x2: 1226.819,
    y1: 230.746,
    y2: -139.69,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2816a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2816a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff71bf"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 238.447,
    cy: 774.383,
    r: 185.217,
    style: {
      fill: "url(#qH)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qI",
    x1: 1223.906,
    x2: 1223.906,
    y1: 228.149,
    y2: -142.46,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2715a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2715a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff71bf"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 234.456,
    cy: 774.241,
    r: 185.304,
    style: {
      fill: "url(#qI)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qJ",
    x1: 1221.021,
    x2: 1221.021,
    y1: 225.521,
    y2: -145.262,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2715a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2715a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff71bf"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 230.464,
    cy: 774.057,
    r: 185.39,
    style: {
      fill: "url(#qJ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qK",
    x1: 1218.165,
    x2: 1218.165,
    y1: 222.862,
    y2: -148.095,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2715a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2715a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff71bf"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 226.474,
    cy: 773.831,
    r: 185.477,
    style: {
      fill: "url(#qK)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qL",
    x1: 1215.336,
    x2: 1215.336,
    y1: 220.171,
    y2: -150.958,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2715a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2715a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff70bf"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 222.485,
    cy: 773.563,
    r: 185.564,
    style: {
      fill: "url(#qL)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qM",
    x1: 1212.537,
    x2: 1212.537,
    y1: 217.45,
    y2: -153.853,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2715a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2715a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff70c0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 218.496,
    cy: 773.253,
    r: 185.651,
    style: {
      fill: "url(#qM)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qN",
    x1: 1209.766,
    x2: 1209.766,
    y1: 214.698,
    y2: -156.779,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2615a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2615a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff70c0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 214.51,
    cy: 772.901,
    r: 185.738,
    style: {
      fill: "url(#qN)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qO",
    x1: 1207.025,
    x2: 1207.025,
    y1: 211.916,
    y2: -159.735,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2615a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2615a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff70c0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 210.525,
    cy: 772.506,
    r: 185.825,
    style: {
      fill: "url(#qO)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qP",
    x1: 1204.314,
    x2: 1204.314,
    y1: 209.103,
    y2: -162.722,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2615a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2615a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff70c0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 206.543,
    cy: 772.068,
    r: 185.911,
    style: {
      fill: "url(#qP)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qQ",
    x1: 1201.633,
    x2: 1201.633,
    y1: 206.259,
    y2: -165.739,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2615a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2615a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff70c0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 202.564,
    cy: 771.588,
    r: 185.998,
    style: {
      fill: "url(#qQ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qR",
    x1: 1198.983,
    x2: 1198.983,
    y1: 203.385,
    y2: -168.786,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2615a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2615a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff70c0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 198.587,
    cy: 771.065,
    r: 186.085,
    style: {
      fill: "url(#qR)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qS",
    x1: 1196.363,
    x2: 1196.363,
    y1: 200.481,
    y2: -171.864,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2515a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2515a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff70c0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 194.614,
    cy: 770.498,
    r: 186.172,
    style: {
      fill: "url(#qS)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qT",
    x1: 1193.775,
    x2: 1193.775,
    y1: 197.547,
    y2: -174.972,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2515a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2515a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff70c0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 190.644,
    cy: 769.889,
    r: 186.259,
    style: {
      fill: "url(#qT)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qU",
    x1: 1191.218,
    x2: 1191.218,
    y1: 194.583,
    y2: -178.11,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2515a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2515a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff70c0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 186.679,
    cy: 769.236,
    r: 186.345,
    style: {
      fill: "url(#qU)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qV",
    x1: 1188.693,
    x2: 1188.693,
    y1: 191.589,
    y2: -181.277,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2515a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2515a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6fc1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 182.718,
    cy: 768.539,
    r: 186.432,
    style: {
      fill: "url(#qV)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qW",
    x1: 1186.201,
    x2: 1186.201,
    y1: 188.565,
    y2: -184.475,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2415a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2415a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6fc1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 178.762,
    cy: 767.799,
    r: 186.519,
    style: {
      fill: "url(#qW)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qX",
    x1: 1183.741,
    x2: 1183.741,
    y1: 185.512,
    y2: -187.701,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2415a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2415a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6fc1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 174.811,
    cy: 767.015,
    r: 186.606,
    style: {
      fill: "url(#qX)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qY",
    x1: 1181.314,
    x2: 1181.314,
    y1: 182.429,
    y2: -190.958,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2415a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2415a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6fc1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 170.865,
    cy: 766.187,
    r: 186.693,
    style: {
      fill: "url(#qY)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qZ",
    x1: 1178.92,
    x2: 1178.92,
    y1: 179.317,
    y2: -194.244,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2415a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2415a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6fc1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 166.925,
    cy: 765.315,
    r: 186.78,
    style: {
      fill: "url(#qZ)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ra",
    x1: 1176.561,
    x2: 1176.561,
    y1: 176.176,
    y2: -197.559,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2414a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2414a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6fc1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 162.991,
    cy: 764.399,
    r: 186.866,
    style: {
      fill: "url(#ra)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rb",
    x1: 1174.235,
    x2: 1174.235,
    y1: 173.005,
    y2: -200.903,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2314a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2314a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6fc1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 159.064,
    cy: 763.439,
    r: 186.953,
    style: {
      fill: "url(#rb)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rc",
    x1: 1171.943,
    x2: 1171.943,
    y1: 169.806,
    y2: -204.276,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2314a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2314a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6fc1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 155.143,
    cy: 762.434,
    r: 187.04,
    style: {
      fill: "url(#rc)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rd",
    x1: 1169.687,
    x2: 1169.687,
    y1: 166.577,
    y2: -207.678,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2314a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2314a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6fc1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 151.23,
    cy: 761.384,
    r: 187.127,
    style: {
      fill: "url(#rd)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "re",
    x1: 1167.465,
    x2: 1167.465,
    y1: 163.32,
    y2: -211.109,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2314a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2314a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6ec2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 147.324,
    cy: 760.289,
    r: 187.214,
    style: {
      fill: "url(#re)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rf",
    x1: 1165.279,
    x2: 1165.279,
    y1: 160.034,
    y2: -214.568,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2314a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2314a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6ec2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 143.426,
    cy: 759.15,
    r: 187.3,
    style: {
      fill: "url(#rf)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rg",
    x1: 1163.129,
    x2: 1163.129,
    y1: 156.72,
    y2: -218.056,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2214a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2214a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6ec2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 139.536,
    cy: 757.965,
    r: 187.387,
    style: {
      fill: "url(#rg)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rh",
    x1: 1161.015,
    x2: 1161.015,
    y1: 153.377,
    y2: -221.573,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2214a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2214a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6ec2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 135.654,
    cy: 756.736,
    r: 187.474,
    style: {
      fill: "url(#rh)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ri",
    x1: 1158.938,
    x2: 1158.938,
    y1: 150.006,
    y2: -225.118,
    gradientTransform: "rotate(-41.14 1745.71 1711.049)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#2214a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6ec2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 131.782,
    cy: 755.46,
    r: 187.561,
    style: {
      fill: "url(#ri)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth);
export default __webpack_public_path__ + "static/media/auth.641c0d4e55dfe278025d6a7a06427cf2.svg";
export { ForwardRef as ReactComponent };